(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define('main', ['exports'], factory) :
	(global = global || self, factory(global.main = {}));
}(this, (function (exports) { 'use strict';

	const t = (t, e = 1e4) => (t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e),
	      e = function (t) {
	  if (!(t && t instanceof Element && t.offsetParent)) return !1;
	  const e = t.scrollHeight > t.clientHeight,
	        i = window.getComputedStyle(t).overflowY,
	        n = -1 !== i.indexOf("hidden"),
	        s = -1 !== i.indexOf("visible");
	  return e && !n && !s;
	},
	      i = function (t, n) {
	  return !(!t || t === document.body || n && t === n) && (e(t) ? t : i(t.parentElement, n));
	},
	      n = function (t) {
	  var e = new DOMParser().parseFromString(t, "text/html").body;

	  if (e.childElementCount > 1) {
	    for (var i = document.createElement("div"); e.firstChild;) i.appendChild(e.firstChild);

	    return i;
	  }

	  return e.firstChild;
	},
	      s = t => `${t || ""}`.split(" ").filter(t => !!t),
	      o = (t, e, i) => {
	  s(e).forEach(e => {
	    t && t.classList.toggle(e, i || !1);
	  });
	};

	class a {
	  constructor(t) {
	    Object.defineProperty(this, "pageX", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "pageY", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "clientX", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "clientY", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "id", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "time", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "nativePointer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
	  }

	}

	const r = {
	  passive: !1
	};

	class l {
	  constructor(t, {
	    start: e = () => !0,
	    move: i = () => {},
	    end: n = () => {}
	  }) {
	    Object.defineProperty(this, "element", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "startCallback", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "moveCallback", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "endCallback", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "currentPointers", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), Object.defineProperty(this, "startPointers", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;

	    for (const t of ["onPointerStart", "onTouchStart", "onMove", "onTouchEnd", "onPointerEnd", "onWindowBlur"]) this[t] = this[t].bind(this);

	    this.element.addEventListener("mousedown", this.onPointerStart, r), this.element.addEventListener("touchstart", this.onTouchStart, r), this.element.addEventListener("touchmove", this.onMove, r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
	  }

	  onPointerStart(t) {
	    if (!t.buttons || 0 !== t.button) return;
	    const e = new a(t);
	    this.currentPointers.some(t => t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
	  }

	  onTouchStart(t) {
	    for (const e of Array.from(t.changedTouches || [])) this.triggerPointerStart(new a(e), t);

	    window.addEventListener("blur", this.onWindowBlur);
	  }

	  onMove(t) {
	    const e = this.currentPointers.slice(),
	          i = "changedTouches" in t ? Array.from(t.changedTouches || []).map(t => new a(t)) : [new a(t)],
	          n = [];

	    for (const t of i) {
	      const e = this.currentPointers.findIndex(e => e.id === t.id);
	      e < 0 || (n.push(t), this.currentPointers[e] = t);
	    }

	    n.length && this.moveCallback(t, this.currentPointers.slice(), e);
	  }

	  onPointerEnd(t) {
	    t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
	  }

	  onTouchEnd(t) {
	    for (const e of Array.from(t.changedTouches || [])) this.triggerPointerEnd(t, new a(e));
	  }

	  triggerPointerStart(t, e) {
	    return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
	  }

	  triggerPointerEnd(t, e) {
	    const i = this.currentPointers.findIndex(t => t.id === e.id);
	    i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
	  }

	  onWindowBlur() {
	    this.clear();
	  }

	  clear() {
	    for (; this.currentPointers.length;) {
	      const t = this.currentPointers[this.currentPointers.length - 1];
	      this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
	        bubbles: !0,
	        cancelable: !0,
	        clientX: t.clientX,
	        clientY: t.clientY
	      }), t, this.currentPointers.slice());
	    }
	  }

	  stop() {
	    this.element.removeEventListener("mousedown", this.onPointerStart, r), this.element.removeEventListener("touchstart", this.onTouchStart, r), this.element.removeEventListener("touchmove", this.onMove, r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
	  }

	}

	function c(t, e) {
	  return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
	}

	function h(t, e) {
	  return e ? {
	    clientX: (t.clientX + e.clientX) / 2,
	    clientY: (t.clientY + e.clientY) / 2
	  } : t;
	}

	const d = t => "object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t),
	      u = (t, ...e) => {
	  const i = e.length;

	  for (let n = 0; n < i; n++) {
	    const i = e[n] || {};
	    Object.entries(i).forEach(([e, i]) => {
	      const n = Array.isArray(i) ? [] : {};
	      t[e] || Object.assign(t, {
	        [e]: n
	      }), d(i) ? Object.assign(t[e], u(n, i)) : Array.isArray(i) ? Object.assign(t, {
	        [e]: [...i]
	      }) : Object.assign(t, {
	        [e]: i
	      });
	    });
	  }

	  return t;
	},
	      p = function (t, e) {
	  return t.split(".").reduce((t, e) => "object" == typeof t ? t[e] : void 0, e);
	};

	class f {
	  constructor(t = {}) {
	    Object.defineProperty(this, "options", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: t
	    }), Object.defineProperty(this, "events", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: new Map()
	    }), this.setOptions(t);

	    for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
	  }

	  setOptions(t) {
	    this.options = t ? u({}, this.constructor.defaults, t) : {};

	    for (const [t, e] of Object.entries(this.option("on") || {})) this.on(t, e);
	  }

	  option(t, ...e) {
	    let i = p(t, this.options);
	    return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
	  }

	  optionFor(t, e, i, ...n) {
	    let s = p(e, t);
	    var o;
	    "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
	    let a = p(e, this.options);
	    return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
	  }

	  cn(t) {
	    const e = this.options.classes;
	    return e && e[t] || "";
	  }

	  localize(t, e = []) {
	    t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i) => {
	      let n = "";
	      return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
	    });

	    for (let i = 0; i < e.length; i++) t = t.split(e[i][0]).join(e[i][1]);

	    return t = t.replace(/\{\{(.*?)\}\}/g, (t, e) => e);
	  }

	  on(t, e) {
	    let i = [];
	    "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map()), i.forEach(t => {
	      let i = this.events.get(t);
	      i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
	    });
	  }

	  off(t, e) {
	    let i = [];
	    "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach(t => {
	      const i = this.events.get(t);

	      if (Array.isArray(i)) {
	        const t = i.indexOf(e);
	        t > -1 && i.splice(t, 1);
	      }
	    });
	  }

	  emit(t, ...e) {
	    [...(this.events.get(t) || [])].forEach(t => t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
	  }

	}

	Object.defineProperty(f, "version", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: "5.0.15"
	}), Object.defineProperty(f, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {}
	});

	class m extends f {
	  constructor(t = {}) {
	    super(t), Object.defineProperty(this, "plugins", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {}
	    });
	  }

	  attachPlugins(t = {}) {
	    const e = new Map();

	    for (const [i, n] of Object.entries(t)) {
	      const t = this.option(i),
	            s = this.plugins[i];
	      s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
	    }

	    for (const [t, i] of e) this.plugins[t] = i, i.attach();

	    this.emit("attachPlugins");
	  }

	  detachPlugins(t) {
	    t = t || Object.keys(this.plugins);

	    for (const e of t) {
	      const t = this.plugins[e];
	      t && t.detach(), delete this.plugins[e];
	    }

	    return this.emit("detachPlugins"), this;
	  }

	}

	var g;
	!function (t) {
	  t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
	}(g || (g = {}));

	const b = ["a", "b", "c", "d", "e", "f"],
	      v = {
	  PANUP: "Move up",
	  PANDOWN: "Move down",
	  PANLEFT: "Move left",
	  PANRIGHT: "Move right",
	  ZOOMIN: "Zoom in",
	  ZOOMOUT: "Zoom out",
	  TOGGLEZOOM: "Toggle zoom level",
	  TOGGLE1TO1: "Toggle zoom level",
	  ITERATEZOOM: "Toggle zoom level",
	  ROTATECCW: "Rotate counterclockwise",
	  ROTATECW: "Rotate clockwise",
	  FLIPX: "Flip horizontally",
	  FLIPY: "Flip vertically",
	  FITX: "Fit horizontally",
	  FITY: "Fit vertically",
	  RESET: "Reset",
	  TOGGLEFS: "Toggle fullscreen"
	},
	      y = {
	  content: null,
	  width: "auto",
	  height: "auto",
	  panMode: "drag",
	  touch: !0,
	  dragMinThreshold: 3,
	  lockAxis: !1,
	  mouseMoveFactor: 1,
	  mouseMoveFriction: .12,
	  zoom: !0,
	  pinchToZoom: !0,
	  panOnlyZoomed: "auto",
	  minScale: 1,
	  maxScale: 2,
	  friction: .25,
	  dragFriction: .35,
	  decelFriction: .05,
	  click: "toggleZoom",
	  dblClick: !1,
	  wheel: "zoom",
	  wheelLimit: 7,
	  spinner: !0,
	  bounds: "auto",
	  infinite: !1,
	  rubberband: !0,
	  bounce: !0,
	  maxVelocity: 75,
	  transformParent: !1,
	  classes: {
	    content: "f-panzoom__content",
	    isLoading: "is-loading",
	    canZoomIn: "can-zoom_in",
	    canZoomOut: "can-zoom_out",
	    isDraggable: "is-draggable",
	    isDragging: "is-dragging",
	    inFullscreen: "in-fullscreen",
	    htmlHasFullscreen: "with-panzoom-in-fullscreen"
	  },
	  l10n: v
	},
	      w = '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>',
	      x = t => t && null !== t && t instanceof Element && "nodeType" in t,
	      E = (t, e) => {
	  t && s(e).forEach(e => {
	    t.classList.remove(e);
	  });
	},
	      S = (t, e) => {
	  t && s(e).forEach(e => {
	    t.classList.add(e);
	  });
	},
	      P = {
	  a: 1,
	  b: 0,
	  c: 0,
	  d: 1,
	  e: 0,
	  f: 0
	};

	let C = null,
	    M = null;

	class T extends m {
	  get isTouchDevice() {
	    return null === M && (M = window.matchMedia("(hover: none)").matches), M;
	  }

	  get isMobile() {
	    return null === C && (C = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), C;
	  }

	  get panMode() {
	    return "mousemove" !== this.options.panMode || this.isTouchDevice ? "drag" : "mousemove";
	  }

	  get panOnlyZoomed() {
	    const t = this.options.panOnlyZoomed;
	    return "auto" === t ? this.isTouchDevice : t;
	  }

	  get isInfinite() {
	    return this.option("infinite");
	  }

	  get angle() {
	    return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
	  }

	  get targetAngle() {
	    return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
	  }

	  get scale() {
	    const {
	      a: t,
	      b: e
	    } = this.current;
	    return Math.sqrt(t * t + e * e) || 1;
	  }

	  get targetScale() {
	    const {
	      a: t,
	      b: e
	    } = this.target;
	    return Math.sqrt(t * t + e * e) || 1;
	  }

	  get minScale() {
	    return this.option("minScale") || 1;
	  }

	  get fullScale() {
	    const {
	      contentRect: t
	    } = this;
	    return t.fullWidth / t.fitWidth || 1;
	  }

	  get maxScale() {
	    return this.fullScale * (this.option("maxScale") || 1) || 1;
	  }

	  get coverScale() {
	    const {
	      containerRect: t,
	      contentRect: e
	    } = this,
	          i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
	    return Math.min(this.fullScale, i);
	  }

	  get isScaling() {
	    return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
	  }

	  get isContentLoading() {
	    const t = this.content;
	    return !!(t && t instanceof HTMLImageElement) && !t.complete;
	  }

	  get isResting() {
	    if (this.isBouncingX || this.isBouncingY) return !1;

	    for (const t of b) {
	      const e = "e" == t || "f" === t ? .001 : 1e-5;
	      if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
	    }

	    return !(!this.ignoreBounds && !this.checkBounds().inBounds);
	  }

	  constructor(t, e = {}, i = {}) {
	    var s;
	    if (super(e), Object.defineProperty(this, "pointerTracker", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "resizeObserver", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "updateTimer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "clickTimer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "rAF", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "isTicking", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "friction", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "ignoreBounds", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "isBouncingX", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "isBouncingY", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "clicks", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "trackingPoints", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), Object.defineProperty(this, "pwt", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "cwd", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "pmme", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: g.Init
	    }), Object.defineProperty(this, "isDragging", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "content", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "spinner", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "containerRect", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {
	        width: 0,
	        height: 0,
	        innerWidth: 0,
	        innerHeight: 0
	      }
	    }), Object.defineProperty(this, "contentRect", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0,
	        fullWidth: 0,
	        fullHeight: 0,
	        fitWidth: 0,
	        fitHeight: 0,
	        width: 0,
	        height: 0
	      }
	    }), Object.defineProperty(this, "dragStart", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {
	        x: 0,
	        y: 0,
	        top: 0,
	        left: 0,
	        time: 0
	      }
	    }), Object.defineProperty(this, "dragOffset", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {
	        x: 0,
	        y: 0,
	        time: 0
	      }
	    }), Object.defineProperty(this, "current", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: Object.assign({}, P)
	    }), Object.defineProperty(this, "target", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: Object.assign({}, P)
	    }), Object.defineProperty(this, "velocity", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {
	        a: 0,
	        b: 0,
	        c: 0,
	        d: 0,
	        e: 0,
	        f: 0
	      }
	    }), Object.defineProperty(this, "lockedAxis", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), !t) throw new Error("Container Element Not Found");
	    this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, T.Plugins), i)), this.emit("init");
	    const o = this.content;

	    if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
	      if (this.option("spinner")) {
	        t.classList.add(this.cn("isLoading"));
	        const e = n(w);
	        !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
	      }

	      this.emit("beforeLoad");
	    } else queueMicrotask(() => {
	      this.enable();
	    });
	  }

	  initContent() {
	    const {
	      container: t
	    } = this,
	          e = this.cn("content");
	    let i = this.option("content") || t.querySelector(`.${e}`);
	    if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && S(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
	    this.content = i;
	  }

	  onLoad() {
	    this.spinner && (this.spinner.remove(), this.spinner = null), this.option("spinner") && this.container.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), this.state === g.Init ? this.enable() : this.updateMetrics();
	  }

	  onError() {
	    this.state !== g.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = g.Error, this.emit("error"));
	  }

	  attachObserver() {
	    var t;

	    const e = () => Math.abs(this.containerRect.width - this.container.getBoundingClientRect().width) > .1 || Math.abs(this.containerRect.height - this.container.getBoundingClientRect().height) > .1;

	    this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(() => {
	      this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(() => {
	        e() && this.onResize(), this.updateTimer = null;
	      }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
	    })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
	  }

	  detachObserver() {
	    var t;
	    null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
	  }

	  attachEvents() {
	    const {
	      container: t
	    } = this;
	    t.addEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), t.addEventListener("wheel", this.onWheel, {
	      passive: !1
	    }), this.pointerTracker = new l(t, {
	      start: this.onPointerDown,
	      move: this.onPointerMove,
	      end: this.onPointerUp
	    }), document.addEventListener("mousemove", this.onMouseMove);
	  }

	  detachEvents() {
	    var t;
	    const {
	      container: e
	    } = this;
	    e.removeEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), e.removeEventListener("wheel", this.onWheel, {
	      passive: !1
	    }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener("mousemove", this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
	  }

	  animate() {
	    const t = this.friction;
	    this.setTargetForce();
	    const e = this.option("maxVelocity");

	    for (const i of b) t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];

	    this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(() => this.animate()) : this.stop("current");
	  }

	  setTargetForce() {
	    for (const t of b) "e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
	  }

	  checkBounds(t = 0, e = 0) {
	    const {
	      current: i
	    } = this,
	          n = i.e + t,
	          s = i.f + e,
	          o = this.getBounds(),
	          {
	      x: a,
	      y: r
	    } = o,
	          l = a.min,
	          c = a.max,
	          h = r.min,
	          d = r.max;
	    let u = 0,
	        p = 0;
	    return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < .001 && (u = 0), Math.abs(p) < .001 && (p = 0), Object.assign(Object.assign({}, o), {
	      xDiff: u,
	      yDiff: p,
	      inBounds: !u && !p
	    });
	  }

	  clampTargetBounds() {
	    const {
	      target: t
	    } = this,
	          {
	      x: e,
	      y: i
	    } = this.getBounds();
	    e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
	  }

	  calculateContentDim(t = this.current) {
	    const {
	      content: e,
	      contentRect: i
	    } = this,
	          {
	      fitWidth: n,
	      fitHeight: s,
	      fullWidth: o,
	      fullHeight: a
	    } = i;
	    let r = o,
	        l = a;

	    if (this.option("zoom") || 0 !== this.angle) {
	      const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight),
	            c = i ? o : n,
	            h = i ? a : s,
	            d = this.getMatrix(t),
	            u = new DOMPoint(0, 0).matrixTransform(d),
	            p = new DOMPoint(0 + c, 0).matrixTransform(d),
	            f = new DOMPoint(0 + c, 0 + h).matrixTransform(d),
	            m = new DOMPoint(0, 0 + h).matrixTransform(d),
	            g = Math.abs(f.x - u.x),
	            b = Math.abs(f.y - u.y),
	            v = Math.abs(m.x - p.x),
	            y = Math.abs(m.y - p.y);
	      r = Math.max(g, v), l = Math.max(b, y);
	    }

	    return {
	      contentWidth: r,
	      contentHeight: l
	    };
	  }

	  setEdgeForce() {
	    if (this.ignoreBounds || this.isDragging || "mousemove" === this.panMode || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
	    const {
	      target: t
	    } = this,
	          {
	      x: e,
	      y: i,
	      xDiff: n,
	      yDiff: s
	    } = this.checkBounds();
	    const o = this.option("maxVelocity");
	    let a = this.velocity.e,
	        r = this.velocity.f;
	    0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
	  }

	  enable() {
	    const {
	      content: t
	    } = this,
	          e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);

	    for (const t of b) this.current[t] = this.target[t] = e[t];

	    this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = g.Ready, this.emit("ready");
	  }

	  onClick(t) {
	    var e;
	    this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
	    const i = t.target;
	    if (!i || t.defaultPrevented) return;
	    if (i && i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
	    if ((() => {
	      const t = window.getSelection();
	      return t && "Range" === t.type;
	    })() && !i.closest("button")) return;
	    const n = i.closest("[data-panzoom-action]"),
	          s = i.closest("[data-panzoom-change]"),
	          o = n || s,
	          a = o && x(o) ? o.dataset : null;

	    if (a) {
	      const e = a.panzoomChange,
	            i = a.panzoomAction;

	      if ((e || i) && t.preventDefault(), e) {
	        let t = {};

	        try {
	          t = JSON.parse(e);
	        } catch (t) {
	          console && console.warn("The given data was not valid JSON");
	        }

	        return void this.applyChange(t);
	      }

	      if (i) return void (this[i] && this[i]());
	    }

	    if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
	    const r = this.content.getBoundingClientRect();
	    if (this.dragStart.time && !this.canZoomOut() && (Math.abs(r.x - this.dragStart.x) > 2 || Math.abs(r.y - this.dragStart.y) > 2)) return;
	    this.dragStart.time = 0;

	    const l = e => {
	      this.option("zoom") && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
	        event: t
	      }));
	    },
	          c = this.option("click", t),
	          h = this.option("dblClick", t);

	    h ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(() => {
	      1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && c && l(c)) : (this.emit("dblClick", t), t.defaultPrevented || l(h)), this.clicks = 0, this.clickTimer = null;
	    }, 350))) : (this.emit("click", t), !t.defaultPrevented && c && l(c));
	  }

	  addTrackingPoint(t) {
	    const e = this.trackingPoints.filter(t => t.time > Date.now() - 100);
	    e.push(t), this.trackingPoints = e;
	  }

	  onPointerDown(t, e, i) {
	    var n;
	    this.pwt = 0, this.dragOffset = {
	      x: 0,
	      y: 0,
	      time: 0
	    }, this.trackingPoints = [];
	    const s = this.content.getBoundingClientRect();
	    if (this.dragStart = {
	      x: s.x,
	      y: s.y,
	      top: s.top,
	      left: s.left,
	      time: Date.now()
	    }, this.clickTimer) return !1;
	    if ("mousemove" === this.panMode && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;

	    if (!i.length) {
	      const e = t.composedPath()[0];
	      if (["A", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].includes(e.nodeName) || e.closest("[contenteditable]") || e.closest("[data-selectable]") || e.closest("[data-panzoom-change]") || e.closest("[data-panzoom-action]")) return !1;
	      null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
	    }

	    if ("mousedown" === t.type) t.preventDefault();else if (Math.abs(this.velocity.a) > .3) return !1;
	    return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
	  }

	  onPointerMove(e, n, s) {
	    if (!1 === this.option("touch", e)) return;
	    if (!this.isDragging) return;
	    if (n.length < 2 && this.panOnlyZoomed && t(this.targetScale) <= t(this.minScale)) return;
	    if (this.emit("touchMove", e), e.defaultPrevented) return;
	    this.addTrackingPoint(n[0]);
	    const {
	      content: o
	    } = this,
	          a = h(s[0], s[1]),
	          r = h(n[0], n[1]);
	    let l = 0,
	        d = 0;

	    if (n.length > 1) {
	      const t = o.getBoundingClientRect();
	      l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
	    }

	    const u = c(s[0], s[1]),
	          p = c(n[0], n[1]);
	    let f = u ? p / u : 1,
	        m = r.clientX - a.clientX,
	        g = r.clientY - a.clientY;
	    this.dragOffset.x += m, this.dragOffset.y += g, this.dragOffset.time = Date.now() - this.dragStart.time;
	    let b = t(this.targetScale) === t(this.minScale) && this.option("lockAxis");
	    if (b && !this.lockedAxis) if ("xy" === b || "y" === b || "touchmove" === e.type) {
	      if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
	      const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
	      this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, m = 0, g = 0;
	    } else this.lockedAxis = b;
	    if (i(e.target, this.content) && (b = "x", this.dragOffset.y = 0), b && "xy" !== b && this.lockedAxis !== b && t(this.targetScale) === t(this.minScale)) return;
	    e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
	    const v = this.checkBounds(m, g);
	    this.option("rubberband") ? ("x" !== this.isInfinite && (v.xDiff > 0 && m < 0 || v.xDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * v.xDiff))), "y" !== this.isInfinite && (v.yDiff > 0 && g < 0 || v.yDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * v.yDiff)))) : (v.xDiff && (m = 0), v.yDiff && (g = 0));
	    const y = this.targetScale,
	          w = this.minScale,
	          x = this.maxScale;
	    y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && t(y) === t(w) && (m = 0), "x" === this.lockedAxis && t(y) === t(w) && (g = 0), this.applyChange({
	      originX: l,
	      originY: d,
	      panX: m,
	      panY: g,
	      scale: f,
	      friction: this.option("dragFriction"),
	      ignoreBounds: !0
	    });
	  }

	  onPointerUp(t, e, n) {
	    if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
	    this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== g.Destroy && (t.defaultPrevented || this.startDecelAnim()));
	  }

	  startDecelAnim() {
	    const e = this.isScaling;
	    this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;

	    for (const t of b) this.velocity[t] = 0;

	    this.target.e = this.current.e, this.target.f = this.current.f, E(this.container, "is-scaling"), E(this.container, "is-animating"), this.isTicking = !1;
	    const {
	      trackingPoints: i
	    } = this,
	          n = i[0],
	          s = i[i.length - 1];
	    let o = 0,
	        a = 0,
	        r = 0;
	    s && n && (o = s.clientX - n.clientX, a = s.clientY - n.clientY, r = s.time - n.time);
	    let l = 0,
	        c = 0,
	        h = 0,
	        d = 0,
	        u = this.option("decelFriction");
	    const p = this.targetScale;

	    if (r > 0) {
	      h = Math.abs(o) > 3 ? o / (r / 30) : 0, d = Math.abs(a) > 3 ? a / (r / 30) : 0;
	      const t = this.option("maxVelocity");
	      t && (h = Math.max(Math.min(h, t), -1 * t), d = Math.max(Math.min(d, t), -1 * t));
	    }

	    h && (l = h / (1 / (1 - u) - 1)), d && (c = d / (1 / (1 - u) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && t(p) === this.minScale) && (l = h = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && t(p) === this.minScale) && (c = d = 0);
	    const f = this.dragOffset.x,
	          m = this.dragOffset.y,
	          g = this.option("dragMinThreshold") || 0;
	    Math.abs(f) < g && Math.abs(m) < g && (l = c = 0, h = d = 0), (p < this.minScale - 1e-5 || p > this.maxScale + 1e-5 || e && !l && !c) && (u = .35), this.applyChange({
	      panX: l,
	      panY: c,
	      friction: u
	    }), this.emit("decel", h, d, f, m);
	  }

	  onWheel(t) {
	    var e = [-t.deltaX || 0, -t.deltaY || 0, -t.detail || 0].reduce(function (t, e) {
	      return Math.abs(e) > Math.abs(t) ? e : t;
	    });
	    const i = Math.max(-1, Math.min(1, e));
	    if (this.emit("wheel", t, i), "mousemove" === this.panMode) return;
	    if (t.defaultPrevented) return;
	    const n = this.option("wheel");
	    "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
	      panX: 2 * -t.deltaX,
	      panY: 2 * -t.deltaY,
	      bounce: !1
	    })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
	  }

	  onMouseMove(t) {
	    this.panWithMouse(t);
	  }

	  onKeydown(t) {
	    "Escape" === t.key && this.toggleFS();
	  }

	  onResize() {
	    this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
	  }

	  setTransform() {
	    this.emit("beforeTransform");
	    const {
	      current: e,
	      target: i,
	      content: n,
	      contentRect: s
	    } = this,
	          o = Object.assign({}, P);

	    for (const n of b) {
	      const s = "e" == n || "f" === n ? 1e3 : 1e5;
	      o[n] = t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
	    }

	    let {
	      a: a,
	      b: r,
	      c: l,
	      d: c,
	      e: h,
	      f: d
	    } = o,
	        u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`,
	        p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
	    if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
	    p.style.transform = u;
	    const {
	      contentWidth: f,
	      contentHeight: m
	    } = this.calculateContentDim();
	    s.width = f, s.height = m, this.emit("afterTransform");
	  }

	  updateMetrics(e = !1) {
	    if (!this || this.state === g.Destroy) return;
	    if (this.isContentLoading) return;
	    const {
	      container: i,
	      content: n
	    } = this,
	          s = n instanceof HTMLImageElement,
	          o = i.getBoundingClientRect(),
	          a = getComputedStyle(this.container),
	          r = o.width,
	          l = o.height,
	          c = parseFloat(a.paddingTop) + parseFloat(a.paddingBottom),
	          h = r - (parseFloat(a.paddingLeft) + parseFloat(a.paddingRight)),
	          d = l - c;
	    this.containerRect = {
	      width: r,
	      height: l,
	      innerWidth: h,
	      innerHeight: d
	    };
	    let u = this.option("width") || "auto",
	        p = this.option("height") || "auto";
	    "auto" === u && (u = parseFloat(n.dataset.width || "") || (t => {
	      let e = 0;
	      return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
	    })(n)), "auto" === p && (p = parseFloat(n.dataset.height || "") || (t => {
	      let e = 0;
	      return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
	    })(n));
	    let f = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
	    this.option("transformParent") && (f = f.parentElement || f);
	    const m = f.getAttribute("style") || "";
	    f.style.setProperty("transform", "none", "important"), s && (f.style.width = "", f.style.height = ""), f.offsetHeight;
	    const b = n.getBoundingClientRect();
	    let v = b.width,
	        y = b.height,
	        w = 0,
	        x = 0;
	    s && (Math.abs(u - v) > 1 || Math.abs(p - y) > 1) && ({
	      width: v,
	      height: y,
	      top: w,
	      left: x
	    } = ((t, e, i, n) => {
	      const s = i / n;
	      return s > t / e ? (i = t, n = t / s) : (i = e * s, n = e), {
	        width: i,
	        height: n,
	        top: .5 * (e - n),
	        left: .5 * (t - i)
	      };
	    })(v, y, u, p)), this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
	      top: b.top - o.top + w,
	      bottom: o.bottom - b.bottom + w,
	      left: b.left - o.left + x,
	      right: o.right - b.right + x,
	      fitWidth: v,
	      fitHeight: y,
	      width: v,
	      height: y,
	      fullWidth: u,
	      fullHeight: p
	    }), f.style.cssText = m, s && (f.style.width = `${v}px`, f.style.height = `${y}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || (t(this.targetScale) < t(this.minScale) ? this.zoomTo(this.minScale, {
	      friction: 0
	    }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
	      friction: 0
	    }) : this.state === g.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
	  }

	  getBounds() {
	    const e = this.option("bounds");
	    if ("auto" !== e) return e;
	    const {
	      contentWidth: i,
	      contentHeight: n
	    } = this.calculateContentDim(this.target);
	    let s = 0,
	        o = 0,
	        a = 0,
	        r = 0;
	    const l = this.option("infinite");
	    if (!0 === l || this.lockedAxis && l === this.lockedAxis) s = -1 / 0, a = 1 / 0, o = -1 / 0, r = 1 / 0;else {
	      let {
	        containerRect: e,
	        contentRect: l
	      } = this,
	          c = t(this.contentRect.fitWidth * this.targetScale, 1e3),
	          h = t(this.contentRect.fitHeight * this.targetScale, 1e3),
	          {
	        innerWidth: d,
	        innerHeight: u
	      } = e;

	      if (this.containerRect.width === c && (d = e.width), this.containerRect.width === h && (u = e.height), i > d) {
	        a = .5 * (i - d), s = -1 * a;
	        let t = .5 * (l.right - l.left);
	        s += t, a += t;
	      }

	      if (this.contentRect.fitWidth > d && i < d && (s -= .5 * (this.contentRect.fitWidth - d), a -= .5 * (this.contentRect.fitWidth - d)), n > u) {
	        r = .5 * (n - u), o = -1 * r;
	        let t = .5 * (l.bottom - l.top);
	        o += t, r += t;
	      }

	      this.contentRect.fitHeight > u && n < u && (s -= .5 * (this.contentRect.fitHeight - u), a -= .5 * (this.contentRect.fitHeight - u));
	    }
	    return {
	      x: {
	        min: s,
	        max: a
	      },
	      y: {
	        min: o,
	        max: r
	      }
	    };
	  }

	  updateControls() {
	    const e = this,
	          i = e.container,
	          {
	      panMode: n,
	      contentRect: s,
	      fullScale: a,
	      targetScale: r,
	      coverScale: l,
	      maxScale: c,
	      minScale: h
	    } = e;
	    let d = {
	      toggleMax: r - h < .5 * (c - h) ? c : h,
	      toggleCover: r - h < .5 * (l - h) ? l : h,
	      toggleZoom: r - h < .5 * (a - h) ? a : h
	    }[e.option("click") || ""] || h,
	        u = e.canZoomIn(),
	        p = e.canZoomOut(),
	        f = p && "drag" === n;
	    t(r) < t(h) && !this.panOnlyZoomed && (f = !0), (t(s.width, 1) > t(s.fitWidth, 1) || t(s.height, 1) > t(s.fitHeight, 1)) && (f = !0), t(s.width * r, 1) < t(s.fitWidth, 1) && (f = !1), "mousemove" === n && (f = !1);
	    let m = u && t(d) > t(r),
	        g = !m && !f && p && t(d) < t(r);
	    o(i, this.cn("canZoomIn"), m), o(i, this.cn("canZoomOut"), g), o(i, this.cn("isDraggable"), f);

	    for (const t of i.querySelectorAll('[data-panzoom-action="zoomIn"]')) u ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));

	    for (const t of i.querySelectorAll('[data-panzoom-action="zoomOut"]')) p ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));

	    for (const t of i.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
	      u || p ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
	      const e = t.querySelector("g");
	      e && (e.style.display = u ? "" : "none");
	    }
	  }

	  panTo({
	    x: t = this.target.e,
	    y: e = this.target.f,
	    scale: i = this.targetScale,
	    friction: n = this.option("friction"),
	    angle: s = 0,
	    originX: o = 0,
	    originY: a = 0,
	    flipX: r = !1,
	    flipY: l = !1,
	    ignoreBounds: c = !1
	  }) {
	    this.state !== g.Destroy && this.applyChange({
	      panX: t - this.target.e,
	      panY: e - this.target.f,
	      scale: i / this.targetScale,
	      angle: s,
	      originX: o,
	      originY: a,
	      friction: n,
	      flipX: r,
	      flipY: l,
	      ignoreBounds: c
	    });
	  }

	  applyChange({
	    panX: e = 0,
	    panY: i = 0,
	    scale: n = 1,
	    angle: s = 0,
	    originX: o = -this.current.e,
	    originY: a = -this.current.f,
	    friction: r = this.option("friction"),
	    flipX: l = !1,
	    flipY: c = !1,
	    ignoreBounds: h = !1,
	    bounce: d = this.option("bounce")
	  }) {
	    if (this.state === g.Destroy) return;
	    this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
	    const {
	      current: u
	    } = this,
	          p = u.e,
	          f = u.f,
	          m = this.getMatrix(this.target);
	    let v = new DOMMatrix().translate(p, f).translate(o, a).translate(e, i);

	    if (this.option("zoom")) {
	      if (!h) {
	        const t = this.targetScale,
	              e = this.minScale,
	              i = this.maxScale;
	        t * n < e && (n = e / t), t * n > i && (n = i / t);
	      }

	      v = v.scale(n);
	    }

	    v = v.translate(-o, -a).translate(-p, -f).multiply(m), s && (v = v.rotate(s)), l && (v = v.scale(-1, 1)), c && (v = v.scale(1, -1));

	    for (const e of b) "e" !== e && "f" !== e && (v[e] > this.minScale + 1e-5 || v[e] < this.minScale - 1e-5) ? this.target[e] = v[e] : this.target[e] = t(v[e], 1e3);

	    (this.targetScale < this.scale || Math.abs(n - 1) > .1 || "mousemove" === this.panMode || !1 === d) && !h && this.clampTargetBounds(), this.isResting || (this.state = g.Panning, this.requestTick());
	  }

	  stop(t = !1) {
	    if (this.state === g.Init || this.state === g.Destroy) return;
	    const e = this.isTicking;
	    this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;

	    for (const e of b) this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);

	    this.setTransform(), E(this.container, "is-scaling"), E(this.container, "is-animating"), this.isTicking = !1, this.state = g.Ready, e && (this.emit("endAnimation"), this.updateControls());
	  }

	  requestTick() {
	    this.isTicking || (this.emit("startAnimation"), this.updateControls(), S(this.container, "is-animating"), this.isScaling && S(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(() => this.animate()));
	  }

	  panWithMouse(e, i = this.option("mouseMoveFriction")) {
	    if (this.pmme = e, "mousemove" !== this.panMode || !e) return;
	    if (t(this.targetScale) <= t(this.minScale)) return;
	    this.emit("mouseMove", e);
	    const {
	      container: n,
	      containerRect: s,
	      contentRect: o
	    } = this,
	          a = s.width,
	          r = s.height,
	          l = n.getBoundingClientRect(),
	          c = (e.clientX || 0) - l.left,
	          h = (e.clientY || 0) - l.top;
	    let {
	      contentWidth: d,
	      contentHeight: u
	    } = this.calculateContentDim(this.target);
	    const p = this.option("mouseMoveFactor");
	    p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
	    let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
	    f += .5 * (o.right - o.left);
	    let m = .5 * (u - r) - h / r * 100 / 100 * (u - r);
	    m += .5 * (o.bottom - o.top), this.applyChange({
	      panX: f - this.target.e,
	      panY: m - this.target.f,
	      friction: i
	    });
	  }

	  zoomWithWheel(e) {
	    if (this.state === g.Destroy || this.state === g.Init) return;
	    const i = Date.now();
	    if (i - this.pwt < 45) return void e.preventDefault();
	    this.pwt = i;
	    var n = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (t, e) {
	      return Math.abs(e) > Math.abs(t) ? e : t;
	    });
	    const s = Math.max(-1, Math.min(1, n)),
	          {
	      targetScale: o,
	      maxScale: a,
	      minScale: r
	    } = this;
	    let l = o * (100 + 45 * s) / 100;
	    t(l) < t(r) && t(o) <= t(r) ? (this.cwd += Math.abs(s), l = r) : t(l) > t(a) && t(o) >= t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), t(l) !== t(o) && this.zoomTo(l, {
	      event: e
	    }));
	  }

	  canZoomIn() {
	    return this.option("zoom") && (t(this.contentRect.width, 1) < t(this.contentRect.fitWidth, 1) || t(this.targetScale) < t(this.maxScale));
	  }

	  canZoomOut() {
	    return this.option("zoom") && t(this.targetScale) > t(this.minScale);
	  }

	  zoomIn(t = 1.25, e) {
	    this.zoomTo(this.targetScale * t, e);
	  }

	  zoomOut(t = .8, e) {
	    this.zoomTo(this.targetScale * t, e);
	  }

	  zoomToFit(t) {
	    this.zoomTo("fit", t);
	  }

	  zoomToCover(t) {
	    this.zoomTo("cover", t);
	  }

	  zoomToFull(t) {
	    this.zoomTo("full", t);
	  }

	  zoomToMax(t) {
	    this.zoomTo("max", t);
	  }

	  toggleZoom(t) {
	    this.zoomTo(this.targetScale - this.minScale < .5 * (this.fullScale - this.minScale) ? "full" : "fit", t);
	  }

	  toggleMax(t) {
	    this.zoomTo(this.targetScale - this.minScale < .5 * (this.maxScale - this.minScale) ? "max" : "fit", t);
	  }

	  toggleCover(t) {
	    this.zoomTo(this.targetScale - this.minScale < .5 * (this.coverScale - this.minScale) ? "cover" : "fit", t);
	  }

	  iterateZoom(t) {
	    this.zoomTo("next", t);
	  }

	  zoomTo(t = 1, {
	    friction: e = "auto",
	    originX: i = 0,
	    originY: n = 0,
	    event: s
	  } = {}) {
	    if (this.isContentLoading || this.state === g.Destroy) return;
	    const {
	      targetScale: o
	    } = this;
	    this.stop();
	    let a = 1;

	    if ("mousemove" === this.panMode && (s = this.pmme || s), s) {
	      const t = this.content.getBoundingClientRect(),
	            e = s.clientX || 0,
	            o = s.clientY || 0;
	      i = e - t.left - .5 * t.width, n = o - t.top - .5 * t.height;
	    }

	    const r = this.fullScale,
	          l = this.maxScale;
	    let c = this.coverScale;
	    "number" == typeof t ? a = t / o : ("next" === t && (r - c < .2 && (c = r), t = o < r - 1e-5 ? "full" : o < l - 1e-5 ? "max" : "fit"), a = "full" === t ? r / o || 1 : "cover" === t ? c / o || 1 : "max" === t ? l / o || 1 : 1 / o || 1), e = "auto" === e ? a > 1 ? .15 : .25 : e, this.applyChange({
	      scale: a,
	      originX: i,
	      originY: n,
	      friction: e
	    }), s && "mousemove" === this.panMode && this.panWithMouse(s, e);
	  }

	  rotateCCW() {
	    this.applyChange({
	      angle: -90
	    });
	  }

	  rotateCW() {
	    this.applyChange({
	      angle: 90
	    });
	  }

	  flipX() {
	    this.applyChange({
	      flipX: !0
	    });
	  }

	  flipY() {
	    this.applyChange({
	      flipY: !0
	    });
	  }

	  fitX() {
	    this.stop("target");
	    const {
	      containerRect: t,
	      contentRect: e,
	      target: i
	    } = this;
	    this.applyChange({
	      panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
	      panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
	      scale: t.width / e.fitWidth / this.targetScale,
	      originX: 0,
	      originY: 0,
	      ignoreBounds: !0
	    });
	  }

	  fitY() {
	    this.stop("target");
	    const {
	      containerRect: t,
	      contentRect: e,
	      target: i
	    } = this;
	    this.applyChange({
	      panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
	      panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
	      scale: t.height / e.fitHeight / this.targetScale,
	      originX: 0,
	      originY: 0,
	      ignoreBounds: !0
	    });
	  }

	  toggleFS() {
	    const {
	      container: t
	    } = this,
	          e = this.cn("inFullscreen"),
	          i = this.cn("htmlHasFullscreen");
	    t.classList.toggle(e);
	    const n = t.classList.contains(e);
	    n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
	  }

	  getMatrix(t = this.current) {
	    const {
	      a: e,
	      b: i,
	      c: n,
	      d: s,
	      e: o,
	      f: a
	    } = t;
	    return new DOMMatrix([e, i, n, s, o, a]);
	  }

	  reset(t) {
	    if (this.state !== g.Init && this.state !== g.Destroy) {
	      this.stop("current");

	      for (const t of b) this.target[t] = P[t];

	      this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = g.Panning, this.requestTick());
	    }
	  }

	  destroy() {
	    this.stop(), this.state = g.Destroy, this.detachEvents(), this.detachObserver();
	    const {
	      container: t,
	      content: e
	    } = this,
	          i = this.option("classes") || {};

	    for (const e of Object.values(i)) t.classList.remove(e + "");

	    e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
	  }

	}

	Object.defineProperty(T, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: y
	}), Object.defineProperty(T, "Plugins", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {}
	});

	const O = function (t, e) {
	  let i = !0;
	  return (...n) => {
	    i && (i = !1, t(...n), setTimeout(() => {
	      i = !0;
	    }, e));
	  };
	},
	      A = (t, e) => {
	  let i = [];
	  return t.childNodes.forEach(t => {
	    t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
	  }), i;
	},
	      z = {
	  viewport: null,
	  track: null,
	  enabled: !0,
	  slides: [],
	  axis: "x",
	  transition: "fade",
	  preload: 1,
	  slidesPerPage: "auto",
	  initialPage: 0,
	  friction: .12,
	  Panzoom: {
	    decelFriction: .12
	  },
	  center: !0,
	  infinite: !0,
	  fill: !0,
	  dragFree: !1,
	  adaptiveHeight: !1,
	  direction: "ltr",
	  classes: {
	    container: "f-carousel",
	    viewport: "f-carousel__viewport",
	    track: "f-carousel__track",
	    slide: "f-carousel__slide",
	    isLTR: "is-ltr",
	    isRTL: "is-rtl",
	    isHorizontal: "is-horizontal",
	    isVertical: "is-vertical",
	    inTransition: "in-transition",
	    isSelected: "is-selected"
	  },
	  l10n: {
	    NEXT: "Next slide",
	    PREV: "Previous slide",
	    GOTO: "Go to slide #%d"
	  }
	};

	var L;
	!function (t) {
	  t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
	}(L || (L = {}));

	const R = t => {
	  if ("string" == typeof t && (t = {
	    html: t
	  }), !(t instanceof String || t instanceof HTMLElement)) {
	    const e = t.thumb;
	    void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
	  }

	  return Object.assign({
	    html: "",
	    el: null,
	    isDom: !1,
	    class: "",
	    index: -1,
	    dim: 0,
	    gap: 0,
	    pos: 0,
	    transition: !1
	  }, t);
	},
	      k = (t = {}) => Object.assign({
	  index: -1,
	  slides: [],
	  dim: 0,
	  pos: -1
	}, t);

	class I extends f {
	  constructor(t, e) {
	    super(e), Object.defineProperty(this, "instance", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: t
	    });
	  }

	  attach() {}

	  detach() {}

	}

	const D = {
	  classes: {
	    list: "f-carousel__dots",
	    isDynamic: "is-dynamic",
	    hasDots: "has-dots",
	    dot: "f-carousel__dot",
	    isBeforePrev: "is-before-prev",
	    isPrev: "is-prev",
	    isCurrent: "is-current",
	    isNext: "is-next",
	    isAfterNext: "is-after-next"
	  },
	  dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
	  dynamicFrom: 11,
	  maxCount: 1 / 0,
	  minCount: 2
	};

	class F extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "isDynamic", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "list", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  onRefresh() {
	    this.refresh();
	  }

	  build() {
	    let t = this.list;
	    return t || (t = document.createElement("ul"), S(t, this.cn("list")), t.setAttribute("role", "tablist"), this.instance.container.appendChild(t), S(this.instance.container, this.cn("hasDots")), this.list = t), t;
	  }

	  refresh() {
	    var t;
	    const e = this.instance.pages.length,
	          i = Math.min(2, this.option("minCount")),
	          n = Math.max(2e3, this.option("maxCount")),
	          s = this.option("dynamicFrom");
	    if (e < i || e > n) return void this.cleanup();
	    const a = "number" == typeof s && e > 5 && e >= s,
	          r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
	    r && this.cleanup();
	    const l = this.build();
	    if (o(l, this.cn("isDynamic"), !!a), r) for (let t = 0; t < e; t++) l.append(this.createItem(t));
	    let c,
	        h = 0;

	    for (const e of [...l.children]) {
	      const i = h === this.instance.page;
	      i && (c = e), o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");

	      for (const t of ["isBeforePrev", "isPrev", "isNext", "isAfterNext"]) E(e, this.cn(t));

	      h++;
	    }

	    if (c = c || l.firstChild, a && c) {
	      const t = c.previousElementSibling,
	            e = t && t.previousElementSibling;
	      S(t, this.cn("isPrev")), S(e, this.cn("isBeforePrev"));
	      const i = c.nextElementSibling,
	            n = i && i.nextElementSibling;
	      S(i, this.cn("isNext")), S(n, this.cn("isAfterNext"));
	    }

	    this.isDynamic = a;
	  }

	  createItem(t = 0) {
	    var e;
	    const i = document.createElement("li");
	    i.setAttribute("role", "presentation");
	    const s = n(this.instance.localize(this.option("dotTpl"), [["%d", t + 1]]).replace(/\%i/g, t + ""));
	    return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
	  }

	  cleanup() {
	    this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, E(this.instance.container, this.cn("hasDots"));
	  }

	  attach() {
	    this.instance.on(["refresh", "change"], this.onRefresh);
	  }

	  detach() {
	    this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
	  }

	}

	Object.defineProperty(F, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: D
	});

	class j extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "prev", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "next", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  onRefresh() {
	    const t = this.instance,
	          e = t.pages.length,
	          i = t.page;
	    if (e < 2) return void this.cleanup();
	    this.build();
	    let n = this.prev,
	        s = this.next;
	    n && s && (n.removeAttribute("disabled"), s.removeAttribute("disabled"), t.isInfinite || (i <= 0 && n.setAttribute("disabled", ""), i >= e - 1 && s.setAttribute("disabled", "")));
	  }

	  createButton(t) {
	    const e = this.instance,
	          i = document.createElement("button");
	    i.setAttribute("tabindex", "0"), i.setAttribute("title", e.localize(`{{${t.toUpperCase()}}}`)), S(i, this.cn("button") + " " + this.cn("next" === t ? "isNext" : "isPrev"));
	    const n = e.isRTL ? "next" === t ? "prev" : "next" : t;
	    var s;
	    return i.innerHTML = e.localize(this.option(`${n}Tpl`)), i.dataset[`carousel${(s = t, s ? s.match("^[a-z]") ? s.charAt(0).toUpperCase() + s.substring(1) : s : "")}`] = "true", i;
	  }

	  build() {
	    let t = this.container;
	    t || (this.container = t = document.createElement("div"), S(t, this.cn("container")), this.instance.container.appendChild(t)), this.next || (this.next = t.appendChild(this.createButton("next"))), this.prev || (this.prev = t.appendChild(this.createButton("prev")));
	  }

	  cleanup() {
	    this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove(), this.prev = null, this.next = null, this.container = null;
	  }

	  attach() {
	    this.instance.on(["refresh", "change"], this.onRefresh);
	  }

	  detach() {
	    this.instance.off(["refresh", "change"], this.onRefresh), this.cleanup();
	  }

	}

	Object.defineProperty(j, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {
	    classes: {
	      container: "f-carousel__nav",
	      button: "f-button",
	      isNext: "is-next",
	      isPrev: "is-prev"
	    },
	    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
	    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
	  }
	});

	class H extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "selectedIndex", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "target", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "nav", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  addAsTargetFor(t) {
	    this.target = this.instance, this.nav = t, this.attachEvents();
	  }

	  addAsNavFor(t) {
	    this.nav = this.instance, this.target = t, this.attachEvents();
	  }

	  attachEvents() {
	    this.nav && this.target && (this.nav.options.initialSlide = this.target.options.initialPage, this.nav.on("ready", this.onNavReady), this.nav.state === L.Ready && this.onNavReady(this.nav), this.target.on("ready", this.onTargetReady), this.target.state === L.Ready && this.onTargetReady(this.target));
	  }

	  onNavReady(t) {
	    t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
	  }

	  onTargetReady(t) {
	    t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
	  }

	  onNavClick(t, e, i) {
	    i.pointerType || this.onNavTouch(t, t.panzoom, i);
	  }

	  onNavTouch(t, e, i) {
	    var n, s;
	    if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
	    const o = i.target,
	          {
	      nav: a,
	      target: r
	    } = this;
	    if (!a || !r || !o) return;
	    const l = o.closest("[data-index]");
	    if (i.stopPropagation(), i.preventDefault(), !l) return;
	    const c = parseInt(l.dataset.index || "", 10) || 0,
	          h = r.getPageForSlide(c),
	          d = a.getPageForSlide(c);
	    a.slideTo(d), r.slideTo(h, {
	      friction: null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")
	    }), this.markSelectedSlide(c);
	  }

	  onNavCreateSlide(t, e) {
	    e.index === this.selectedIndex && this.markSelectedSlide(e.index);
	  }

	  onTargetChange() {
	    const {
	      target: t,
	      nav: e
	    } = this;
	    if (!t || !e) return;
	    if (e.state !== L.Ready || t.state !== L.Ready) return;
	    const i = t.pages[t.page].slides[0].index,
	          n = e.getPageForSlide(i);
	    this.markSelectedSlide(i), e.slideTo(n);
	  }

	  markSelectedSlide(t) {
	    const {
	      nav: e
	    } = this;
	    e && e.state === L.Ready && (this.selectedIndex = t, [...e.slides].map(e => {
	      e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
	    }));
	  }

	  attach() {
	    let t = this.options.target,
	        e = this.options.nav;
	    t ? this.addAsNavFor(t) : e && this.addAsTargetFor(e);
	  }

	  detach() {
	    this.nav && (this.nav.off("ready", this.onNavReady), this.nav.off("createSlide", this.onNavCreateSlide), this.nav.off("Panzoom.click", this.onNavClick), this.nav.off("Panzoom.touchEnd", this.onNavTouch)), this.nav = null, this.target && (this.target.off("ready", this.onTargetReady), this.target.off("refresh", this.onTargetChange), this.target.off("change", this.onTargetChange)), this.target = null;
	  }

	}

	Object.defineProperty(H, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {
	    friction: .35
	  }
	});
	const B = {
	  Navigation: j,
	  Dots: F,
	  Sync: H
	};

	class _ extends m {
	  get axis() {
	    return this.isHorizontal ? "e" : "f";
	  }

	  get isEnabled() {
	    return this.state === L.Ready;
	  }

	  get isInfinite() {
	    let t = !1;
	    const e = this.contentDim,
	          i = this.viewportDim;
	    return this.pages.length >= 2 && e > 1.5 * i && (t = this.option("infinite")), t;
	  }

	  get isRTL() {
	    return "rtl" === this.option("direction");
	  }

	  get isHorizontal() {
	    return "x" === this.option("axis");
	  }

	  constructor(t, e = {}, i = {}) {
	    if (super(), Object.defineProperty(this, "userOptions", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {}
	    }), Object.defineProperty(this, "userPlugins", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {}
	    }), Object.defineProperty(this, "bp", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: ""
	    }), Object.defineProperty(this, "lp", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: L.Init
	    }), Object.defineProperty(this, "page", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "prevPage", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "viewport", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "track", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "slides", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), Object.defineProperty(this, "pages", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), Object.defineProperty(this, "panzoom", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "inTransition", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: new Set()
	    }), Object.defineProperty(this, "contentDim", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "viewportDim", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), "string" == typeof t && (t = document.querySelector(t)), !t || !x(t)) throw new Error("No Element found");
	    this.container = t, this.slideNext = O(this.slideNext.bind(this), 150), this.slidePrev = O(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(() => {
	      this.processOptions();
	    });
	  }

	  processOptions() {
	    const t = u({}, _.defaults, this.userOptions);
	    let e = "";
	    const i = t.breakpoints;
	    if (i && d(i)) for (const [n, s] of Object.entries(i)) window.matchMedia(n).matches && d(s) && (e += n, u(t, s));
	    e === this.bp && this.state !== L.Init || (this.bp = e, this.state === L.Ready && (t.initialSlide = this.pages[this.page].slides[0].index), this.state !== L.Init && this.destroy(), super.setOptions(t), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(() => {
	      this.init();
	    }, 0));
	  }

	  init() {
	    this.state = L.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, _.Plugins), this.userPlugins)), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = L.Ready, this.emit("ready");
	  }

	  initLayout() {
	    const {
	      container: t
	    } = this,
	          e = this.option("classes");
	    S(t, this.cn("container")), o(t, e.isLTR, !this.isRTL), o(t, e.isRTL, this.isRTL), o(t, e.isVertical, !this.isHorizontal), o(t, e.isHorizontal, this.isHorizontal);
	    let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
	    i || (i = document.createElement("div"), S(i, e.viewport), i.append(...A(t, `.${e.slide}`)), t.prepend(i));
	    let n = this.option("track") || t.querySelector(`.${e.track}`);
	    n || (n = document.createElement("div"), S(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
	  }

	  initSlides() {
	    const {
	      track: t
	    } = this;

	    if (t) {
	      this.slides = [], [...A(t, `.${this.cn("slide")}`)].forEach(t => {
	        if (x(t)) {
	          const e = R({
	            el: t,
	            isDom: !0,
	            index: this.slides.length
	          });
	          this.slides.push(e), this.emit("initSlide", e, this.slides.length);
	        }
	      });

	      for (let t of this.option("slides", [])) {
	        const e = R(t);
	        e.index = this.slides.length, this.slides.push(e), this.emit("initSlide", e, this.slides.length);
	      }

	      this.emit("initSlides");
	    }
	  }

	  setInitialPage() {
	    let t = 0;
	    const e = this.option("initialSlide");
	    t = "number" == typeof e ? this.getPageForSlide(e) : parseInt(this.option("initialPage", 0) + "", 10) || 0, this.page = t;
	  }

	  setInitialPosition() {
	    if (!this.track || !this.pages.length) return;
	    const t = this.isHorizontal;
	    let e = this.page;
	    this.pages[e] || (this.page = e = 0);
	    const i = this.pages[e].pos * (this.isRTL && t ? 1 : -1),
	          n = t ? `${i}px` : "0",
	          s = t ? "0" : `${i}px`;
	    this.track.style.transform = `translate3d(${n}, ${s}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
	  }

	  initPanzoom() {
	    this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
	    const t = this.option("Panzoom") || {};
	    this.panzoom = new T(this.viewport, u({}, {
	      content: this.track,
	      zoom: !1,
	      panOnlyZoomed: !1,
	      lockAxis: this.isHorizontal ? "x" : "y",
	      infinite: this.isInfinite,
	      click: !1,
	      dblClick: !1,
	      touch: t => !(this.pages.length < 2 && !t.options.infinite),
	      bounds: () => this.getBounds(),
	      maxVelocity: t => Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
	    }, t)), this.panzoom.on("*", (t, e, ...i) => {
	      this.emit(`Panzoom.${e}`, t, ...i);
	    }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
	  }

	  attachEvents() {
	    const t = this.container;
	    t && (t.addEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
	  }

	  createPages() {
	    let t = [];
	    const {
	      contentDim: e,
	      viewportDim: i
	    } = this,
	          n = this.option("slidesPerPage");

	    if ("number" == typeof n && e > i) {
	      for (let e = 0; e < this.slides.length; e += n) t.push(k({
	        index: e,
	        slides: this.slides.slice(e, e + n)
	      }));

	      return t;
	    }

	    let s = 0,
	        o = 0;

	    for (const e of this.slides) (!t.length || o + e.dim > i) && (t.push(k()), s = t.length - 1, o = 0), o += e.dim + e.gap, t[s].slides.push(e);

	    return t;
	  }

	  processPages() {
	    const e = this.pages,
	          {
	      contentDim: i,
	      viewportDim: n
	    } = this,
	          s = this.option("center"),
	          o = this.option("fill"),
	          a = o && s && i > n && !this.isInfinite;
	    if (e.forEach((t, e) => {
	      t.index = e, t.pos = t.slides[0].pos, t.dim = 0;

	      for (const [e, i] of t.slides.entries()) t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);

	      a && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : a && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : s && (t.pos += -.5 * (n - t.dim));
	    }), e.forEach((e, s) => {
	      o && !this.isInfinite && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = t(e.pos, 1e3), e.dim = t(e.dim, 1e3), e.pos < .1 && e.pos > -.1 && (e.pos = 0);
	    }), this.isInfinite) return e;
	    const r = [];
	    let l;
	    return e.forEach(t => {
	      const e = Object.assign({}, t);
	      l && e.pos === l.pos ? (l.dim += e.dim, l.slides = [...l.slides, ...e.slides]) : (e.index = r.length, l = e, r.push(e));
	    }), r;
	  }

	  getPageFromIndex(t = 0) {
	    const e = this.pages.length;
	    let i;
	    return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
	  }

	  getSlideMetrics(e) {
	    const i = this.isHorizontal ? "width" : "height";
	    let n = 0,
	        s = 0,
	        o = e.el;
	    o ? n = parseFloat(o.dataset[i] || "") || 0 : (o = document.createElement("div"), o.style.visibility = "hidden", S(o, this.cn("slide") + " " + e.class), (this.track || document.body).prepend(o)), n ? (o.style[i] = `${n}px`, o.style["width" === i ? "height" : "width"] = "") : n = o.getBoundingClientRect()[i];
	    const a = getComputedStyle(o);
	    return "content-box" === a.boxSizing && (this.isHorizontal ? (n += parseFloat(a.paddingLeft) || 0, n += parseFloat(a.paddingRight) || 0) : (n += parseFloat(a.paddingTop) || 0, n += parseFloat(a.paddingBottom) || 0)), s = parseFloat(a[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, this.isHorizontal, e.el || o.remove(), {
	      dim: t(n, 1e3),
	      gap: t(s, 1e3)
	    };
	  }

	  getBounds() {
	    let t = {
	      min: 0,
	      max: 0
	    };
	    if (this.isInfinite) t = {
	      min: -1 / 0,
	      max: 1 / 0
	    };else if (this.pages.length) {
	      const e = this.pages[0].pos,
	            i = this.pages[this.pages.length - 1].pos;
	      t = this.isRTL && this.isHorizontal ? {
	        min: e,
	        max: i
	      } : {
	        min: -1 * i,
	        max: -1 * e
	      };
	    }
	    return {
	      x: this.isHorizontal ? t : {
	        min: 0,
	        max: 0
	      },
	      y: this.isHorizontal ? {
	        min: 0,
	        max: 0
	      } : t
	    };
	  }

	  repositionSlides() {
	    let e,
	        {
	      viewport: i,
	      viewportDim: n,
	      contentDim: s,
	      page: o,
	      pages: a
	    } = this,
	        r = 0,
	        l = 0,
	        c = 0,
	        h = 0;
	    this.panzoom ? h = -1 * this.panzoom.current[this.axis] : a[o] && (h = a[o].pos || 0), e = this.isHorizontal ? this.isRTL ? "right" : "left" : "top", this.isRTL && this.isHorizontal && (h *= -1);

	    for (const i of this.slides) i.el ? ("top" === e ? (i.el.style.right = "", i.el.style.left = "") : i.el.style.top = "", i.index !== r ? i.el.style[e] = 0 === l ? "" : `${t(l, 1e3)}px` : i.el.style[e] = "", c += i.dim + i.gap, r++) : l += i.dim + i.gap;

	    if (this.isInfinite && c && i) {
	      const o = this.isHorizontal;
	      let a = getComputedStyle(i),
	          r = "padding",
	          d = o ? "Right" : "Bottom",
	          u = parseFloat(a[r + (o ? "Left" : "Top")]);
	      h -= u, n += u, n += parseFloat(a[r + d]);

	      for (const i of this.slides) i.el && (t(i.pos) < t(n) && t(i.pos + i.dim + i.gap) < t(h) && t(h) > t(s - n) && (i.el.style[e] = `${t(l + c, 1e3)}px`), t(i.pos + i.gap) >= t(s - n) && t(i.pos) > t(h + n) && t(h) < t(n) && (i.el.style[e] = `-${t(c, 1e3)}px`));
	    }

	    let d,
	        u,
	        p = [...this.inTransition];

	    if (p.length > 1 && (d = this.pages[p[0]], u = this.pages[p[1]]), d && u) {
	      let i = 0;

	      for (const n of this.slides) n.el ? this.inTransition.has(n.index) && d.slides.indexOf(n) < 0 && (n.el.style[e] = `${t(i + (d.pos - u.pos), 1e3)}px`) : i += n.dim + n.gap;
	    }
	  }

	  createSlideEl(t) {
	    if (!this.track || !t) return;
	    if (t.el) return;
	    const e = document.createElement("div");
	    S(e, this.cn("slide")), S(e, t.class), S(e, t.customClass), t.html && (e.innerHTML = t.html);
	    const i = [];
	    this.slides.forEach((t, e) => {
	      t.el && i.push(e);
	    });
	    const n = t.index;
	    let s = null;

	    if (i.length) {
	      let t = i.reduce((t, e) => Math.abs(e - n) < Math.abs(t - n) ? e : t);
	      s = this.slides[t];
	    }

	    const o = s && s.el ? s.index < t.index ? s.el.nextSibling : s.el : null;
	    this.track.insertBefore(e, this.track.contains(o) ? o : null), t.el = e, this.emit("createSlide", t);
	  }

	  removeSlideEl(t, e = !1) {
	    const i = t.el;
	    if (!i) return;
	    if (E(i, this.cn("isSelected")), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), E(i, this.cn("isSelected")), void (i.style.left = "");
	    this.emit("removeSlide", t);
	    const n = new CustomEvent("animationend");
	    i.dispatchEvent(n), t.el && t.el.remove(), t.el = null;
	  }

	  transitionTo(e = 0, i = this.option("transition")) {
	    if (!i) return !1;
	    const {
	      pages: n,
	      panzoom: s
	    } = this;
	    e = parseInt((e || 0).toString()) || 0;
	    const o = this.getPageFromIndex(e);
	    if (!s || !n[o] || n.length < 2 || n[this.page].slides[0].dim < this.viewportDim) return !1;
	    const a = e > this.page ? 1 : -1,
	          r = this.pages[o].pos * (this.isRTL ? 1 : -1);
	    if (this.page === o && t(r, 1e3) === t(s.target[this.axis], 1e3)) return !1;
	    this.clearTransitions();
	    const l = s.isResting;
	    S(this.container, this.cn("inTransition"));
	    const c = this.pages[this.page].slides[0],
	          h = this.pages[o].slides[0];
	    this.inTransition.add(h.index), this.createSlideEl(h);
	    let d = c.el,
	        u = h.el;
	    l || "slide" === i || (i = "fadeFast", d = null);
	    const p = this.isRTL ? "next" : "prev",
	          f = this.isRTL ? "prev" : "next";
	    return d && (this.inTransition.add(c.index), c.transition = i, d.addEventListener("animationend", this.onAnimationEnd), d.classList.add(`f-${i}Out`, `to-${a > 0 ? f : p}`)), u && (h.transition = i, u.addEventListener("animationend", this.onAnimationEnd), u.classList.add(`f-${i}In`, `from-${a > 0 ? p : f}`)), s.panTo({
	      x: this.isHorizontal ? r : 0,
	      y: this.isHorizontal ? 0 : r,
	      friction: 0
	    }), this.onChange(o), !0;
	  }

	  manageSlideVisiblity() {
	    const t = new Set(),
	          e = new Set(),
	          i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);

	    for (const n of this.slides) i.has(n) ? t.add(n) : e.add(n);

	    for (const e of this.inTransition) t.add(this.slides[e]);

	    for (const e of t) this.createSlideEl(e), this.lazyLoadSlide(e);

	    for (const i of e) t.has(i) || this.removeSlideEl(i);

	    this.markSelectedSlides(), this.repositionSlides();
	  }

	  markSelectedSlides() {
	    if (!this.pages[this.page] || !this.pages[this.page].slides) return;
	    const t = "aria-hidden";
	    let e = this.cn("isSelected");
	    if (e) for (const i of this.slides) i.el && (i.el.dataset.index = `${i.index}`, this.pages[this.page].slides.includes(i) ? (i.el.classList.contains(e) || (S(i.el, e), this.emit("selectSlide", i)), i.el.removeAttribute(t)) : (i.el.classList.contains(e) && (E(i.el, e), this.emit("unselectSlide", i)), i.el.setAttribute(t, "true")));
	  }

	  flipInfiniteTrack() {
	    const t = this.panzoom;
	    if (!t || !this.isInfinite) return;
	    const e = "x" === this.option("axis") ? "e" : "f",
	          {
	      viewportDim: i,
	      contentDim: n
	    } = this;
	    let s = t.current[e],
	        o = t.target[e] - s,
	        a = 0,
	        r = .5 * i,
	        l = n;
	    this.isRTL && this.isHorizontal ? (s < -r && (a = -1, s += l), s > l - r && (a = 1, s -= l)) : (s > r && (a = 1, s -= l), s < -l + r && (a = -1, s += l)), a && (t.current[e] = s, t.target[e] = s + o);
	  }

	  lazyLoadSlide(t) {
	    const e = this,
	          i = t && t.el;
	    if (!i) return;
	    const s = new Set(),
	          o = "f-fadeIn";
	    i.querySelectorAll("[data-lazy-srcset]").forEach(t => {
	      t instanceof HTMLImageElement && s.add(t);
	    });
	    let a = Array.from(i.querySelectorAll("[data-lazy-src]"));
	    i.dataset.lazySrc && a.push(i), a.map(t => {
	      t instanceof HTMLImageElement ? s.add(t) : x(t) && (t.style.backgroundImage = `url('${t.dataset.lazySrc || ""}')`, delete t.dataset.lazySrc);
	    });

	    const r = (t, i, n) => {
	      n && (n.remove(), n = null), i.complete && (i.classList.add(o), setTimeout(() => {
	        i.classList.remove(o);
	      }, 350), i.style.display = ""), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (e.updateMetrics(), e.setViewportHeight()), this.emit("load", t);
	    };

	    for (const e of s) {
	      let i = null;
	      e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.style.display = "none", e.addEventListener("error", () => {
	        r(t, e, i);
	      }), e.addEventListener("load", () => {
	        r(t, e, i);
	      }), setTimeout(() => {
	        e.parentNode && t.el && (e.complete ? r(t, e, i) : (i = n(w), e.parentNode.insertBefore(i, e)));
	      }, 300);
	    }
	  }

	  onAnimationEnd(t) {
	    var e;
	    const i = t.target,
	          n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1,
	          s = this.slides[n],
	          o = t.animationName;
	    if (!i || !s || !o) return;
	    const a = !!this.inTransition.has(n) && s.transition;
	    a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
	  }

	  onDecel(t, e = 0, i = 0) {
	    const {
	      isRTL: n,
	      isHorizontal: s,
	      axis: o,
	      pages: a
	    } = this,
	          r = a.length,
	          l = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
	    let c = 0;
	    if (c = l > 45 && l < 135 ? s ? 0 : i : s ? e : 0, !r) return;
	    const h = this.option("dragFree");
	    let d = this.page,
	        u = n && s ? 1 : -1;
	    const p = t.target[o] * u,
	          f = t.current[o] * u;
	    let {
	      pageIndex: m
	    } = this.getPageFromPosition(p),
	        {
	      pageIndex: g
	    } = this.getPageFromPosition(f);
	    h ? this.onChange(m) : (d = g, Math.abs(c) > 5 && (d = n && s ? c < 0 ? d - 1 : d + 1 : c < 0 ? d + 1 : d - 1), this.slideTo(d, {
	      transition: !1,
	      friction: t.option("decelFriction")
	    }));
	  }

	  onClick(t) {
	    const e = t.target,
	          i = e && x(e) ? e.dataset : null;
	    let n, s;
	    i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
	  }

	  onSlideTo(t) {
	    const e = t.detail || 0;
	    this.slideTo(this.getPageForSlide(e), {
	      friction: 0
	    });
	  }

	  onChange(t, e = 0) {
	    const i = this.page;
	    this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
	  }

	  onRefresh() {
	    let t = this.contentDim,
	        e = this.viewportDim;
	    this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
	      friction: 0,
	      transition: !1
	    });
	  }

	  onResize() {
	    this.option("breakpoints") && this.processOptions();
	  }

	  onBeforeTransform(t) {
	    this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
	  }

	  onEndAnimation() {
	    this.inTransition.size || this.emit("settle");
	  }

	  reInit(t = null, e = null) {
	    this.destroy(), this.state = L.Init, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
	  }

	  slideTo(t = 0, {
	    friction: e = this.option("friction"),
	    transition: i = this.option("transition")
	  } = {}) {
	    if (this.state === L.Destroy) return;
	    const {
	      axis: n,
	      isHorizontal: s,
	      isRTL: o,
	      pages: a,
	      panzoom: r
	    } = this,
	          l = a.length,
	          c = o && s ? 1 : -1;
	    if (!r || !l) return;
	    if (this.transitionTo(t, i)) return;
	    const h = this.getPageFromIndex(t);
	    let d = a[h].pos;

	    if (this.isInfinite) {
	      const e = this.contentDim,
	            i = r.target[n] * c;
	      if (2 === l) d += e * Math.floor(parseFloat(t + "") / 2);else {
	        const t = i;
	        d = [d, d - e, d + e].reduce(function (e, i) {
	          return Math.abs(i - t) < Math.abs(e - t) ? i : e;
	        });
	      }
	    }

	    d *= c, Math.abs(r.target[n] - d) < .1 || (r.panTo({
	      x: s ? d : 0,
	      y: s ? 0 : d,
	      friction: e
	    }), this.onChange(h));
	  }

	  slideToClosest(t) {
	    if (this.panzoom) {
	      const {
	        pageIndex: e
	      } = this.getPageFromPosition(this.panzoom.current[this.isHorizontal ? "e" : "f"]);
	      this.slideTo(e, t);
	    }
	  }

	  slideNext() {
	    this.slideTo(this.page + 1);
	  }

	  slidePrev() {
	    this.slideTo(this.page - 1);
	  }

	  clearTransitions() {
	    this.inTransition.clear(), E(this.container, this.cn("inTransition"));
	    const t = ["to-prev", "to-next", "from-prev", "from-next"];

	    for (const e of this.slides) {
	      const i = e.el;

	      if (i) {
	        i.removeEventListener("animationend", this.onAnimationEnd), i.classList.remove(...t);
	        const n = e.transition;
	        n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
	      }
	    }

	    this.manageSlideVisiblity();
	  }

	  prependSlide(t) {
	    var e, i;
	    let n = Array.isArray(t) ? t : [t];

	    for (const t of n.reverse()) this.slides.unshift(R(t));

	    for (let t = 0; t < this.slides.length; t++) this.slides[t].index = t;

	    const s = (null === (e = this.pages[this.page]) || void 0 === e ? void 0 : e.pos) || 0;
	    this.page += n.length, this.updateMetrics();
	    const o = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0;

	    if (this.panzoom) {
	      const t = this.isRTL ? s - o : o - s;
	      this.panzoom.target.e -= t, this.panzoom.current.e -= t, this.panzoom.requestTick();
	    }
	  }

	  appendSlide(t) {
	    let e = Array.isArray(t) ? t : [t];

	    for (const t of e) {
	      const e = R(t);
	      e.index = this.slides.length, this.slides.push(e), this.emit("initSlide", t, this.slides.length);
	    }

	    this.updateMetrics();
	  }

	  removeSlide(t) {
	    const e = this.slides.length;
	    t = (t % e + e) % e, this.removeSlideEl(this.slides[t], !0), this.slides.splice(t, 1);

	    for (let t = 0; t < this.slides.length; t++) this.slides[t].index = t;

	    this.updateMetrics(), this.slideTo(this.page, {
	      friction: 0,
	      transition: !1
	    });
	  }

	  updateMetrics() {
	    const {
	      panzoom: e,
	      viewport: i,
	      track: n,
	      isHorizontal: s
	    } = this;
	    if (!n) return;
	    const o = s ? "width" : "height";

	    if (i) {
	      let e = t(i.getBoundingClientRect()[o], 1e3),
	          n = getComputedStyle(i),
	          a = "padding",
	          r = s ? "Right" : "Bottom";
	      e -= parseFloat(n[a + (s ? "Left" : "Top")]) + parseFloat(n[a + r]), this.viewportDim = e;
	    }

	    let a,
	        r = this.pages.length,
	        l = 0;

	    for (const [e, i] of this.slides.entries()) {
	      let n = 0,
	          s = 0;
	      !i.el && a ? (n = a.dim, s = a.gap) : (({
	        dim: n,
	        gap: s
	      } = this.getSlideMetrics(i)), a = i), n = t(n, 1e3), s = t(s, 1e3), i.dim = n, i.gap = s, i.pos = l, l += n, (this.isInfinite || e < this.slides.length - 1) && (l += s);
	    }

	    const c = this.contentDim;
	    l = t(l, 1e3), this.contentDim = l, e && (e.contentRect[o] = l, e.contentRect["e" === this.axis ? "fullWidth" : "fullHeight"] = l), this.pages = this.createPages(), this.pages = this.processPages(), this.state === L.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), e && r === this.pages.length && Math.abs(l - c) > .5 && (e.target[this.axis] = -1 * this.pages[this.page].pos, e.current[this.axis] = -1 * this.pages[this.page].pos, e.stop()), this.manageSlideVisiblity(), this.emit("refresh");
	  }

	  getProgress(e, i = !1) {
	    void 0 === e && (e = this.page);
	    const n = this,
	          s = n.panzoom,
	          o = n.pages[e] || 0;
	    if (!o || !s) return 0;
	    let a = -1 * s.current.e,
	        r = n.contentDim;
	    var l = [t((a - o.pos) / (1 * o.dim), 1e3), t((a + r - o.pos) / (1 * o.dim), 1e3), t((a - r - o.pos) / (1 * o.dim), 1e3)].reduce(function (t, e) {
	      return Math.abs(e) < Math.abs(t) ? e : t;
	    });
	    return i ? l : Math.max(-1, Math.min(1, l));
	  }

	  setViewportHeight() {
	    const {
	      page: t,
	      pages: e,
	      viewport: i,
	      isHorizontal: n
	    } = this;
	    if (!i || !e[t]) return;
	    let s = 0;
	    n && this.track && (this.track.style.height = "auto", e[t].slides.forEach(t => {
	      t.el && (s = Math.max(s, t.el.offsetHeight));
	    })), i.style.height = s ? `${s}px` : "";
	  }

	  getPageForSlide(t) {
	    for (const e of this.pages) for (const i of e.slides) if (i.index === t) return e.index;

	    return -1;
	  }

	  getVisibleSlides(t = 0) {
	    var e;
	    const i = new Set();
	    let {
	      contentDim: n,
	      viewportDim: s,
	      pages: o,
	      page: a
	    } = this;
	    n = n + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
	    let r = 0;
	    r = this.panzoom ? -1 * this.panzoom.current[this.axis] : o[a] && o[a].pos || 0, this.isInfinite && (r -= Math.floor(r / n) * n), this.isRTL && this.isHorizontal && (r *= -1);
	    const l = r - s * t,
	          c = r + s * (t + 1),
	          h = this.isInfinite ? [-1, 0, 1] : [0];

	    for (const t of this.slides) for (const e of h) {
	      const s = t.pos + e * n,
	            o = t.pos + t.dim + t.gap + e * n;
	      s < c && o > l && i.add(t);
	    }

	    return i;
	  }

	  getPageFromPosition(t) {
	    const {
	      viewportDim: e,
	      contentDim: i
	    } = this,
	          n = this.pages.length,
	          s = this.slides.length,
	          o = this.slides[s - 1];
	    let a = 0,
	        r = 0,
	        l = 0;
	    const c = this.option("center");
	    c && (t += .5 * e), this.isInfinite || (t = Math.max(this.slides[0].pos, Math.min(t, o.pos)));
	    const h = i + o.gap;
	    l = Math.floor(t / h) || 0, t -= l * h;
	    let d = o,
	        u = this.slides.find(e => {
	      const i = t + (d && !c ? .5 * d.dim : 0);
	      return d = e, e.pos <= i && e.pos + e.dim + e.gap > i;
	    });
	    return u || (u = o), r = this.getPageForSlide(u.index), a = r + l * n, {
	      page: a,
	      pageIndex: r
	    };
	  }

	  destroy() {
	    if ([L.Destroy].includes(this.state)) return;
	    this.state = L.Destroy;
	    const {
	      container: t,
	      viewport: e,
	      track: i,
	      slides: n,
	      panzoom: s
	    } = this,
	          o = this.option("classes");
	    t.removeEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach(t => {
	      this.removeSlideEl(t);
	    }), this.detachPlugins(), e && e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes);

	    for (const [e, i] of Object.entries(o)) "container" !== e && i && t.classList.remove(i);

	    this.track = null, this.viewport = null, this.page = 0, this.slides = [];
	    const a = this.events.get("ready");
	    this.events = new Map(), a && this.events.set("ready", a);
	  }

	}

	Object.defineProperty(_, "Panzoom", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: T
	}), Object.defineProperty(_, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: z
	}), Object.defineProperty(_, "Plugins", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: B
	});

	const N = function (t) {
	  const e = window.pageYOffset,
	        i = window.pageYOffset + window.innerHeight;
	  if (!x(t)) return 0;
	  const n = t.getBoundingClientRect(),
	        s = n.y + window.pageYOffset,
	        o = n.y + n.height + window.pageYOffset;
	  if (e > o || i < s) return 0;
	  if (e < s && i > o) return 100;
	  if (s < e && o > i) return 100;
	  let a = n.height;
	  s < e && (a -= window.pageYOffset - s), o > i && (a -= o - i);
	  const r = a / window.innerHeight * 100;
	  return Math.round(r);
	},
	      W = !("undefined" == typeof window || !window.document || !window.document.createElement);

	let $$1;

	const X = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'].join(","),
	      Y = t => {
	  if (t && W) {
	    void 0 === $$1 && document.createElement("div").focus({
	      get preventScroll() {
	        return $$1 = !0, !1;
	      }

	    });

	    try {
	      if ($$1) t.focus({
	        preventScroll: !0
	      });else {
	        const e = window.pageXOffset || document.body.scrollTop,
	              i = window.pageYOffset || document.body.scrollLeft;
	        t.focus(), document.body.scrollTo({
	          top: e,
	          left: i,
	          behavior: "auto"
	        });
	      }
	    } catch (t) {}
	  }
	},
	      q = {
	  dragToClose: !0,
	  hideScrollbar: !0,
	  Carousel: {
	    classes: {
	      container: "fancybox__carousel",
	      viewport: "fancybox__viewport",
	      track: "fancybox__track",
	      slide: "fancybox__slide"
	    }
	  },
	  contentClick: "toggleZoom",
	  contentDblClick: !1,
	  backdropClick: "close",
	  animated: !0,
	  idle: 3500,
	  showClass: "f-zoomInUp",
	  hideClass: "f-fadeOut",
	  commonCaption: !1,
	  parentEl: null,
	  startIndex: 0,
	  l10n: Object.assign(Object.assign({}, v), {
	    CLOSE: "Close",
	    NEXT: "Next",
	    PREV: "Previous",
	    MODAL: "You can close this modal content with the ESC key",
	    ERROR: "Something Went Wrong, Please Try Again Later",
	    IMAGE_ERROR: "Image Not Found",
	    ELEMENT_NOT_FOUND: "HTML Element Not Found",
	    AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
	    AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
	    IFRAME_ERROR: "Error Loading Page",
	    TOGGLE_ZOOM: "Toggle zoom level",
	    TOGGLE_THUMBS: "Toggle thumbnails",
	    TOGGLE_SLIDESHOW: "Toggle slideshow",
	    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
	    DOWNLOAD: "Download"
	  }),
	  tpl: {
	    closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
	    main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
	  },
	  groupAll: !1,
	  groupAttr: "data-fancybox",
	  defaultType: "image",
	  defaultDisplay: "block",
	  autoFocus: !0,
	  trapFocus: !0,
	  placeFocusBack: !0,
	  closeButton: "auto",
	  keyboard: {
	    Escape: "close",
	    Delete: "close",
	    Backspace: "close",
	    PageUp: "next",
	    PageDown: "prev",
	    ArrowUp: "prev",
	    ArrowDown: "next",
	    ArrowRight: "next",
	    ArrowLeft: "prev"
	  },
	  Fullscreen: {
	    autoStart: !1
	  },
	  compact: () => window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
	  wheel: "zoom"
	};

	var Z, V;
	!function (t) {
	  t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
	}(Z || (Z = {})), function (t) {
	  t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
	}(V || (V = {}));

	const G = () => {
	  queueMicrotask(() => {
	    (() => {
	      const {
	        slug: t,
	        index: e
	      } = U.parseURL(),
	            i = xt.getInstance();

	      if (i && !1 !== i.option("Hash")) {
	        const n = i.carousel;

	        if (t && n) {
	          for (let e of n.slides) if (e.slug && e.slug === t) return n.slideTo(e.index);

	          if (t === i.option("slug")) return n.slideTo(e - 1);
	          const s = i.getSlide(),
	                o = s && s.triggerEl && s.triggerEl.dataset;
	          if (o && o.fancybox === t) return n.slideTo(e - 1);
	        }

	        U.hasSilentClose = !0, i.close();
	      }

	      U.startFromUrl();
	    })();
	  });
	};

	class U extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "origHash", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: ""
	    }), Object.defineProperty(this, "timer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  onChange() {
	    const t = this.instance,
	          e = t.carousel;
	    this.timer && clearTimeout(this.timer);
	    const i = t.getSlide();
	    if (!e || !i) return;
	    const n = t.isOpeningSlide(i),
	          s = new URL(document.URL).hash;
	    let o,
	        a = i.slug || void 0;
	    o = a || this.instance.option("slug"), !o && i.triggerEl && i.triggerEl.dataset && (o = i.triggerEl.dataset.fancybox);
	    let r = "";
	    o && "true" !== o && (r = "#" + o + (!a && e.slides.length > 1 ? "-" + (i.index + 1) : "")), n && (this.origHash = s !== r ? s : ""), r && s !== r && (this.timer = setTimeout(() => {
	      try {
	        window.history[n ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + r);
	      } catch (t) {}
	    }, 300));
	  }

	  onClose() {
	    if (this.timer && clearTimeout(this.timer), !0 !== U.hasSilentClose) try {
	      window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
	    } catch (t) {}
	  }

	  attach() {
	    this.instance.on("Carousel.ready", this.onChange), this.instance.on("Carousel.change", this.onChange), this.instance.on("close", this.onClose);
	  }

	  detach() {
	    this.instance.off("Carousel.ready", this.onChange), this.instance.off("Carousel.change", this.onChange), this.instance.off("close", this.onClose);
	  }

	  static parseURL() {
	    const t = window.location.hash.slice(1),
	          e = t.split("-"),
	          i = e[e.length - 1],
	          n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
	    return {
	      hash: t,
	      slug: e.join("-"),
	      index: n
	    };
	  }

	  static startFromUrl() {
	    if (U.hasSilentClose = !1, xt.getInstance() || !1 === xt.defaults.Hash) return;
	    const {
	      hash: t,
	      slug: e,
	      index: i
	    } = U.parseURL();
	    if (!e) return;
	    let n = document.querySelector(`[data-slug="${t}"]`);
	    if (n && n.dispatchEvent(new CustomEvent("click", {
	      bubbles: !0,
	      cancelable: !0
	    })), xt.getInstance()) return;
	    const s = document.querySelectorAll(`[data-fancybox="${e}"]`);
	    s.length && (n = s[i - 1], n && n.dispatchEvent(new CustomEvent("click", {
	      bubbles: !0,
	      cancelable: !0
	    })));
	  }

	  static destroy() {
	    window.removeEventListener("hashchange", G, !1);
	  }

	}

	function K() {
	  window.addEventListener("hashchange", G, !1), setTimeout(() => {
	    U.startFromUrl();
	  }, 500);
	}

	Object.defineProperty(U, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {}
	}), Object.defineProperty(U, "hasSilentClose", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: !1
	}), W && (/complete|interactive|loaded/.test(document.readyState) ? K() : document.addEventListener("DOMContentLoaded", K));

	class J extends I {
	  onCreateSlide(t, e, i) {
	    const n = this.instance,
	          s = n.optionFor(i, "src") || "",
	          {
	      el: o,
	      type: a
	    } = i;
	    o && "image" === a && "string" == typeof s && this.setContent(i, s).then(t => {
	      const e = i.contentEl,
	            s = i.imageEl,
	            a = i.thumbElSrc;
	      if (n.isClosing() || !e || !s) return;
	      e.offsetHeight;
	      const r = !!n.isOpeningSlide(i) && this.getZoomInfo(i);

	      if (this.option("protected")) {
	        o.addEventListener("contextmenu", t => {
	          t.preventDefault();
	        });
	        const t = document.createElement("div");
	        S(t, "fancybox-protected"), e.appendChild(t);
	      }

	      if (a && r) {
	        const s = t.contentRect,
	              o = Math.max(s.fullWidth, s.fullHeight);
	        let c = null;
	        !r.opacity && o > 1200 && (c = document.createElement("img"), S(c, "fancybox-ghost"), c.src = a, e.appendChild(c));

	        const h = () => {
	          c && (S(c, "f-fadeFastOut"), setTimeout(() => {
	            c && (c.remove(), c = null);
	          }, 200));
	        };

	        (l = a, new Promise((t, e) => {
	          const i = new Image();
	          i.onload = t, i.onerror = e, i.src = l;
	        })).then(() => {
	          i.state = V.Opening, this.instance.emit("reveal", i), this.zoomIn(i).then(() => {
	            h(), this.instance.done(i);
	          }, () => {
	            n.hideLoading(i);
	          }), c && setTimeout(() => {
	            h();
	          }, o > 2500 ? 800 : 200);
	        }, () => {
	          n.hideLoading(i), n.revealContent(i);
	        });
	      } else {
	        const e = this.optionFor(i, "initialSize"),
	              s = this.optionFor(i, "zoom"),
	              o = {
	          event: n.prevMouseMoveEvent || n.options.event,
	          friction: s ? .12 : 0
	        };
	        let a = n.optionFor(i, "showClass") || void 0,
	            r = !0;
	        n.isOpeningSlide(i) && ("full" === e ? t.zoomToFull(o) : "cover" === e ? t.zoomToCover(o) : "max" === e ? t.zoomToMax(o) : r = !1, t.stop("current")), r && a && (a = t.isDragging ? "f-fadeIn" : ""), n.revealContent(i, a);
	      }

	      var l;
	    }, () => {
	      n.setError(i, "{{IMAGE_ERROR}}");
	    });
	  }

	  onRemoveSlide(t, e, i) {
	    i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
	  }

	  onChange(t, e, i, n) {
	    for (const t of e.slides) {
	      const e = t.panzoom;
	      e && t.index !== i && e.reset(.35);
	    }
	  }

	  onClose() {
	    const t = this.instance,
	          e = t.container,
	          i = t.getSlide();
	    if (!e || !e.parentElement || !i) return;
	    const {
	      el: n,
	      contentEl: s,
	      panzoom: o
	    } = i,
	          a = i.thumbElSrc;
	    if (!n || !a || !s || !o || o.isContentLoading || o.state === g.Init || o.state === g.Destroy) return;
	    o.updateMetrics();
	    let r = this.getZoomInfo(i);
	    if (!r) return;
	    this.instance.state = Z.CustomClosing, e.classList.remove("is-zooming-in"), e.classList.add("is-zooming-out"), s.style.backgroundImage = `url('${a}')`;
	    const l = e.getBoundingClientRect();
	    Object.assign(e.style, {
	      position: "absolute",
	      top: `${window.pageYOffset}px`,
	      left: `${window.pageXOffset}px`,
	      bottom: "auto",
	      right: "auto",
	      width: `${l.width}px`,
	      height: `${l.height}px`,
	      overflow: "hidden"
	    });
	    const {
	      x: c,
	      y: h,
	      scale: d,
	      opacity: u
	    } = r;

	    if (u) {
	      const t = ((t, e, i, n) => {
	        const s = e - t,
	              o = n - i;
	        return e => i + ((e - t) / s * o || 0);
	      })(o.scale, d, 1, 0);

	      o.on("afterTransform", () => {
	        s.style.opacity = t(o.scale) + "";
	      });
	    }

	    o.on("endAnimation", () => {
	      t.destroy();
	    }), o.target.a = d, o.target.b = 0, o.target.c = 0, o.target.d = d, o.panTo({
	      x: c,
	      y: h,
	      scale: d,
	      friction: u ? .2 : .33,
	      ignoreBounds: !0
	    }), o.isResting && t.destroy();
	  }

	  setContent(t, e) {
	    return new Promise((i, s) => {
	      var o, a;
	      const r = this.instance,
	            l = t.el;
	      if (!l) return void s();
	      r.showLoading(t);
	      let c = this.optionFor(t, "content");
	      "string" == typeof c && (c = n(c)), c && x(c) || (c = document.createElement("img"), c instanceof HTMLImageElement && (c.src = e || "", c.alt = (null === (o = t.caption) || void 0 === o ? void 0 : o.replace(/<[^>]+>/gi, "").substring(0, 1e3)) || `Image ${t.index + 1} of ${null === (a = r.carousel) || void 0 === a ? void 0 : a.pages.length}`, c.draggable = !1, t.srcset && c.setAttribute("srcset", t.srcset)), t.sizes && c.setAttribute("sizes", t.sizes)), c.classList.add("fancybox-image"), t.imageEl = c, r.setContent(t, c, !1);
	      t.panzoom = new T(l, u({}, this.option("Panzoom") || {}, {
	        content: c,
	        width: r.optionFor(t, "width", "auto"),
	        height: r.optionFor(t, "height", "auto"),
	        wheel: () => {
	          const t = r.option("wheel");
	          return ("zoom" === t || "pan" == t) && t;
	        },
	        click: (e, i) => {
	          var n, s;
	          if (r.isCompact || r.isClosing()) return !1;
	          if (t.index !== (null === (n = r.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
	          let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
	          return r.option(o ? "contentClick" : "backdropClick") || !1;
	        },
	        dblClick: () => r.isCompact ? "toggleZoom" : r.option("contentDblClick") || !1,
	        spinner: !1,
	        panOnlyZoomed: !0,
	        wheelLimit: 1 / 0,
	        transformParent: !0,
	        on: {
	          ready: t => {
	            i(t);
	          },
	          error: () => {
	            s();
	          },
	          destroy: () => {
	            s();
	          }
	        }
	      }));
	    });
	  }

	  zoomIn(t) {
	    return new Promise((e, i) => {
	      const n = this.instance,
	            s = n.container,
	            {
	        panzoom: o,
	        contentEl: a,
	        el: r
	      } = t;
	      o && o.updateMetrics();
	      const l = this.getZoomInfo(t);
	      if (!(l && r && a && o && s)) return void i();

	      const {
	        x: c,
	        y: h,
	        scale: d,
	        opacity: u
	      } = l,
	            p = () => {
	        t.state !== V.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
	      },
	            f = t => {
	        t.scale < .99 || t.scale > 1.01 || (a.style.opacity = "", E(s, "is-zooming-in"), t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
	      };

	      o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on(["error", "destroy"], () => {
	        i();
	      }), o.panTo({
	        x: c,
	        y: h,
	        scale: d,
	        friction: 0,
	        ignoreBounds: !0
	      }), o.stop("current");
	      const m = {
	        event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
	      },
	            g = this.optionFor(t, "initialSize");
	      S(s, "is-zooming-in"), n.hideLoading(t), "full" === g ? o.zoomToFull(m) : "cover" === g ? o.zoomToCover(m) : "max" === g ? o.zoomToMax(m) : o.reset(.172);
	    });
	  }

	  getZoomInfo(t) {
	    const {
	      el: e,
	      imageEl: i,
	      thumbEl: n,
	      panzoom: s
	    } = t;
	    if (!e || !i || !n || !s || N(n) < 3 || !this.optionFor(t, "zoom") || this.instance.state === Z.Destroy) return !1;
	    const {
	      top: o,
	      left: a,
	      width: r,
	      height: l
	    } = n.getBoundingClientRect();
	    let {
	      top: c,
	      left: h,
	      fitWidth: d,
	      fitHeight: u
	    } = s.contentRect;
	    if (!(r && l && d && u)) return !1;
	    const p = r / d,
	          f = s.container.getBoundingClientRect();
	    c += f.top, h += f.left;
	    const m = -1 * (h + .5 * d - (a + .5 * r)),
	          g = -1 * (c + .5 * u - (o + .5 * l));
	    let b = this.option("zoomOpacity") || !1;
	    return "auto" === b && (b = Math.abs(r / l - d / u) > .1), {
	      x: m,
	      y: g,
	      scale: p,
	      opacity: b
	    };
	  }

	  attach() {
	    this.instance.on("Carousel.change", this.onChange), this.instance.on("Carousel.createSlide", this.onCreateSlide), this.instance.on("Carousel.removeSlide", this.onRemoveSlide), this.instance.on("close", this.onClose);
	  }

	  detach() {
	    this.instance.off("Carousel.change", this.onChange), this.instance.off("Carousel.createSlide", this.onCreateSlide), this.instance.off("Carousel.removeSlide", this.onRemoveSlide), this.instance.off("close", this.onClose);
	  }

	}

	Object.defineProperty(J, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {
	    initialSize: "fit",
	    Panzoom: {
	      maxScale: 1
	    },
	    protected: !1,
	    zoom: !0,
	    zoomOpacity: "auto"
	  }
	});

	const Q = (t, e = {}) => {
	  const i = new URL(t),
	        n = new URLSearchParams(i.search),
	        s = new URLSearchParams();

	  for (const [t, i] of [...n, ...Object.entries(e)]) {
	    let e = i.toString();
	    "t" === t ? s.set("start", parseInt(e).toString()) : s.set(t, e);
	  }

	  let o = s.toString(),
	      a = t.match(/#t=((.*)?\d+s)/);
	  return a && (o += `#t=${a[1]}`), o;
	},
	      tt = {
	  ajax: null,
	  autoSize: !0,
	  preload: !0,
	  videoAutoplay: !0,
	  videoRatio: 16 / 9,
	  videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
	  videoFormat: "",
	  vimeo: {
	    byline: 1,
	    color: "00adef",
	    controls: 1,
	    dnt: 1,
	    muted: 0
	  },
	  youtube: {
	    controls: 1,
	    enablejsapi: 1,
	    nocookie: 1,
	    rel: 0,
	    fs: 1
	  }
	},
	      et = ["image", "html", "ajax", "inline", "clone", "iframe", "map", "pdf", "html5video", "youtube", "vimeo", "video"];

	class it extends I {
	  onInitSlide(t, e, i) {
	    this.processType(i);
	  }

	  onCreateSlide(t, e, i) {
	    this.setContent(i);
	  }

	  onRemoveSlide(t, e, i) {
	    i.closeBtnEl && (i.closeBtnEl.remove(), i.closeBtnEl = void 0), i.xhr && (i.xhr.abort(), i.xhr = null), i.iframeEl && (i.iframeEl.onload = i.iframeEl.onerror = null, i.iframeEl.src = "//about:blank", i.iframeEl = null);
	    const n = i.contentEl,
	          s = i.placeholderEl;
	    if ("inline" === i.type && n && s) n.classList.remove("fancybox__content"), "none" !== n.style.display && (n.style.display = "none"), s.parentNode && s.parentNode.insertBefore(n, s), s.remove(), i.placeholderEl = null;else for (; i.el && i.el.firstChild;) i.el.removeChild(i.el.firstChild);
	  }

	  onSelectSlide(t, e, i) {
	    i.state === V.Ready && this.playVideo();
	  }

	  onUnselectSlide(t, e, i) {
	    var n, s;

	    if ("html5video" === i.type) {
	      try {
	        null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
	      } catch (t) {}

	      return;
	    }

	    let o;
	    "vimeo" === i.type ? o = {
	      method: "pause",
	      value: "true"
	    } : "youtube" === i.type && (o = {
	      event: "command",
	      func: "pauseVideo"
	    }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
	  }

	  onDone(t, e) {
	    t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
	  }

	  onRefresh(t, e) {
	    e.slides.forEach(t => {
	      t.el && (this.setAspectRatio(t), this.resizeIframe(t));
	    });
	  }

	  onMessage(t) {
	    try {
	      let e = JSON.parse(t.data);

	      if ("https://player.vimeo.com" === t.origin) {
	        if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe"))) e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
	      } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
	        const t = document.getElementById(e.id);
	        t && (t.dataset.ready = "true");
	      }
	    } catch (t) {}
	  }

	  loadAjaxContent(t) {
	    const e = this.instance.optionFor(t, "src") || "";
	    this.instance.showLoading(t);
	    const i = this.instance,
	          n = new XMLHttpRequest();
	    i.showLoading(t), n.onreadystatechange = function () {
	      n.readyState === XMLHttpRequest.DONE && i.state === Z.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
	    };
	    const s = t.ajax || null;
	    n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
	  }

	  setInlineContent(t) {
	    let e = null;
	    if (x(t.src)) e = t.src;else if ("string" == typeof t.src) {
	      const i = t.src.split("#", 2).pop();
	      e = i ? document.getElementById(i) : null;
	    }

	    if (e) {
	      if ("clone" === t.type || e.closest(".fancybox__slide")) {
	        e = e.cloneNode(!0);
	        const i = e.dataset.animationName;
	        i && (e.classList.remove(i), delete e.dataset.animationName);
	        let n = e.getAttribute("id");
	        n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
	      } else if (e.parentNode) {
	        const i = document.createElement("div");
	        i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
	      }

	      this.instance.setContent(t, e);
	    } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
	  }

	  setIframeContent(t) {
	    const {
	      src: e,
	      el: i
	    } = t;
	    if (!e || "string" != typeof e || !i) return;
	    const n = this.instance,
	          s = document.createElement("iframe");
	    s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`), s.setAttribute("allow", "autoplay; fullscreen"), s.setAttribute("scrolling", "auto"), s.onerror = () => {
	      n.setError(t, "{{IFRAME_ERROR}}");
	    }, t.iframeEl = s;
	    const o = this.optionFor(t, "preload");
	    if (i.classList.add("is-loading"), "iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), this.resizeIframe(t), void n.setContent(t, s);
	    n.showLoading(t), s.onload = () => {
	      if (!s.src.length) return;
	      const e = "true" !== s.dataset.ready;
	      s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
	    }, s.setAttribute("src", e), n.setContent(t, s, !1);
	  }

	  resizeIframe(t) {
	    const e = t.iframeEl,
	          i = null == e ? void 0 : e.parentElement;
	    if (!e || !i) return;
	    let n = t.autoSize,
	        s = t.width || 0,
	        o = t.height || 0;
	    s && o && (n = !1);
	    const a = i && i.style;
	    if (!1 !== t.preload && !1 !== n && a) try {
	      const t = window.getComputedStyle(i),
	            n = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight),
	            r = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom),
	            l = e.contentWindow;

	      if (l) {
	        const t = l.document,
	              e = t.getElementsByTagName("html")[0],
	              i = t.body;
	        a.width = "", i.style.overflow = "hidden", s = s || e.scrollWidth + n, a.width = `${s}px`, i.style.overflow = "", a.flex = "0 0 auto", a.height = `${i.scrollHeight}px`, o = e.scrollHeight + r;
	      }
	    } catch (t) {}

	    if (s || o) {
	      const t = {
	        flex: "0 1 auto",
	        width: "",
	        height: ""
	      };
	      s && (t.width = `${s}px`), o && (t.height = `${o}px`), Object.assign(a, t);
	    }
	  }

	  playVideo() {
	    const t = this.instance.getSlide();
	    if (!t) return;
	    const {
	      el: e
	    } = t;
	    if (!e || !e.offsetParent) return;
	    if (!this.optionFor(t, "videoAutoplay")) return;
	    if ("html5video" === t.type) try {
	      const t = e.querySelector("video");

	      if (t) {
	        const e = t.play();
	        void 0 !== e && e.then(() => {}).catch(e => {
	          t.muted = !0, t.play();
	        });
	      }
	    } catch (t) {}
	    if ("youtube" !== t.type && "vimeo" !== t.type) return;

	    const i = () => {
	      if (t.iframeEl && t.iframeEl.contentWindow) {
	        let e;
	        if ("true" === t.iframeEl.dataset.ready) return e = "youtube" === t.type ? {
	          event: "command",
	          func: "playVideo"
	        } : {
	          method: "play",
	          value: "true"
	        }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
	        "youtube" === t.type && (e = {
	          event: "listening",
	          id: t.iframeEl.getAttribute("id")
	        }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
	      }

	      t.poller = setTimeout(i, 250);
	    };

	    i();
	  }

	  processType(t) {
	    if (t.html) return t.type = "html", t.src = t.html, void (t.html = "");
	    const e = this.instance.optionFor(t, "src", "");
	    if (!e || "string" != typeof e) return;
	    let i = t.type,
	        n = null;

	    if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
	      const s = this.optionFor(t, "youtube"),
	            {
	        nocookie: o
	      } = s,
	            a = function (t, e) {
	        var i = {};

	        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);

	        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
	          var s = 0;

	          for (n = Object.getOwnPropertySymbols(t); s < n.length; s++) e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
	        }

	        return i;
	      }(s, ["nocookie"]),
	            r = `www.youtube${o ? "-nocookie" : ""}.com`,
	            l = Q(e, a),
	            c = encodeURIComponent(n[2]);

	      t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = "youtube";
	    } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
	      const s = Q(e, this.optionFor(t, "vimeo")),
	            o = encodeURIComponent(n[1]),
	            a = n[4] || "";
	      t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = "vimeo";
	    }

	    if (!i && t.triggerEl) {
	      const e = t.triggerEl.dataset.type;
	      et.includes(e) && (i = e);
	    }

	    i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = "html5video", t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = "image" : e.match(/\.(pdf)((\?|#).*)?$/i) ? i = "pdf" : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = "map") : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = "map")), i = i || this.instance.option("defaultType"), t.type = i, "image" === i && (t.thumbSrc = t.thumbSrc || t.src);
	  }

	  setContent(t) {
	    const e = this.instance.optionFor(t, "src") || "";

	    if (t && t.type && e) {
	      switch (t.type) {
	        case "html":
	          this.instance.setContent(t, e);
	          break;

	        case "html5video":
	          const i = this.option("videoTpl");
	          i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
	          break;

	        case "inline":
	        case "clone":
	          this.setInlineContent(t);
	          break;

	        case "ajax":
	          this.loadAjaxContent(t);
	          break;

	        case "pdf":
	        case "map":
	        case "youtube":
	        case "vimeo":
	          t.preload = !1;

	        case "iframe":
	          this.setIframeContent(t);
	      }

	      this.setAspectRatio(t);
	    }
	  }

	  setAspectRatio(t) {
	    var e;
	    const i = t.contentEl,
	          n = this.optionFor(t, "videoRatio"),
	          s = null === (e = t.el) || void 0 === e ? void 0 : e.getBoundingClientRect();
	    if (!(i && s && n && 1 !== n && t.type && ["video", "youtube", "vimeo", "html5video"].includes(t.type))) return;
	    const o = s.width,
	          a = s.height;
	    i.style.aspectRatio = n + "", i.style.width = o / a > n ? "auto" : "", i.style.height = o / a > n ? "" : "auto";
	  }

	  attach() {
	    this.instance.on("Carousel.initSlide", this.onInitSlide), this.instance.on("Carousel.createSlide", this.onCreateSlide), this.instance.on("Carousel.removeSlide", this.onRemoveSlide), this.instance.on("Carousel.selectSlide", this.onSelectSlide), this.instance.on("Carousel.unselectSlide", this.onUnselectSlide), this.instance.on("Carousel.Panzoom.refresh", this.onRefresh), this.instance.on("done", this.onDone), window.addEventListener("message", this.onMessage);
	  }

	  detach() {
	    this.instance.off("Carousel.initSlide", this.onInitSlide), this.instance.off("Carousel.createSlide", this.onCreateSlide), this.instance.off("Carousel.removeSlide", this.onRemoveSlide), this.instance.off("Carousel.selectSlide", this.onSelectSlide), this.instance.off("Carousel.unselectSlide", this.onUnselectSlide), this.instance.off("Carousel.Panzoom.refresh", this.onRefresh), this.instance.off("done", this.onDone), window.removeEventListener("message", this.onMessage);
	  }

	}

	Object.defineProperty(it, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: tt
	});

	class nt extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: "ready"
	    }), Object.defineProperty(this, "inHover", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "timer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "progressBar", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  get isActive() {
	    return "ready" !== this.state;
	  }

	  onReady(t) {
	    this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
	  }

	  onChange() {
	    var t;
	    (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) || (this.removeProgressBar(), this.pause());
	  }

	  onSettle() {
	    this.resume();
	  }

	  onVisibilityChange() {
	    "visible" === document.visibilityState ? this.resume() : this.pause();
	  }

	  onMouseEnter() {
	    this.inHover = !0, this.pause();
	  }

	  onMouseLeave() {
	    var t;
	    this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
	  }

	  onTimerEnd() {
	    "play" === this.state && (this.instance.isInfinite || this.instance.page !== this.instance.pages.length - 1 ? this.instance.slideNext() : this.instance.slideTo(0));
	  }

	  removeProgressBar() {
	    this.progressBar && (this.progressBar.remove(), this.progressBar = null);
	  }

	  createProgressBar() {
	    var t;
	    if (!this.option("showProgress")) return null;
	    this.removeProgressBar();
	    const e = this.instance,
	          i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
	    let n = this.option("progressParentEl");
	    if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
	    const s = document.createElement("div");
	    return S(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
	  }

	  set() {
	    if (this.instance.pages.length < 2) return;
	    if (this.progressBar) return;
	    const t = this.option("timeout");
	    this.state = "play", S(this.instance.container, "has-autoplay");
	    let e = this.createProgressBar();
	    e && (e.style.transitionDuration = `${t}ms`, e.style.transform = "scaleX(1)"), this.timer = setTimeout(() => {
	      this.timer = null, this.inHover || this.onTimerEnd();
	    }, t), this.emit("set");
	  }

	  clear() {
	    this.timer && (clearTimeout(this.timer), this.timer = null), this.removeProgressBar();
	  }

	  start() {
	    if (this.set(), this.option("pauseOnHover")) {
	      const t = this.instance.container;
	      t.addEventListener("mouseenter", this.onMouseEnter, !1), t.addEventListener("mouseleave", this.onMouseLeave, !1);
	    }

	    document.addEventListener("visibilitychange", this.onVisibilityChange, !1);
	  }

	  stop() {
	    const t = this.instance.container;
	    this.clear(), this.state = "ready", t.removeEventListener("mouseenter", this.onMouseEnter, !1), t.removeEventListener("mouseleave", this.onMouseLeave, !1), document.removeEventListener("visibilitychange", this.onVisibilityChange, !1), E(t, "has-autoplay"), this.emit("stop");
	  }

	  pause() {
	    "play" === this.state && (this.state = "pause", this.clear(), this.emit("pause"));
	  }

	  resume() {
	    const t = this.instance;
	    if (t.isInfinite || t.page !== t.pages.length - 1) {
	      if ("play" !== this.state) {
	        if ("pause" === this.state && !this.inHover) {
	          const t = new Event("resume", {
	            bubbles: !0,
	            cancelable: !0
	          });
	          this.emit("resume", event), t.defaultPrevented || this.set();
	        }
	      } else this.set();
	    } else this.stop();
	  }

	  toggle() {
	    "play" === this.state || "pause" === this.state ? this.stop() : this.set();
	  }

	  attach() {
	    this.instance.on("ready", this.onReady), this.instance.on("Panzoom.startAnimation", this.onChange), this.instance.on("Panzoom.endAnimation", this.onSettle), this.instance.on("Panzoom.touchMove", this.onChange);
	  }

	  detach() {
	    this.instance.off("ready", this.onReady), this.instance.off("Panzoom.startAnimation", this.onChange), this.instance.off("Panzoom.endAnimation", this.onSettle), this.instance.off("Panzoom.touchMove", this.onChange), this.stop();
	  }

	}

	Object.defineProperty(nt, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {
	    autoStart: !0,
	    pauseOnHover: !0,
	    progressParentEl: null,
	    showProgress: !0,
	    timeout: 3e3
	  }
	});

	class st extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "ref", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  onPrepare(t) {
	    const e = t.carousel;
	    if (!e) return;
	    const i = t.container;
	    i && (e.options.Autoplay = u(this.option("Autoplay") || {}, {
	      pauseOnHover: !1,
	      autoStart: !1,
	      timeout: this.option("timeout"),
	      progressParentEl: () => i.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]") || i,
	      on: {
	        set: e => {
	          var n;
	          i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== V.Ready && e.pause();
	        },
	        stop: () => {
	          i.classList.remove("has-slideshow"), t.isCompact || t.endIdle();
	        },
	        resume: (e, i) => {
	          var n, s, o;
	          !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === V.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
	        }
	      }
	    }), e.attachPlugins({
	      Autoplay: nt
	    }), this.ref = e.plugins.Autoplay);
	  }

	  onReady(t) {
	    const e = t.carousel,
	          i = this.ref;
	    e && i && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
	  }

	  onDone(t, e) {
	    const i = this.ref;
	    if (!i) return;
	    const n = e.panzoom;
	    n && n.on("startAnimation", () => {
	      t.isCurrentSlide(e) && i.stop();
	    }), t.isCurrentSlide(e) && i.resume();
	  }

	  onKeydown(t, e) {
	    var i;
	    const n = this.ref;
	    n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
	  }

	  attach() {
	    this.instance.on("Carousel.init", this.onPrepare), this.instance.on("Carousel.ready", this.onReady), this.instance.on("done", this.onDone), this.instance.on("keydown", this.onKeydown);
	  }

	  detach() {
	    this.instance.off("Carousel.init", this.onPrepare), this.instance.off("Carousel.ready", this.onReady), this.instance.off("done", this.onDone), this.instance.off("keydown", this.onKeydown);
	  }

	}

	Object.defineProperty(st, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: {
	    key: " ",
	    playOnStart: !1,
	    timeout: 3e3
	  }
	});
	const ot = {
	  classes: {
	    container: "f-thumbs f-carousel__thumbs",
	    viewport: "f-thumbs__viewport",
	    track: "f-thumbs__track",
	    slide: "f-thumbs__slide",
	    isResting: "is-resting",
	    isSelected: "is-selected",
	    isLoading: "is-loading",
	    hasThumbs: "has-thumbs"
	  },
	  minCount: 2,
	  parentEl: null,
	  thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
	  type: "modern"
	};
	var at;
	!function (t) {
	  t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden", t[t.Disabled = 3] = "Disabled";
	}(at || (at = {}));
	let rt = class extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "type", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: "modern"
	    }), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "track", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "carousel", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "panzoom", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "thumbWidth", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "thumbClipWidth", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "thumbHeight", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "thumbGap", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "thumbExtraGap", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "shouldCenter", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !0
	    }), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: at.Init
	    });
	  }

	  formatThumb(t, e) {
	    return this.instance.localize(e, [["%i", t.index], ["%d", t.index + 1], ["%s", t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"]]);
	  }

	  getSlides() {
	    const t = [],
	          e = this.option("thumbTpl") || "";
	    if (e) for (const i of this.instance.slides || []) {
	      let n = "";
	      i.type && (n = `for-${i.type}`, i.type && ["video", "youtube", "vimeo", "html5video"].includes(i.type) && (n += " for-video")), t.push({
	        html: this.formatThumb(i, e),
	        customClass: n
	      });
	    }
	    return t;
	  }

	  onInitSlide(t, e) {
	    const i = e.el;
	    i && (e.thumbSrc = i.dataset.thumbSrc || e.thumbSrc || "", e.thumbClipWidth = parseFloat(i.dataset.thumbClipWidth || "") || e.thumbClipWidth || 0, e.thumbHeight = parseFloat(i.dataset.thumbHeight || "") || e.thumbHeight || 0);
	  }

	  onInitSlides() {
	    this.state === at.Init && this.build();
	  }

	  onRefreshM() {
	    this.refreshModern();
	  }

	  onChangeM() {
	    "modern" === this.type && (this.shouldCenter = !0, this.centerModern());
	  }

	  onClickModern(t) {
	    t.preventDefault(), t.stopPropagation();

	    const e = this.instance,
	          i = e.page,
	          n = t => {
	      if (t) {
	        const e = t.closest("[data-carousel-index]");
	        if (e) return parseInt(e.dataset.carouselIndex || "", 10) || 0;
	      }

	      return -1;
	    },
	          s = (t, e) => {
	      const i = document.elementFromPoint(t, e);
	      return i ? n(i) : -1;
	    };

	    let o = n(t.target);
	    o < 0 && (o = s(t.clientX + this.thumbGap, t.clientY), o === i && (o = i - 1)), o < 0 && (o = s(t.clientX - this.thumbGap, t.clientY), o === i && (o = i + 1)), o < 0 && (o = (e => {
	      let n = s(t.clientX - e, t.clientY),
	          a = s(t.clientX + e, t.clientY);
	      return o < 0 && n === i && (o = i + 1), o < 0 && a === i && (o = i - 1), o;
	    })(this.thumbExtraGap)), o === i ? this.centerModern() : o > -1 && o < e.pages.length && e.slideTo(o);
	  }

	  onTransformM() {
	    if ("modern" !== this.type) return;
	    const {
	      instance: t,
	      container: e,
	      track: i
	    } = this,
	          n = t.panzoom;
	    if (!(e && i && n && this.panzoom)) return;
	    o(e, this.cn("isResting"), n.state !== g.Init && n.isResting);
	    const s = this.thumbGap,
	          a = this.thumbExtraGap,
	          r = this.thumbClipWidth;
	    let l = 0,
	        c = 0,
	        h = 0;

	    for (const e of t.slides) {
	      let i = e.index,
	          n = e.thumbSlideEl;
	      if (!n) continue;
	      o(n, this.cn("isSelected"), i === t.page), c = 1 - Math.abs(t.getProgress(i)), n.style.setProperty("--progress", c ? c + "" : "");
	      const d = .5 * ((e.thumbWidth || 0) - r);
	      l += s, l += d, c && (l -= c * (d + a)), n.style.setProperty("--shift", l - s + ""), l += d, c && (l -= c * (d + a)), l -= s, 0 === i && (h = a * c);
	    }

	    i && (i.style.setProperty("--left", h + ""), i.style.setProperty("--width", l + h + s + a * c + "")), this.shouldCenter && this.centerModern();
	  }

	  buildClassic() {
	    const {
	      container: t,
	      track: e
	    } = this,
	          i = this.getSlides();
	    if (!t || !e || !i) return;
	    const n = new this.instance.constructor(t, u({
	      track: e,
	      infinite: !1,
	      center: !0,
	      fill: !0,
	      dragFree: !0,
	      slidesPerPage: 1,
	      transition: !1,
	      Dots: !1,
	      Navigation: !1,
	      Sync: {},
	      classes: {
	        container: "f-thumbs",
	        viewport: "f-thumbs__viewport",
	        track: "f-thumbs__track",
	        slide: "f-thumbs__slide"
	      }
	    }, this.option("Carousel") || {}, {
	      Sync: {
	        target: this.instance
	      },
	      slides: i
	    }));
	    this.carousel = n, this.track = e, n.on("ready", () => {
	      this.emit("ready");
	    });
	  }

	  buildModern() {
	    if ("modern" !== this.type) return;
	    const {
	      container: t,
	      track: e,
	      instance: i
	    } = this,
	          s = this.option("thumbTpl") || "";
	    if (!t || !e || !s) return;
	    S(t, "is-horizontal"), this.updateModern();

	    for (const t of i.slides || []) {
	      const i = document.createElement("div");

	      if (S(i, this.cn("slide")), t.type) {
	        let e = `for-${t.type}`;
	        ["video", "youtube", "vimeo", "html5video"].includes(t.type) && (e += " for-video"), S(i, e);
	      }

	      i.appendChild(n(this.formatThumb(t, s))), t.thumbSlideEl = i, e.appendChild(i), this.resizeModernSlide(t);
	    }

	    const o = new i.constructor.Panzoom(t, {
	      content: e,
	      lockAxis: "x",
	      zoom: !1,
	      panOnlyZoomed: !1,
	      bounds: () => {
	        let t = 0,
	            e = 0,
	            n = i.slides[0],
	            s = i.slides[i.slides.length - 1],
	            o = i.slides[i.page];
	        return n && s && o && (e = -1 * this.getModernThumbPos(0), 0 !== i.page && (e += .5 * (n.thumbWidth || 0)), t = -1 * this.getModernThumbPos(i.slides.length - 1), i.page !== i.slides.length - 1 && (t += (s.thumbWidth || 0) - (o.thumbWidth || 0) - .5 * (s.thumbWidth || 0))), {
	          x: {
	            min: t,
	            max: e
	          },
	          y: {
	            min: 0,
	            max: 0
	          }
	        };
	      }
	    });
	    o.on("touchStart", (t, e) => {
	      this.shouldCenter = !1;
	    }), o.on("click", (t, e) => this.onClickModern(e)), o.on("ready", () => {
	      this.centerModern(), this.emit("ready");
	    }), o.on(["afterTransform", "refresh"], t => {
	      this.lazyLoadModern();
	    }), this.panzoom = o, this.refreshModern();
	  }

	  updateModern() {
	    if ("modern" !== this.type) return;
	    const {
	      container: t
	    } = this;
	    t && (this.thumbGap = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-gap")) || 0, this.thumbExtraGap = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-extra-gap")) || 0, this.thumbWidth = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-width")) || 40, this.thumbClipWidth = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-clip-width")) || 40, this.thumbHeight = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-height")) || 40);
	  }

	  refreshModern() {
	    var t;

	    if ("modern" === this.type) {
	      this.updateModern();

	      for (const t of this.instance.slides || []) this.resizeModernSlide(t);

	      this.onTransformM(), null === (t = this.panzoom) || void 0 === t || t.updateMetrics(!0), this.centerModern(0);
	    }
	  }

	  centerModern(e) {
	    const i = this.instance,
	          {
	      container: n,
	      panzoom: s
	    } = this;
	    if (!n || !s || s.state === g.Init) return;
	    const o = i.page;
	    let a = this.getModernThumbPos(o),
	        r = a;

	    for (let t = i.page - 3; t < i.page + 3; t++) {
	      if (t < 0 || t > i.pages.length - 1 || t === i.page) continue;
	      const e = 1 - Math.abs(i.getProgress(t));
	      e > 0 && e < 1 && (r += e * (this.getModernThumbPos(t) - a));
	    }

	    let l = 100;
	    void 0 === e && (e = .2, i.inTransition.size > 0 && (e = .12), Math.abs(-1 * s.current.e - r) > s.containerRect.width && (e = .5, l = 0)), s.options.maxVelocity = l, s.applyChange({
	      panX: t(-1 * r - s.target.e, 1e3),
	      friction: null === i.prevPage ? 0 : e
	    });
	  }

	  lazyLoadModern() {
	    const {
	      instance: t,
	      panzoom: e
	    } = this;
	    if (!e) return;
	    const i = -1 * e.current.e || 0;
	    let s = this.getModernThumbPos(t.page);
	    if (e.state !== g.Init || 0 === s) for (const s of t.slides || []) {
	      const t = s.thumbSlideEl;
	      if (!t) continue;
	      const o = t.querySelector("img[data-lazy-src]"),
	            a = s.index,
	            r = this.getModernThumbPos(a),
	            l = i - .5 * e.containerRect.innerWidth,
	            c = l + e.containerRect.innerWidth;
	      if (!o || r < l || r > c) continue;
	      let h = o.dataset.lazySrc;
	      if (!h || !h.length) continue;
	      if (delete o.dataset.lazySrc, o.src = h, o.complete) continue;
	      S(t, this.cn("isLoading"));
	      const d = n(w);
	      t.appendChild(d), o.addEventListener("load", () => {
	        t.offsetParent && (t.classList.remove(this.cn("isLoading")), d.remove());
	      }, !1);
	    }
	  }

	  resizeModernSlide(t) {
	    if ("modern" !== this.type) return;
	    if (!t.thumbSlideEl) return;
	    const e = t.thumbClipWidth && t.thumbHeight ? Math.round(this.thumbHeight * (t.thumbClipWidth / t.thumbHeight)) : this.thumbWidth;
	    t.thumbWidth = e;
	  }

	  getModernThumbPos(e) {
	    const i = this.instance.slides[e],
	          n = this.panzoom;
	    if (!n || !n.contentRect.fitWidth) return 0;
	    let s = n.containerRect.innerWidth,
	        o = n.contentRect.width;
	    2 === this.instance.slides.length && (e -= 1, o = 2 * this.thumbClipWidth);
	    let a = e * (this.thumbClipWidth + this.thumbGap) + this.thumbExtraGap + .5 * (i.thumbWidth || 0);
	    return a -= o > s ? .5 * s : .5 * o, t(a || 0, 1);
	  }

	  build() {
	    const t = this.instance,
	          e = t.container,
	          i = this.option("minCount") || 0;

	    if (i) {
	      let e = 0;

	      for (const i of t.slides || []) i.thumbSrc && e++;

	      if (e < i) return this.cleanup(), void (this.state = at.Disabled);
	    }

	    const n = this.option("type");
	    if (["modern", "classic"].indexOf(n) < 0) return void (this.state = at.Disabled);
	    this.type = n;
	    const s = document.createElement("div");
	    S(s, this.cn("container")), S(s, `is-${n}`);
	    const o = this.option("parentEl");
	    o ? o.appendChild(s) : e.after(s), this.container = s, S(e, this.cn("hasThumbs"));
	    const a = document.createElement("div");
	    S(a, this.cn("track")), s.appendChild(a), this.track = a, "classic" === n ? this.buildClassic() : this.buildModern(), this.state = at.Ready, s.addEventListener("click", e => {
	      setTimeout(() => {
	        var e;
	        null === (e = null == s ? void 0 : s.querySelector(`[data-carousel-index="${t.page}"]`)) || void 0 === e || e.focus();
	      }, 100);
	    });
	  }

	  cleanup() {
	    this.carousel && this.carousel.destroy(), this.carousel = null, this.panzoom && this.panzoom.destroy(), this.panzoom = null, this.container && this.container.remove(), this.container = null, this.track = null, this.state = at.Init, E(this.instance.container, this.cn("hasThumbs"));
	  }

	  attach() {
	    const {
	      instance: t
	    } = this;
	    t.on("initSlide", this.onInitSlide), t.state === L.Init ? t.on("initSlides", this.onInitSlides) : this.onInitSlides(), t.on("Panzoom.afterTransform", this.onTransformM), t.on("Panzoom.refresh", this.onRefreshM), t.on("change", this.onChangeM);
	  }

	  detach() {
	    const {
	      instance: t
	    } = this;
	    t.off("initSlide", this.onInitSlide), t.off("initSlides", this.onInitSlides), t.off("Panzoom.afterTransform", this.onTransformM), t.off("Panzoom.refresh", this.onRefreshM), t.off("change", this.onChangeM), this.cleanup();
	  }

	};
	Object.defineProperty(rt, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: ot
	});
	const lt = Object.assign(Object.assign({}, ot), {
	  key: "t",
	  showOnStart: !0,
	  parentEl: null
	});

	class ct extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "ref", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "hidden", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    });
	  }

	  get isEnabled() {
	    const t = this.ref;
	    return t && t.state !== at.Disabled;
	  }

	  get isHidden() {
	    return this.hidden;
	  }

	  onInit() {
	    const t = this.instance,
	          e = t.carousel;
	    if (this.ref || !e) return;
	    const i = this.option("parentEl") || t.footer || t.container;
	    i && (e.options.Thumbs = u({}, this.options, {
	      parentEl: i,
	      classes: {
	        container: "f-thumbs fancybox__thumbs"
	      },
	      Carousel: {
	        Sync: {
	          friction: t.option("Carousel.friction")
	        },
	        on: {
	          click: (t, e) => {
	            e.stopPropagation();
	          }
	        }
	      },
	      on: {
	        ready: t => {
	          const e = t.container;
	          e && this.hidden && (this.refresh(), e.style.transition = "none", this.hide(), e.offsetHeight, queueMicrotask(() => {
	            e.style.transition = "", this.show();
	          }));
	        }
	      }
	    }), e.attachPlugins({
	      Thumbs: rt
	    }), this.ref = e.plugins.Thumbs, this.option("showOnStart") || (this.ref.state = at.Hidden, this.hidden = !0));
	  }

	  onResize() {
	    var t;
	    const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
	    e && (e.style.maxHeight = "");
	  }

	  onKeydown(t, e) {
	    const i = this.option("key");
	    i && i === e && this.toggle();
	  }

	  toggle() {
	    const t = this.ref;
	    t && t.state !== at.Disabled && (t.state !== at.Hidden ? this.hidden ? this.show() : this.hide() : t.build());
	  }

	  show() {
	    const t = this.ref,
	          e = t && t.state !== at.Disabled && t.container;
	    e && (this.refresh(), e.offsetHeight, e.removeAttribute("aria-hidden"), e.classList.remove("is-hidden"), this.hidden = !1);
	  }

	  hide() {
	    const t = this.ref,
	          e = t && t.container;
	    e && (this.refresh(), e.offsetHeight, e.classList.add("is-hidden"), e.setAttribute("aria-hidden", "true")), this.hidden = !0;
	  }

	  refresh() {
	    const t = this.ref;
	    if (!t || t.state === at.Disabled) return;
	    const e = t.container,
	          i = (null == e ? void 0 : e.firstChild) || null;
	    e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
	  }

	  attach() {
	    this.instance.state === Z.Init ? this.instance.on("Carousel.init", this.onInit) : this.onInit(), this.instance.on("resize", this.onResize), this.instance.on("keydown", this.onKeydown);
	  }

	  detach() {
	    var t;
	    this.instance.off("Carousel.init", this.onInit), this.instance.off("resize", this.onResize), this.instance.off("keydown", this.onKeydown), null === (t = this.instance.carousel) || void 0 === t || t.detachPlugins(["Thumbs"]), this.ref = null;
	  }

	}

	Object.defineProperty(ct, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: lt
	});
	const ht = {
	  panLeft: {
	    icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
	    change: {
	      panX: -100
	    }
	  },
	  panRight: {
	    icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
	    change: {
	      panX: 100
	    }
	  },
	  panUp: {
	    icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
	    change: {
	      panY: -100
	    }
	  },
	  panDown: {
	    icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
	    change: {
	      panY: 100
	    }
	  },
	  zoomIn: {
	    icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
	    action: "zoomIn"
	  },
	  zoomOut: {
	    icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
	    action: "zoomOut"
	  },
	  toggle1to1: {
	    icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
	    action: "toggleZoom"
	  },
	  toggleZoom: {
	    icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
	    action: "toggleZoom"
	  },
	  iterateZoom: {
	    icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
	    action: "iterateZoom"
	  },
	  rotateCCW: {
	    icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
	    action: "rotateCCW"
	  },
	  rotateCW: {
	    icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
	    action: "rotateCW"
	  },
	  flipX: {
	    icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
	    action: "flipX"
	  },
	  flipY: {
	    icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
	    action: "flipY"
	  },
	  fitX: {
	    icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
	    action: "fitX"
	  },
	  fitY: {
	    icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
	    action: "fitY"
	  },
	  reset: {
	    icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
	    action: "reset"
	  },
	  toggleFS: {
	    icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
	    action: "toggleFS"
	  }
	};
	var dt;
	!function (t) {
	  t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
	}(dt || (dt = {}));
	const ut = {
	  absolute: "auto",
	  display: {
	    left: ["infobar"],
	    middle: [],
	    right: ["iterateZoom", "slideshow", "fullscreen", "thumbs", "close"]
	  },
	  enabled: "auto",
	  items: {
	    infobar: {
	      tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
	    },
	    download: {
	      tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
	    },
	    prev: {
	      tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
	    },
	    next: {
	      tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
	    },
	    slideshow: {
	      tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
	    },
	    fullscreen: {
	      tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
	    },
	    thumbs: {
	      tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
	    },
	    close: {
	      tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
	    }
	  },
	  parentEl: null
	},
	      pt = {
	  tabindex: "-1",
	  width: "24",
	  height: "24",
	  viewBox: "0 0 24 24",
	  xmlns: "http://www.w3.org/2000/svg"
	};

	class ft extends I {
	  constructor() {
	    super(...arguments), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: dt.Init
	    }), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    });
	  }

	  onReady(t) {
	    var e;
	    if (!t.carousel) return;
	    let i = this.option("display"),
	        n = this.option("absolute"),
	        s = this.option("enabled");

	    if ("auto" === s) {
	      const t = this.instance.carousel;
	      let e = 0;
	      if (t) for (const i of t.slides) (i.panzoom || "image" === i.type) && e++;
	      e || (s = !1);
	    }

	    s || (i = void 0);
	    let o = 0;
	    const a = {
	      left: [],
	      middle: [],
	      right: []
	    };
	    if (i) for (const t of ["left", "middle", "right"]) for (const n of i[t]) {
	      const i = this.createEl(n);
	      i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
	    }
	    let r = null;

	    if (o && (r = this.createContainer()), r) {
	      for (const [t, e] of Object.entries(a)) {
	        const i = document.createElement("div");
	        S(i, "fancybox__toolbar__column is-" + t);

	        for (const t of e) i.appendChild(t);

	        "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
	      }

	      !0 === n && S(r, "is-absolute"), this.state = dt.Ready, this.onRefresh();
	    } else this.state = dt.Disabled;
	  }

	  onClick(t) {
	    var e, i;
	    const n = this.instance,
	          s = n.getSlide(),
	          o = null == s ? void 0 : s.panzoom,
	          a = t.target,
	          r = a && x(a) ? a.dataset : null;
	    if (!r) return;
	    if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
	    if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();

	    if (void 0 !== r.fancyboxToggleSlideshow) {
	      t.preventDefault(), t.stopPropagation();
	      const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
	      let s = e.isActive;
	      return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
	    }

	    const l = r.panzoomAction,
	          c = r.panzoomChange;

	    if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
	      let t = {};

	      try {
	        t = JSON.parse(c);
	      } catch (t) {}

	      o && o.applyChange(t);
	    } else l && o && o[l] && o[l]();
	  }

	  onChange() {
	    this.onRefresh();
	  }

	  onRefresh() {
	    if (this.instance.isClosing()) return;
	    const t = this.container;
	    if (!t) return;
	    const e = this.instance.getSlide();
	    if (!e || e.state !== V.Ready) return;
	    const i = e && !e.error && e.panzoom;

	    for (const e of t.querySelectorAll("[data-panzoom-action]")) i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));

	    let n = i && i.canZoomIn(),
	        s = i && i.canZoomOut();

	    for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]')) n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));

	    for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]')) s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));

	    for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')) {
	      s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
	      const t = e.querySelector("g");
	      t && (t.style.display = n ? "" : "none");
	    }
	  }

	  onDone(t, e) {
	    var i;
	    null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", () => {
	      this.instance.isCurrentSlide(e) && this.onRefresh();
	    }), this.instance.isCurrentSlide(e) && this.onRefresh();
	  }

	  createContainer() {
	    const t = this.instance.container;
	    if (!t) return null;
	    const e = this.option("parentEl") || t,
	          i = document.createElement("div");
	    return S(i, "fancybox__toolbar"), e.prepend(i), i.addEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !0
	    }), t && S(t, "has-toolbar"), this.container = i, i;
	  }

	  createEl(t) {
	    var e;
	    const i = this.instance.carousel;
	    if (!i) return null;
	    if ("toggleFS" === t) return null;
	    if ("fullscreen" === t && !this.instance.fsAPI) return null;
	    let s = null;
	    const o = i.slides.length || 0;
	    let a = 0,
	        r = 0;

	    for (const t of i.slides) (t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;

	    if (o < 2 && ["infobar", "prev", "next"].includes(t)) return s;
	    if (void 0 !== ht[t] && !a) return null;
	    if ("download" === t && !r) return null;

	    if ("thumbs" === t) {
	      const t = this.instance.plugins.Thumbs;
	      if (!t || !t.isEnabled) return null;
	    }

	    if ("slideshow" === t) {
	      if (!(null === (e = this.instance.carousel) || void 0 === e ? void 0 : e.plugins.Autoplay) || o < 2) return null;
	    }

	    if (void 0 !== ht[t]) {
	      const e = ht[t];
	      s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), S(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild(n(this.instance.localize(e.icon)));
	    } else {
	      const e = (this.option("items") || [])[t];
	      e && (s = n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", t => {
	        t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
	      }));
	    }

	    const l = null == s ? void 0 : s.querySelector("svg");
	    if (l) for (const [t, e] of Object.entries(pt)) l.getAttribute(t) || l.setAttribute(t, String(e));
	    return s;
	  }

	  removeContainer() {
	    const t = this.container;
	    t && t.remove(), this.container = null, this.state = dt.Disabled;
	    const e = this.instance.container;
	    e && E(e, "has-toolbar");
	  }

	  attach() {
	    const t = this,
	          {
	      instance: e
	    } = t;
	    e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on("reveal", t.onChange), e.on("Carousel.change", t.onChange), t.onReady(t.instance);
	  }

	  detach() {
	    const t = this,
	          {
	      instance: e
	    } = t;
	    e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off("reveal", t.onChange), e.off("Carousel.change", t.onChange), t.removeContainer();
	  }

	}

	Object.defineProperty(ft, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: ut
	});

	const mt = {
	  Hash: U,
	  Html: it,
	  Images: J,
	  Slideshow: st,
	  Thumbs: ct,
	  Toolbar: ft
	},
	      gt = function () {
	  var t = window.getSelection();
	  return t && "Range" === t.type;
	};

	let bt = null,
	    vt = null;
	const yt = new Map();
	let wt = 0;

	class xt extends m {
	  get isIdle() {
	    return this.idle;
	  }

	  get isCompact() {
	    return this.option("compact");
	  }

	  constructor(t = [], e = {}, i = {}) {
	    super(e), Object.defineProperty(this, "userSlides", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: []
	    }), Object.defineProperty(this, "userPlugins", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: {}
	    }), Object.defineProperty(this, "idle", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "idleTimer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "clickTimer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "pwt", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "ignoreFocusChange", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: !1
	    }), Object.defineProperty(this, "state", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: Z.Init
	    }), Object.defineProperty(this, "id", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: 0
	    }), Object.defineProperty(this, "container", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "footer", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "caption", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "carousel", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "lastFocus", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: null
	    }), Object.defineProperty(this, "prevMouseMoveEvent", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), Object.defineProperty(this, "fsAPI", {
	      enumerable: !0,
	      configurable: !0,
	      writable: !0,
	      value: void 0
	    }), this.fsAPI = (() => {
	      let t,
	          e = "",
	          i = "",
	          n = "";
	      return document.fullscreenEnabled ? (e = "requestFullscreen", i = "exitFullscreen", n = "fullscreenElement") : document.webkitFullscreenEnabled && (e = "webkitRequestFullscreen", i = "webkitExitFullscreen", n = "webkitFullscreenElement"), e && (t = {
	        request: function (t) {
	          return "webkitRequestFullscreen" === e ? t[e](Element.ALLOW_KEYBOARD_INPUT) : t[e]();
	        },
	        exit: function () {
	          return document[n] && document[i]();
	        },
	        isFullscreen: function () {
	          return document[n];
	        }
	      }), t;
	    })(), this.id = e.id || ++wt, yt.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(() => {
	      this.init();
	    });
	  }

	  init() {
	    if (this.state === Z.Destroy) return;
	    this.state = Z.Init, this.attachPlugins(Object.assign(Object.assign({}, xt.Plugins), this.userPlugins)), this.emit("init"), !0 === this.option("hideScrollbar") && (() => {
	      if (!W) return;
	      const t = document.body;
	      if (t.classList.contains("hide-scrollbar")) return;
	      const e = window.innerWidth - document.documentElement.getBoundingClientRect().width,
	            i = t.currentStyle || window.getComputedStyle(t),
	            n = parseFloat(i.marginRight);
	      document.documentElement.style.setProperty("--fancybox-scrollbar-compensate", `${e}px`), n && t.style.setProperty("--fancybox-body-margin", `${n}px`), t.classList.add("hide-scrollbar");
	    })(), this.initLayout();

	    const t = () => {
	      this.initCarousel(this.userSlides), this.state = Z.Ready, this.attachEvents(), this.emit("ready"), setTimeout(() => {
	        this.container && this.container.setAttribute("aria-hidden", "false");
	      }, 16);
	    };

	    this.option("Fullscreen.autoStart") && this.fsAPI && !this.fsAPI.isFullscreen() ? this.fsAPI.request(this.container).then(() => t()).catch(() => t()) : t();
	  }

	  initLayout() {
	    var t, e;
	    const i = this.option("parentEl") || document.body,
	          s = n(this.localize(this.option("tpl.main") || ""));
	    s && (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle("is-compact", this.isCompact), S(s, this.option("mainClass") || ""), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), S(document.documentElement, "with-fancybox"), bt && vt || (bt = document.createElement("span"), S(bt, "fancybox-focus-guard"), bt.setAttribute("tabindex", "0"), bt.setAttribute("aria-hidden", "true"), bt.setAttribute("aria-label", "Focus guard"), vt = bt.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore(bt, s), null === (e = s.parentElement) || void 0 === e || e.append(vt)), this.option("animated") && (S(s, "is-animated"), setTimeout(() => {
	      this.isClosing() || E(s, "is-animated");
	    }, 350)), this.emit("initLayout"));
	  }

	  initCarousel(t) {
	    const i = this.container;
	    if (!i) return;
	    const n = i.querySelector(".fancybox__carousel");
	    if (!n) return;
	    const s = this.carousel = new _(n, u({}, {
	      slides: t,
	      transition: "fade",
	      Panzoom: {
	        lockAxis: this.option("dragToClose") ? "xy" : "x",
	        infinite: !!this.option("dragToClose") && "y"
	      },
	      Dots: !1,
	      Navigation: {
	        classes: {
	          container: "fancybox__nav",
	          button: "f-button",
	          isNext: "is-next",
	          isPrev: "is-prev"
	        }
	      },
	      initialPage: this.option("startIndex"),
	      l10n: this.option("l10n")
	    }, this.option("Carousel") || {}));
	    s.on("*", (t, e, ...i) => {
	      this.emit(`Carousel.${e}`, t, ...i);
	    }), s.on(["ready", "change"], () => {
	      var t;
	      const e = this.getSlide();
	      e && (null === (t = e.panzoom) || void 0 === t || t.updateControls()), this.manageCaption(e);
	    }), s.on("removeSlide", (t, e) => {
	      e.closeBtnEl && e.closeBtnEl.remove(), e.closeBtnEl = void 0, e.captionEl && e.captionEl.remove(), e.captionEl = void 0, e.spinnerEl && e.spinnerEl.remove(), e.spinnerEl = void 0, e.state = void 0;
	    }), s.on("Panzoom.touchStart", () => {
	      this.isCompact || this.endIdle();
	    }), s.on("settle", () => {
	      this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && this.checkFocus();
	    }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i) => {
	      const n = this.getSlide();
	      if (n && e(n.el)) return;
	      const s = this.container;

	      if (s) {
	        const t = Math.abs(i.current.f),
	              e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
	        s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
	      }
	    }), s.on("Panzoom.touchEnd", (t, i, n) => {
	      var s;
	      const o = this.getSlide();
	      if (o && e(o.el)) return;
	      if (i.isMobile && document.activeElement && -1 !== ["TEXTAREA", "INPUT"].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
	      const a = Math.abs(i.dragOffset.y);
	      "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
	    })), s.on(["change"], t => {
	      var e;
	      let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;

	      if (i) {
	        const e = new CustomEvent("slideTo", {
	          bubbles: !0,
	          cancelable: !0,
	          detail: t.page
	        });
	        i.dispatchEvent(e);
	      }
	    }), s.on(["refresh", "change"], t => {
	      const e = this.container;
	      if (!e) return;

	      for (const i of e.querySelectorAll("[data-fancybox-current-index]")) i.innerHTML = t.page + 1;

	      for (const i of e.querySelectorAll("[data-fancybox-count]")) i.innerHTML = t.pages.length;

	      if (!t.isInfinite) {
	        for (const i of e.querySelectorAll("[data-fancybox-next]")) t.page < t.pages.length - 1 ? (i.removeAttribute("disabled"), i.removeAttribute("tabindex")) : (i.setAttribute("disabled", ""), i.setAttribute("tabindex", "-1"));

	        for (const i of e.querySelectorAll("[data-fancybox-prev]")) t.page > 0 ? (i.removeAttribute("disabled"), i.removeAttribute("tabindex")) : (i.setAttribute("disabled", ""), i.setAttribute("tabindex", "-1"));
	      }

	      const i = this.getSlide();
	      if (!i) return;
	      let n = i.downloadSrc || "";
	      n || "image" !== i.type || i.error || "string" != typeof i.src || (n = i.src);

	      for (const t of e.querySelectorAll("[data-fancybox-download]")) {
	        const e = i.downloadFilename;
	        n ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex"), t.setAttribute("href", n), t.setAttribute("download", e || n), t.setAttribute("target", "_blank")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"), t.removeAttribute("href"), t.removeAttribute("download"));
	      }
	    }), this.emit("initCarousel");
	  }

	  attachEvents() {
	    const t = this.container;
	    t && (t.addEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), t.addEventListener("wheel", this.onWheel, {
	      passive: !1,
	      capture: !1
	    }), document.addEventListener("keydown", this.onKeydown, {
	      passive: !1,
	      capture: !0
	    }), document.addEventListener("visibilitychange", this.onVisibilityChange, !1), document.addEventListener("mousemove", this.onMousemove), this.option("trapFocus") && document.addEventListener("focus", this.onFocus, !0), window.addEventListener("resize", this.onResize));
	  }

	  detachEvents() {
	    const t = this.container;
	    t && (document.removeEventListener("keydown", this.onKeydown, {
	      passive: !1,
	      capture: !0
	    }), t.removeEventListener("wheel", this.onWheel, {
	      passive: !1,
	      capture: !1
	    }), t.removeEventListener("click", this.onClick, {
	      passive: !1,
	      capture: !1
	    }), document.removeEventListener("mousemove", this.onMousemove), window.removeEventListener("resize", this.onResize), document.removeEventListener("visibilitychange", this.onVisibilityChange, !1), document.removeEventListener("focus", this.onFocus, !0));
	  }

	  onClick(t) {
	    var e, i;
	    const {
	      container: n,
	      isCompact: s
	    } = this;
	    if (!n || this.isClosing()) return;
	    !s && this.option("idle") && this.resetIdle();
	    const o = document.activeElement;
	    if (gt() && o && n.contains(o)) return;
	    const a = t.composedPath()[0];
	    if (a === (null === (e = this.carousel) || void 0 === e ? void 0 : e.container)) return;
	    if (a.closest(".f-spinner") || a.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
	    if (a.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
	    if (a.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
	    if (s && "image" === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(() => {
	      this.toggleIdle(), this.clickTimer = null;
	    }, 350));
	    if (this.emit("click", t), t.defaultPrevented) return;
	    let r = !1;

	    if (a.closest(".fancybox__content")) {
	      if (o) {
	        if (o.closest("[contenteditable]")) return;
	        a.matches(X) || o.blur();
	      }

	      if (gt()) return;
	      r = this.option("contentClick");
	    } else a.closest(".fancybox__carousel") && !a.matches(X) && (r = this.option("backdropClick"));

	    "close" === r ? (t.preventDefault(), this.close(t)) : "next" === r ? (t.preventDefault(), this.next()) : "prev" === r && (t.preventDefault(), this.prev());
	  }

	  onWheel(t) {
	    const e = this.option("wheel", t),
	          i = "slide" === e,
	          n = [-t.deltaX || 0, -t.deltaY || 0, -t.detail || 0].reduce(function (t, e) {
	      return Math.abs(e) > Math.abs(t) ? e : t;
	    }),
	          s = Math.max(-1, Math.min(1, n)),
	          o = Date.now();
	    this.pwt && o - this.pwt < 300 ? i && t.preventDefault() : (this.pwt = o, this.emit("wheel", t), t.defaultPrevented || ("close" === e ? (t.preventDefault(), this.close(t)) : "slide" === e && (t.preventDefault(), this[s > 0 ? "prev" : "next"]())));
	  }

	  onKeydown(t) {
	    if (!this.isTopmost()) return;
	    this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
	    const e = t.key,
	          i = this.option("keyboard");
	    if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
	    const n = t.composedPath()[0],
	          s = document.activeElement && document.activeElement.classList,
	          o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;

	    if ("Escape" !== e && !o && x(n)) {
	      if (n.isContentEditable || -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(n.nodeName)) return;
	    }

	    this.emit("keydown", e, t);
	    const a = i[e];
	    "function" == typeof this[a] && (t.preventDefault(), this[a]());
	  }

	  onResize() {
	    const t = this.container;
	    if (!t) return;
	    const e = this.isCompact;
	    t.classList.toggle("is-compact", e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.emit("resize");
	  }

	  onFocus(t) {
	    this.isTopmost() && this.checkFocus(t);
	  }

	  onMousemove(t) {
	    this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
	  }

	  onVisibilityChange() {
	    "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
	  }

	  manageCloseBtn(t) {
	    const e = this.optionFor(t, "closeButton") || !1;

	    if ("auto" === e) {
	      const t = this.plugins.Toolbar;
	      if (t && t.state === dt.Ready) return;
	    }

	    if (!e) return;
	    if (!t.contentEl || t.closeBtnEl) return;
	    const i = this.option("tpl.closeButton");

	    if (i) {
	      const e = n(this.localize(i));
	      t.closeBtnEl = t.contentEl.appendChild(e), t.el && S(t.el, "has-close-btn");
	    }
	  }

	  manageCaption(t) {
	    var e, i;
	    const n = "fancybox__caption",
	          s = "has-caption",
	          o = this.container;
	    if (!o) return;
	    const a = this.isCompact || this.option("commonCaption"),
	          r = !a;
	    if (this.caption && this.stop(this.caption), r && this.caption && (this.caption.remove(), this.caption = null), a && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || []) t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, E(t.el, s), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
	    if (t || (t = this.getSlide()), !t || a && !this.isCurrentSlide(t)) return;
	    const l = t.el;
	    let c = this.optionFor(t, "caption", "");
	    if ("string" != typeof c || !c.length) return void (a && this.caption && this.animate(this.caption, "f-fadeOut", () => {
	      var t;
	      null === (t = this.caption) || void 0 === t || t.remove(), this.caption = null;
	    }));
	    let h = null;

	    if (r) {
	      if (h = t.captionEl || null, l && !h) {
	        const e = `fancybox__caption_${this.id}_${t.index}`;
	        h = document.createElement("div"), S(h, n), h.setAttribute("id", e), t.captionEl = l.appendChild(h), S(l, s), l.setAttribute("aria-labelledby", e);
	      }
	    } else {
	      if (h = this.caption, h || (h = o.querySelector("." + n)), !h) {
	        h = document.createElement("div"), h.dataset.fancyboxCaption = "", S(h, n), h.innerHTML = c;
	        (this.footer || o).prepend(h);
	      }

	      S(o, s), this.caption = h;
	    }

	    h && (h.innerHTML = c);
	  }

	  checkFocus(t) {
	    var e;
	    const i = document.activeElement || null;
	    i && (null === (e = this.container) || void 0 === e ? void 0 : e.contains(i)) || this.focus(t);
	  }

	  focus(t) {
	    var e;
	    if (this.ignoreFocusChange) return;
	    const i = document.activeElement || null,
	          n = (null == t ? void 0 : t.target) || null,
	          s = this.container,
	          o = this.getSlide();
	    if (!s || !(null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport)) return;
	    if (!t && i && s.contains(i)) return;
	    const a = o && o.state === V.Ready ? o.el : null;
	    if (!a || a.contains(i) || s === i) return;
	    t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
	    const r = Array.from(s.querySelectorAll(X));
	    let l = [],
	        c = null;

	    for (let t of r) {
	      const e = !t.offsetParent || t.closest('[aria-hidden="true"]'),
	            i = a && a.contains(t),
	            n = !this.carousel.viewport.contains(t);
	      t === s || (i || n) && !e ? (l.push(t), void 0 !== t.dataset.origTabindex && (t.tabIndex = parseFloat(t.dataset.origTabindex)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && c || (c = t)) : (t.dataset.origTabindex = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || void 0 : t.dataset.origTabindex, t.tabIndex = -1);
	    }

	    let h = null;
	    t ? (!n || l.indexOf(n) < 0) && (h = c || s, l.length && (i === vt ? h = l[0] : this.lastFocus !== s && i !== bt || (h = l[l.length - 1]))) : h = o && "image" === o.type ? s : c || s, h && Y(h), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
	  }

	  next() {
	    const t = this.carousel;
	    t && t.pages.length > 1 && t.slideNext();
	  }

	  prev() {
	    const t = this.carousel;
	    t && t.pages.length > 1 && t.slidePrev();
	  }

	  jumpTo(...t) {
	    this.carousel && this.carousel.slideTo(...t);
	  }

	  isTopmost() {
	    var t;
	    return (null === (t = xt.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
	  }

	  animate(t = null, e = "", i) {
	    if (!t || !e) return void (i && i());
	    this.stop(t);

	    const n = s => {
	      s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), E(t, e));
	    };

	    t.dataset.animationName = e, t.addEventListener("animationend", n), S(t, e);
	  }

	  stop(t) {
	    t && t.dispatchEvent(new CustomEvent("animationend", {
	      bubbles: !1,
	      cancelable: !0,
	      currentTarget: t
	    }));
	  }

	  setContent(t, e = "", i = !0) {
	    if (this.isClosing()) return;
	    const s = t.el;
	    if (!s) return;
	    let o = null;

	    if (x(e) ? o = e : (o = n(e + ""), x(o) || (o = document.createElement("div"), o.innerHTML = e + "")), ["img", "picture", "iframe", "video", "audio"].includes(o.nodeName.toLowerCase())) {
	      const t = document.createElement("div");
	      t.appendChild(o), o = t;
	    }

	    x(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && x(o) ? (S(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), "none" !== o.style.display && "none" !== getComputedStyle(o).getPropertyValue("display") || (o.style.display = t.display || this.option("defaultDisplay") || "flex"), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
	  }

	  revealContent(t, e) {
	    const i = t.el,
	          n = t.contentEl;
	    i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = V.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, () => {
	      this.done(t);
	    }) : this.done(t));
	  }

	  done(t) {
	    this.isClosing() || (t.state = V.Ready, this.emit("done", t), S(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(() => {
	      this.option("autoFocus") && (this.option("autoFocus") ? this.focus() : this.checkFocus());
	    }), this.isOpeningSlide(t) && !this.isCompact && this.option("idle") && this.setIdle());
	  }

	  isCurrentSlide(t) {
	    const e = this.getSlide();
	    return !(!t || !e) && e.index === t.index;
	  }

	  isOpeningSlide(t) {
	    var e, i;
	    return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
	  }

	  showLoading(t) {
	    t.state = V.Loading;
	    const e = t.el;
	    if (!e) return;
	    S(e, "is-loading"), this.emit("loading", t), t.spinnerEl || setTimeout(() => {
	      if (!this.isClosing() && !t.spinnerEl && t.state === V.Loading) {
	        let i = n(w);
	        t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
	      }
	    }, 250);
	  }

	  hideLoading(t) {
	    const e = t.el;
	    if (!e) return;
	    const i = t.spinnerEl;
	    this.isClosing() ? null == i || i.remove() : (E(e, "is-loading"), i && this.animate(i, "f-fadeOut", () => {
	      i.remove();
	    }), t.state === V.Loading && (this.emit("loaded", t), t.state = V.Ready));
	  }

	  setError(t, e) {
	    if (this.isClosing()) return;
	    this.emit("error"), t.error = e, this.hideLoading(t), this.clearContent(t);
	    const i = document.createElement("div");
	    i.classList.add("fancybox-error"), i.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, i);
	  }

	  clearContent(t) {
	    var e;
	    null === (e = this.carousel) || void 0 === e || e.emit("removeSlide", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0), t.closeBtnEl && (t.closeBtnEl.remove(), t.closeBtnEl = void 0);
	    const i = t.el;
	    i && (E(i, "is-loading"), E(i, "has-error"), E(i, "has-unknown"), E(i, `has-${t.type || "unknown"}`));
	  }

	  getSlide() {
	    var t;
	    const e = this.carousel;
	    return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
	  }

	  close(t, e) {
	    if (this.isClosing()) return;
	    const i = new Event("shouldClose", {
	      bubbles: !0,
	      cancelable: !0
	    });
	    if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
	    t && t.cancelable && (t.preventDefault(), t.stopPropagation());

	    const n = this.fsAPI,
	          s = () => {
	      this.proceedClose(t, e);
	    };

	    n && n.isFullscreen() ? Promise.resolve(n.exit()).then(() => s()) : s();
	  }

	  clearIdle() {
	    this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
	  }

	  setIdle(t = !1) {
	    const e = () => {
	      this.clearIdle(), this.idle = !0, S(this.container, "is-idle"), this.emit("setIdle");
	    };

	    if (this.clearIdle(), !this.isClosing()) if (t) e();else {
	      const t = this.option("idle");
	      t && (this.idleTimer = setTimeout(e, t));
	    }
	  }

	  endIdle() {
	    this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, E(this.container, "is-idle"), this.emit("endIdle"));
	  }

	  resetIdle() {
	    this.endIdle(), this.setIdle();
	  }

	  toggleIdle() {
	    this.idle ? this.endIdle() : this.setIdle(!0);
	  }

	  toggleFullscreen() {
	    const t = this.fsAPI;
	    t && (t.isFullscreen() ? t.exit() : this.container && t.request(this.container));
	  }

	  isClosing() {
	    return [Z.Closing, Z.CustomClosing, Z.Destroy].includes(this.state);
	  }

	  proceedClose(t, e) {
	    var i;
	    this.state = Z.Closing, this.clearIdle(), this.detachEvents();
	    const n = this.container,
	          s = this.carousel,
	          o = this.getSlide(),
	          a = o && this.option("placeFocusBack") ? o.triggerEl || this.option("trigger") : null;

	    if (a && (N(a) ? Y(a) : a.focus()), n && (S(n, "is-closing"), n.setAttribute("aria-hidden", "true"), this.option("animated") && S(n, "is-animated"), n.style.pointerEvents = "none"), s) {
	      s.clearTransitions(), null === (i = s.panzoom) || void 0 === i || i.destroy();

	      for (const t of s.slides) {
	        t.state = V.Closing, this.hideLoading(t);
	        const e = t.contentEl;
	        e && this.stop(e);
	        const i = null == t ? void 0 : t.panzoom;
	        i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || s.emit("removeSlide", t);
	      }
	    }

	    this.emit("close", t), this.state !== Z.CustomClosing ? (void 0 === e && o && (e = this.optionFor(o, "hideClass")), e && o ? (this.animate(o.contentEl, e, () => {
	      s && s.emit("removeSlide", o);
	    }), setTimeout(() => {
	      this.destroy();
	    }, 500)) : this.destroy()) : setTimeout(() => {
	      this.destroy();
	    }, 500);
	  }

	  destroy() {
	    var t;
	    if (this.state === Z.Destroy) return;
	    this.state = Z.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
	    const e = this.container;
	    e && e.remove(), yt.delete(this.id);
	    const i = xt.getInstance();
	    i ? i.focus() : (bt && (bt.remove(), bt = null), vt && (vt.remove(), vt = null), E(document.documentElement, "with-fancybox"), (() => {
	      if (!W) return;
	      const t = document,
	            e = t.body;
	      e.classList.remove("hide-scrollbar"), e.style.setProperty("--fancybox-body-margin", ""), t.documentElement.style.setProperty("--fancybox-scrollbar-compensate", "");
	    })(), this.emit("destroy"));
	  }

	  static bind(t, e, i) {
	    if (!W) return;
	    let n,
	        s = "",
	        o = {};
	    if (void 0 === t ? n = document.body : "string" == typeof t ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, "string" == typeof e && (s = e), "object" == typeof i && (o = i || {})), !n || !x(n)) return;
	    s = s || "[data-fancybox]";
	    const a = xt.openers.get(n) || new Map();
	    a.set(s, o), xt.openers.set(n, a), 1 === a.size && n.addEventListener("click", xt.fromEvent);
	  }

	  static unbind(t, e) {
	    let i,
	        n = "";
	    if ("string" == typeof t ? (i = document.body, n = t) : (i = t, "string" == typeof e && (n = e)), !i) return;
	    const s = xt.openers.get(i);
	    s && n && s.delete(n), n && s || (xt.openers.delete(i), i.removeEventListener("click", xt.fromEvent));
	  }

	  static destroy() {
	    let t;

	    for (; t = xt.getInstance();) t.destroy();

	    for (const t of xt.openers.keys()) t.removeEventListener("click", xt.fromEvent);

	    xt.openers = new Map();
	  }

	  static fromEvent(t) {
	    if (t.defaultPrevented) return;
	    if (t.button && 0 !== t.button) return;
	    if (t.ctrlKey || t.metaKey || t.shiftKey) return;
	    let e = t.composedPath()[0];
	    const i = e.closest("[data-fancybox-trigger]");

	    if (i) {
	      const t = i.dataset.fancyboxTrigger || "",
	            n = document.querySelectorAll(`[data-fancybox="${t}"]`),
	            s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
	      e = n[s] || e;
	    }

	    if (!(e && e instanceof Element)) return;
	    let n, s, o, a;
	    if ([...xt.openers].reverse().find(([t, i]) => !(!t.contains(e) || ![...i].reverse().find(([i, r]) => {
	      let l = e.closest(i);
	      return !!l && (n = t, s = i, o = l, a = r, !0);
	    }))), !n || !s || !o) return;
	    a = a || {}, t.preventDefault(), e = o;
	    let r = [],
	        l = u({}, q, a);
	    l.event = t, l.trigger = e, l.delegate = i;
	    const c = l.groupAll,
	          h = l.groupAttr,
	          d = h && e ? e.getAttribute(`${h}`) : "";
	    if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter(t => t.getAttribute(`${h}`) === d) : [e]), !r.length) return;
	    const p = xt.getInstance();
	    return p && p.options.trigger && r.indexOf(p.options.trigger) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), xt.fromNodes(r, l));
	  }

	  static fromSelector(t, e) {
	    let i = null,
	        n = "";
	    if ("string" == typeof t ? (i = document.body, n = t) : t instanceof HTMLElement && "string" == typeof e && (i = t, n = e), !i || !n) return !1;
	    const s = xt.openers.get(i);
	    if (!s) return !1;
	    const o = s.get(n);
	    return !!o && xt.fromNodes(Array.from(i.querySelectorAll(n)), o);
	  }

	  static fromNodes(t, e) {
	    e = u({}, q, e);
	    const i = [];

	    for (const n of t) {
	      const t = n.dataset || {},
	            s = t.src || n.getAttribute("href") || n.getAttribute("currentSrc") || n.getAttribute("src") || void 0;
	      let o;
	      const a = e.delegate;
	      let r;
	      a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o.src || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset.src || void 0));
	      const l = {
	        src: s,
	        triggerEl: n,
	        thumbEl: o,
	        thumbElSrc: r,
	        thumbSrc: r
	      };

	      for (const e in t) "fancybox" !== e && (l[e] = t[e] + "");

	      i.push(l);
	    }

	    return new xt(i, e);
	  }

	  static getInstance(t) {
	    if (t) return yt.get(t);
	    return Array.from(yt.values()).reverse().find(t => !t.isClosing() && t) || null;
	  }

	  static getSlide() {
	    var t;
	    return (null === (t = xt.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
	  }

	  static show(t = [], e = {}) {
	    return new xt(t, e);
	  }

	  static next() {
	    const t = xt.getInstance();
	    t && t.next();
	  }

	  static prev() {
	    const t = xt.getInstance();
	    t && t.prev();
	  }

	  static close(t = !0, ...e) {
	    if (t) for (const t of yt.values()) t.close(...e);else {
	      const t = xt.getInstance();
	      t && t.close(...e);
	    }
	  }

	}

	Object.defineProperty(xt, "version", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: "5.0.15"
	}), Object.defineProperty(xt, "defaults", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: q
	}), Object.defineProperty(xt, "Plugins", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: mt
	}), Object.defineProperty(xt, "openers", {
	  enumerable: !0,
	  configurable: !0,
	  writable: !0,
	  value: new Map()
	});

	const globalJS = {
	  autoFillNoImage: image => {
	    if ($(image).attr("src") === undefined) {
	      $(image).attr("src", "/no-image.svg");
	      $(image).addClass("noImage");
	    }
	  },
	  autoAppend: () => {
	    var appendId = $("[id*='autoAppend-']");
	    appendId.each(function (e) {
	      var id = $(this).attr("id").slice(11); // console.log(id);

	      $(this).appendTo("[id*='autoAppendHere-" + id + "']");
	      var curHeight = $(this).get(0).scrollHeight;
	    });
	  },
	  autoClone: () => {
	    var cloneId = $("[id*='autoClone-']");
	    cloneId.each(function (e) {
	      var id = $(this).attr("id").slice(10); // console.log(id);

	      $(this).clone().appendTo("[id*='autoCloneHere-" + id + "']");
	    });
	  },
	  setBackground: () => {
	    var position = ["", "top", "left", "right", "bottom"];
	    jQuery.each(position, function (index, item) {
	      //
	      //
	      $(`[setBackground${item}]`).each(function () {
	        var background = $(this).attr("setBackground" + item);
	        $(this).css({
	          "background-size": "cover",
	          "background-position": `${item} center`,
	          "background-image": `url(${background})`
	        });
	      });
	    });
	  },
	  scrollToTop: () => {
	    $(window).on("scroll", function () {
	      if ($(this).scrollTop() >= $("header").outerHeight() * 3) {
	        $("#scrollToTop").addClass("active");
	      } else {
	        $("#scrollToTop").removeClass("active");
	      }
	    });
	    $("#scrollToTop").on("click", function () {
	      $("html,body").animate({
	        scrollTop: 0
	      });
	    });
	  },
	  checkListItem: () => {
	    $("main ul").each(function () {
	      $(this).addClass("list-item-added");
	    });
	  },
	  inputButtonSubmit: () => {
	    $("input[type='submit']").each(function () {
	      if ($(this).parent().is(".btn") && $(this).parent().not(".has-input-submit")) {
	        //
	        $(this).parent().addClass("has-input-submit");
	        $(this).parent().attr("data-title", $(this).val());
	      }
	    });
	  },
	  init: () => {
	    globalJS.autoFillNoImage();
	    globalJS.autoAppend();
	    globalJS.autoClone();
	    globalJS.setBackground();
	    globalJS.scrollToTop();
	    globalJS.inputButtonSubmit();
	    globalJS.checkListItem();
	  }
	};

	/**
	 * SSR Window 4.0.2
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2021, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: December 13, 2021
	 */

	/* eslint-disable no-param-reassign */
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
	}

	function extend(target = {}, src = {}) {
	  Object.keys(src).forEach(key => {
	    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
	      extend(target[key], src[key]);
	    }
	  });
	}

	const ssrDocument = {
	  body: {},

	  addEventListener() {},

	  removeEventListener() {},

	  activeElement: {
	    blur() {},

	    nodeName: ''
	  },

	  querySelector() {
	    return null;
	  },

	  querySelectorAll() {
	    return [];
	  },

	  getElementById() {
	    return null;
	  },

	  createEvent() {
	    return {
	      initEvent() {}

	    };
	  },

	  createElement() {
	    return {
	      children: [],
	      childNodes: [],
	      style: {},

	      setAttribute() {},

	      getElementsByTagName() {
	        return [];
	      }

	    };
	  },

	  createElementNS() {
	    return {};
	  },

	  importNode() {
	    return null;
	  },

	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  }
	};

	function getDocument() {
	  const doc = typeof document !== 'undefined' ? document : {};
	  extend(doc, ssrDocument);
	  return doc;
	}

	const ssrWindow = {
	  document: ssrDocument,
	  navigator: {
	    userAgent: ''
	  },
	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  },
	  history: {
	    replaceState() {},

	    pushState() {},

	    go() {},

	    back() {}

	  },
	  CustomEvent: function CustomEvent() {
	    return this;
	  },

	  addEventListener() {},

	  removeEventListener() {},

	  getComputedStyle() {
	    return {
	      getPropertyValue() {
	        return '';
	      }

	    };
	  },

	  Image() {},

	  Date() {},

	  screen: {},

	  setTimeout() {},

	  clearTimeout() {},

	  matchMedia() {
	    return {};
	  },

	  requestAnimationFrame(callback) {
	    if (typeof setTimeout === 'undefined') {
	      callback();
	      return null;
	    }

	    return setTimeout(callback, 0);
	  },

	  cancelAnimationFrame(id) {
	    if (typeof setTimeout === 'undefined') {
	      return;
	    }

	    clearTimeout(id);
	  }

	};

	function getWindow() {
	  const win = typeof window !== 'undefined' ? window : {};
	  extend(win, ssrWindow);
	  return win;
	}

	/**
	 * Dom7 4.0.4
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2022, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: January 11, 2022
	 */
	/* eslint-disable no-proto */

	function makeReactive(obj) {
	  const proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get() {
	      return proto;
	    },

	    set(value) {
	      proto.__proto__ = value;
	    }

	  });
	}

	class Dom7 extends Array {
	  constructor(items) {
	    if (typeof items === 'number') {
	      super(items);
	    } else {
	      super(...(items || []));
	      makeReactive(this);
	    }
	  }

	}

	function arrayFlat(arr = []) {
	  const res = [];
	  arr.forEach(el => {
	    if (Array.isArray(el)) {
	      res.push(...arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}

	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}

	function arrayUnique(arr) {
	  const uniqueArray = [];

	  for (let i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }

	  return uniqueArray;
	}


	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }

	  const a = [];
	  const res = context.querySelectorAll(selector);

	  for (let i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }

	  return a;
	}

	function $$2(selector, context) {
	  const window = getWindow();
	  const document = getDocument();
	  let arr = [];

	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }

	  if (!selector) {
	    return new Dom7(arr);
	  }

	  if (typeof selector === 'string') {
	    const html = selector.trim();

	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      let toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      const tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;

	      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);

	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }

	  return new Dom7(arrayUnique(arr));
	}

	$$2.fn = Dom7.prototype; // eslint-disable-next-line

	function addClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    el.classList.add(...classNames);
	  });
	  return this;
	}

	function removeClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    el.classList.remove(...classNames);
	  });
	  return this;
	}

	function toggleClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    classNames.forEach(className => {
	      el.classList.toggle(className);
	    });
	  });
	}

	function hasClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  return arrayFilter(this, el => {
	    return classNames.filter(className => el.classList.contains(className)).length > 0;
	  }).length > 0;
	}

	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs


	  for (let i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (const attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }

	  return this;
	}

	function removeAttr(attr) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }

	  return this;
	}

	function transform(transform) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].style.transform = transform;
	  }

	  return this;
	}

	function transition(duration) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
	  }

	  return this;
	}

	function on(...args) {
	  let [eventType, targetSelector, listener, capture] = args;

	  if (typeof args[1] === 'function') {
	    [eventType, listener, capture] = args;
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;

	  function handleLiveEvent(e) {
	    const target = e.target;
	    if (!target) return;
	    const eventData = e.target.dom7EventData || [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    if ($$2(target).is(targetSelector)) listener.apply(target, eventData);else {
	      const parents = $$2(target).parents(); // eslint-disable-line

	      for (let k = 0; k < parents.length; k += 1) {
	        if ($$2(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
	      }
	    }
	  }

	  function handleEvent(e) {
	    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }

	    listener.apply(this, eventData);
	  }

	  const events = eventType.split(' ');
	  let j;

	  for (let i = 0; i < this.length; i += 1) {
	    const el = this[i];

	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        const event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        const event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
	        el.dom7LiveListeners[event].push({
	          listener,
	          proxyListener: handleLiveEvent
	        });
	        el.addEventListener(event, handleLiveEvent, capture);
	      }
	    }
	  }

	  return this;
	}

	function off(...args) {
	  let [eventType, targetSelector, listener, capture] = args;

	  if (typeof args[1] === 'function') {
	    [eventType, listener, capture] = args;
	    targetSelector = undefined;
	  }

	  if (!capture) capture = false;
	  const events = eventType.split(' ');

	  for (let i = 0; i < events.length; i += 1) {
	    const event = events[i];

	    for (let j = 0; j < this.length; j += 1) {
	      const el = this[j];
	      let handlers;

	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }

	      if (handlers && handlers.length) {
	        for (let k = handlers.length - 1; k >= 0; k -= 1) {
	          const handler = handlers[k];

	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }

	  return this;
	}

	function trigger(...args) {
	  const window = getWindow();
	  const events = args[0].split(' ');
	  const eventData = args[1];

	  for (let i = 0; i < events.length; i += 1) {
	    const event = events[i];

	    for (let j = 0; j < this.length; j += 1) {
	      const el = this[j];

	      if (window.CustomEvent) {
	        const evt = new window.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true
	        });
	        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	  }

	  return this;
	}

	function transitionEnd(callback) {
	  const dom = this;

	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('transitionend', fireCallBack);
	  }

	  if (callback) {
	    dom.on('transitionend', fireCallBack);
	  }

	  return this;
	}

	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      const styles = this.styles();
	      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	    }

	    return this[0].offsetWidth;
	  }

	  return null;
	}

	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      const styles = this.styles();
	      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	    }

	    return this[0].offsetHeight;
	  }

	  return null;
	}

	function offset() {
	  if (this.length > 0) {
	    const window = getWindow();
	    const document = getDocument();
	    const el = this[0];
	    const box = el.getBoundingClientRect();
	    const body = document.body;
	    const clientTop = el.clientTop || body.clientTop || 0;
	    const clientLeft = el.clientLeft || body.clientLeft || 0;
	    const scrollTop = el === window ? window.scrollY : el.scrollTop;
	    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }

	  return null;
	}

	function styles() {
	  const window = getWindow();
	  if (this[0]) return window.getComputedStyle(this[0], null);
	  return {};
	}

	function css(props, value) {
	  const window = getWindow();
	  let i;

	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (const prop in props) {
	          this[i].style[prop] = props[prop];
	        }
	      }

	      return this;
	    }
	  }

	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }

	    return this;
	  }

	  return this;
	}

	function each(callback) {
	  if (!callback) return this;
	  this.forEach((el, index) => {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}

	function filter(callback) {
	  const result = arrayFilter(this, callback);
	  return $$2(result);
	}

	function html(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }

	  for (let i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }

	  return this;
	}

	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }

	  for (let i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }

	  return this;
	}

	function is(selector) {
	  const window = getWindow();
	  const document = getDocument();
	  const el = this[0];
	  let compareWith;
	  let i;
	  if (!el || typeof selector === 'undefined') return false;

	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $$2(selector);

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  if (selector === document) {
	    return el === document;
	  }

	  if (selector === window) {
	    return el === window;
	  }

	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;

	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }

	    return false;
	  }

	  return false;
	}

	function index() {
	  let child = this[0];
	  let i;

	  if (child) {
	    i = 0; // eslint-disable-next-line

	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }

	    return i;
	  }

	  return undefined;
	}

	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  const length = this.length;

	  if (index > length - 1) {
	    return $$2([]);
	  }

	  if (index < 0) {
	    const returnIndex = length + index;
	    if (returnIndex < 0) return $$2([]);
	    return $$2([this[returnIndex]]);
	  }

	  return $$2([this[index]]);
	}

	function append(...els) {
	  let newChild;
	  const document = getDocument();

	  for (let k = 0; k < els.length; k += 1) {
	    newChild = els[k];

	    for (let i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        const tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;

	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (let j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }

	  return this;
	}

	function prepend(newChild) {
	  const document = getDocument();
	  let i;
	  let j;

	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      const tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;

	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }

	  return this;
	}

	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $$2(this[0].nextElementSibling).is(selector)) {
	        return $$2([this[0].nextElementSibling]);
	      }

	      return $$2([]);
	    }

	    if (this[0].nextElementSibling) return $$2([this[0].nextElementSibling]);
	    return $$2([]);
	  }

	  return $$2([]);
	}

	function nextAll(selector) {
	  const nextEls = [];
	  let el = this[0];
	  if (!el) return $$2([]);

	  while (el.nextElementSibling) {
	    const next = el.nextElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($$2(next).is(selector)) nextEls.push(next);
	    } else nextEls.push(next);

	    el = next;
	  }

	  return $$2(nextEls);
	}

	function prev(selector) {
	  if (this.length > 0) {
	    const el = this[0];

	    if (selector) {
	      if (el.previousElementSibling && $$2(el.previousElementSibling).is(selector)) {
	        return $$2([el.previousElementSibling]);
	      }

	      return $$2([]);
	    }

	    if (el.previousElementSibling) return $$2([el.previousElementSibling]);
	    return $$2([]);
	  }

	  return $$2([]);
	}

	function prevAll(selector) {
	  const prevEls = [];
	  let el = this[0];
	  if (!el) return $$2([]);

	  while (el.previousElementSibling) {
	    const prev = el.previousElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($$2(prev).is(selector)) prevEls.push(prev);
	    } else prevEls.push(prev);

	    el = prev;
	  }

	  return $$2(prevEls);
	}

	function parent(selector) {
	  const parents = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($$2(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }

	  return $$2(parents);
	}

	function parents(selector) {
	  const parents = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    let parent = this[i].parentNode; // eslint-disable-line

	    while (parent) {
	      if (selector) {
	        if ($$2(parent).is(selector)) parents.push(parent);
	      } else {
	        parents.push(parent);
	      }

	      parent = parent.parentNode;
	    }
	  }

	  return $$2(parents);
	}

	function closest(selector) {
	  let closest = this; // eslint-disable-line

	  if (typeof selector === 'undefined') {
	    return $$2([]);
	  }

	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }

	  return closest;
	}

	function find(selector) {
	  const foundElements = [];

	  for (let i = 0; i < this.length; i += 1) {
	    const found = this[i].querySelectorAll(selector);

	    for (let j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }

	  return $$2(foundElements);
	}

	function children(selector) {
	  const children = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    const childNodes = this[i].children;

	    for (let j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $$2(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }

	  return $$2(children);
	}

	function remove() {
	  for (let i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }

	  return this;
	}

	const Methods = {
	  addClass,
	  removeClass,
	  hasClass,
	  toggleClass,
	  attr,
	  removeAttr,
	  transform,
	  transition,
	  on,
	  off,
	  trigger,
	  transitionEnd,
	  outerWidth,
	  outerHeight,
	  styles,
	  offset,
	  css,
	  each,
	  html,
	  text,
	  is,
	  index,
	  eq,
	  append,
	  prepend,
	  next,
	  nextAll,
	  prev,
	  prevAll,
	  parent,
	  parents,
	  closest,
	  find,
	  children,
	  filter,
	  remove
	};
	Object.keys(Methods).forEach(methodName => {
	  Object.defineProperty($$2.fn, methodName, {
	    value: Methods[methodName],
	    writable: true
	  });
	});

	function deleteProps(obj) {
	  const object = obj;
	  Object.keys(object).forEach(key => {
	    try {
	      object[key] = null;
	    } catch (e) {// no getter for object
	    }

	    try {
	      delete object[key];
	    } catch (e) {// something got wrong
	    }
	  });
	}

	function nextTick(callback, delay) {
	  if (delay === void 0) {
	    delay = 0;
	  }

	  return setTimeout(callback, delay);
	}

	function now() {
	  return Date.now();
	}

	function getComputedStyle$1(el) {
	  const window = getWindow();
	  let style;

	  if (window.getComputedStyle) {
	    style = window.getComputedStyle(el, null);
	  }

	  if (!style && el.currentStyle) {
	    style = el.currentStyle;
	  }

	  if (!style) {
	    style = el.style;
	  }

	  return style;
	}

	function getTranslate(el, axis) {
	  if (axis === void 0) {
	    axis = 'x';
	  }

	  const window = getWindow();
	  let matrix;
	  let curTransform;
	  let transformMatrix;
	  const curStyle = getComputedStyle$1(el);

	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;

	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
	    } // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case


	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }

	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
	    else curTransform = parseFloat(matrix[4]);
	  }

	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
	    else curTransform = parseFloat(matrix[5]);
	  }

	  return curTransform || 0;
	}

	function isObject$1(o) {
	  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
	}

	function isNode(node) {
	  // eslint-disable-next-line
	  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
	    return node instanceof HTMLElement;
	  }

	  return node && (node.nodeType === 1 || node.nodeType === 11);
	}

	function extend$1() {
	  const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
	  const noExtend = ['__proto__', 'constructor', 'prototype'];

	  for (let i = 1; i < arguments.length; i += 1) {
	    const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

	    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
	      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

	      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        const nextKey = keysArray[nextIndex];
	        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

	        if (desc !== undefined && desc.enumerable) {
	          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend$1(to[nextKey], nextSource[nextKey]);
	            }
	          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
	            to[nextKey] = {};

	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend$1(to[nextKey], nextSource[nextKey]);
	            }
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }

	  return to;
	}

	function setCSSProperty(el, varName, varValue) {
	  el.style.setProperty(varName, varValue);
	}

	function animateCSSModeScroll(_ref) {
	  let {
	    swiper,
	    targetPosition,
	    side
	  } = _ref;
	  const window = getWindow();
	  const startPosition = -swiper.translate;
	  let startTime = null;
	  let time;
	  const duration = swiper.params.speed;
	  swiper.wrapperEl.style.scrollSnapType = 'none';
	  window.cancelAnimationFrame(swiper.cssModeFrameID);
	  const dir = targetPosition > startPosition ? 'next' : 'prev';

	  const isOutOfBound = (current, target) => {
	    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
	  };

	  const animate = () => {
	    time = new Date().getTime();

	    if (startTime === null) {
	      startTime = time;
	    }

	    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
	    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

	    if (isOutOfBound(currentPosition, targetPosition)) {
	      currentPosition = targetPosition;
	    }

	    swiper.wrapperEl.scrollTo({
	      [side]: currentPosition
	    });

	    if (isOutOfBound(currentPosition, targetPosition)) {
	      swiper.wrapperEl.style.overflow = 'hidden';
	      swiper.wrapperEl.style.scrollSnapType = '';
	      setTimeout(() => {
	        swiper.wrapperEl.style.overflow = '';
	        swiper.wrapperEl.scrollTo({
	          [side]: currentPosition
	        });
	      });
	      window.cancelAnimationFrame(swiper.cssModeFrameID);
	      return;
	    }

	    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
	  };

	  animate();
	}

	let support;

	function calcSupport() {
	  const window = getWindow();
	  const document = getDocument();
	  return {
	    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
	    passiveListener: function checkPassiveListener() {
	      let supportsPassive = false;

	      try {
	        const opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get() {
	            supportsPassive = true;
	          }

	        });
	        window.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {// No support
	      }

	      return supportsPassive;
	    }(),
	    gestures: function checkGestures() {
	      return 'ongesturestart' in window;
	    }()
	  };
	}

	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }

	  return support;
	}

	let deviceCached;

	function calcDevice(_temp) {
	  let {
	    userAgent
	  } = _temp === void 0 ? {} : _temp;
	  const support = getSupport();
	  const window = getWindow();
	  const platform = window.navigator.platform;
	  const ua = userAgent || window.navigator.userAgent;
	  const device = {
	    ios: false,
	    android: false
	  };
	  const screenWidth = window.screen.width;
	  const screenHeight = window.screen.height;
	  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

	  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  const windows = platform === 'Win32';
	  let macos = platform === 'MacIntel'; // iPadOs 13 fix

	  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

	  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  } // Android


	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }

	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  } // Export object


	  return device;
	}

	function getDevice(overrides) {
	  if (overrides === void 0) {
	    overrides = {};
	  }

	  if (!deviceCached) {
	    deviceCached = calcDevice(overrides);
	  }

	  return deviceCached;
	}

	let browser;

	function calcBrowser() {
	  const window = getWindow();

	  function isSafari() {
	    const ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }

	  return {
	    isSafari: isSafari(),
	    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
	  };
	}

	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }

	  return browser;
	}

	function Resize(_ref) {
	  let {
	    swiper,
	    on,
	    emit
	  } = _ref;
	  const window = getWindow();
	  let observer = null;
	  let animationFrame = null;

	  const resizeHandler = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('beforeResize');
	    emit('resize');
	  };

	  const createObserver = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    observer = new ResizeObserver(entries => {
	      animationFrame = window.requestAnimationFrame(() => {
	        const {
	          width,
	          height
	        } = swiper;
	        let newWidth = width;
	        let newHeight = height;
	        entries.forEach(_ref2 => {
	          let {
	            contentBoxSize,
	            contentRect,
	            target
	          } = _ref2;
	          if (target && target !== swiper.el) return;
	          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
	          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
	        });

	        if (newWidth !== width || newHeight !== height) {
	          resizeHandler();
	        }
	      });
	    });
	    observer.observe(swiper.el);
	  };

	  const removeObserver = () => {
	    if (animationFrame) {
	      window.cancelAnimationFrame(animationFrame);
	    }

	    if (observer && observer.unobserve && swiper.el) {
	      observer.unobserve(swiper.el);
	      observer = null;
	    }
	  };

	  const orientationChangeHandler = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('orientationchange');
	  };

	  on('init', () => {
	    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
	      createObserver();
	      return;
	    }

	    window.addEventListener('resize', resizeHandler);
	    window.addEventListener('orientationchange', orientationChangeHandler);
	  });
	  on('destroy', () => {
	    removeObserver();
	    window.removeEventListener('resize', resizeHandler);
	    window.removeEventListener('orientationchange', orientationChangeHandler);
	  });
	}

	function Observer(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on,
	    emit
	  } = _ref;
	  const observers = [];
	  const window = getWindow();

	  const attach = function (target, options) {
	    if (options === void 0) {
	      options = {};
	    }

	    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    const observer = new ObserverFunc(mutations => {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (mutations.length === 1) {
	        emit('observerUpdate', mutations[0]);
	        return;
	      }

	      const observerUpdate = function observerUpdate() {
	        emit('observerUpdate', mutations[0]);
	      };

	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    observers.push(observer);
	  };

	  const init = () => {
	    if (!swiper.params.observer) return;

	    if (swiper.params.observeParents) {
	      const containerParents = swiper.$el.parents();

	      for (let i = 0; i < containerParents.length; i += 1) {
	        attach(containerParents[i]);
	      }
	    } // Observe container


	    attach(swiper.$el[0], {
	      childList: swiper.params.observeSlideChildren
	    }); // Observe wrapper

	    attach(swiper.$wrapperEl[0], {
	      attributes: false
	    });
	  };

	  const destroy = () => {
	    observers.forEach(observer => {
	      observer.disconnect();
	    });
	    observers.splice(0, observers.length);
	  };

	  extendParams({
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  });
	  on('init', init);
	  on('destroy', destroy);
	}

	/* eslint-disable no-underscore-dangle */
	var eventsEmitter = {
	  on(events, handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    const method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(event => {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },

	  once(events, handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;

	    function onceHandler() {
	      self.off(events, onceHandler);

	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }

	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      handler.apply(self, args);
	    }

	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },

	  onAny(handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    const method = priority ? 'unshift' : 'push';

	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }

	    return self;
	  },

	  offAny(handler) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsAnyListeners) return self;
	    const index = self.eventsAnyListeners.indexOf(handler);

	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }

	    return self;
	  },

	  off(events, handler) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(event => {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach((eventHandler, index) => {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },

	  emit() {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    let events;
	    let data;
	    let context;

	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }

	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }

	    data.unshift(context);
	    const eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(event => {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(eventHandler => {
	          eventHandler.apply(context, [event, ...data]);
	        });
	      }

	      if (self.eventsListeners && self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(eventHandler => {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }

	};

	function updateSize() {
	  const swiper = this;
	  let width;
	  let height;
	  const $el = swiper.$el;

	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }

	  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }

	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  } // Subtract paddings


	  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
	  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  Object.assign(swiper, {
	    width,
	    height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}

	function updateSlides() {
	  const swiper = this;

	  function getDirectionLabel(property) {
	    if (swiper.isHorizontal()) {
	      return property;
	    } // prettier-ignore


	    return {
	      'width': 'height',
	      'margin-top': 'margin-left',
	      'margin-bottom ': 'margin-right',
	      'margin-left': 'margin-top',
	      'margin-right': 'margin-bottom',
	      'padding-left': 'padding-top',
	      'padding-right': 'padding-bottom',
	      'marginRight': 'marginBottom'
	    }[property];
	  }

	  function getDirectionPropertyValue(node, label) {
	    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
	  }

	  const params = swiper.params;
	  const {
	    $wrapperEl,
	    size: swiperSize,
	    rtlTranslate: rtl,
	    wrongRTL
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;
	  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
	  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  let snapGrid = [];
	  const slidesGrid = [];
	  const slidesSizesGrid = [];
	  let offsetBefore = params.slidesOffsetBefore;

	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }

	  let offsetAfter = params.slidesOffsetAfter;

	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }

	  const previousSnapGridLength = swiper.snapGrid.length;
	  const previousSlidesGridLength = swiper.slidesGrid.length;
	  let spaceBetween = params.spaceBetween;
	  let slidePosition = -offsetBefore;
	  let prevSlideSize = 0;
	  let index = 0;

	  if (typeof swiperSize === 'undefined') {
	    return;
	  }

	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  }

	  swiper.virtualSize = -spaceBetween; // reset margins

	  if (rtl) slides.css({
	    marginLeft: '',
	    marginBottom: '',
	    marginTop: ''
	  });else slides.css({
	    marginRight: '',
	    marginBottom: '',
	    marginTop: ''
	  }); // reset cssMode offsets

	  if (params.centeredSlides && params.cssMode) {
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
	  }

	  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

	  if (gridEnabled) {
	    swiper.grid.initSlides(slidesLength);
	  } // Calc slides


	  let slideSize;
	  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
	    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
	  }).length > 0;

	  for (let i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    const slide = slides.eq(i);

	    if (gridEnabled) {
	      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
	    }

	    if (slide.css('display') === 'none') continue; // eslint-disable-line

	    if (params.slidesPerView === 'auto') {
	      if (shouldResetSlideSize) {
	        slides[i].style[getDirectionLabel('width')] = ``;
	      }

	      const slideStyles = getComputedStyle(slide[0]);
	      const currentTransform = slide[0].style.transform;
	      const currentWebKitTransform = slide[0].style.webkitTransform;

	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }

	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }

	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      } else {
	        // eslint-disable-next-line
	        const width = getDirectionPropertyValue(slideStyles, 'width');
	        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
	        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
	        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
	        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
	        const boxSizing = slideStyles.getPropertyValue('box-sizing');

	        if (boxSizing && boxSizing === 'border-box') {
	          slideSize = width + marginLeft + marginRight;
	        } else {
	          const {
	            clientWidth,
	            offsetWidth
	          } = slide[0];
	          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	        }
	      }

	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }

	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }

	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);

	      if (slides[i]) {
	        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
	      }
	    }

	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }

	    slidesSizesGrid.push(slideSize);

	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }

	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }

	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({
	      width: `${swiper.virtualSize + params.spaceBetween}px`
	    });
	  }

	  if (params.setWrapperSize) {
	    $wrapperEl.css({
	      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
	    });
	  }

	  if (gridEnabled) {
	    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
	  } // Remove last grid elements depending on width


	  if (!params.centeredSlides) {
	    const newSlidesGrid = [];

	    for (let i = 0; i < snapGrid.length; i += 1) {
	      let slidesGridItem = snapGrid[i];
	      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

	      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(slidesGridItem);
	      }
	    }

	    snapGrid = newSlidesGrid;

	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }

	  if (snapGrid.length === 0) snapGrid = [0];

	  if (params.spaceBetween !== 0) {
	    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
	    slides.filter((_, slideIndex) => {
	      if (!params.cssMode) return true;

	      if (slideIndex === slides.length - 1) {
	        return false;
	      }

	      return true;
	    }).css({
	      [key]: `${spaceBetween}px`
	    });
	  }

	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    let allSlidesSize = 0;
	    slidesSizesGrid.forEach(slideSizeValue => {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    const maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(snap => {
	      if (snap < 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }

	  if (params.centerInsufficientSlides) {
	    let allSlidesSize = 0;
	    slidesSizesGrid.forEach(slideSizeValue => {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;

	    if (allSlidesSize < swiperSize) {
	      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
	      snapGrid.forEach((snap, snapIndex) => {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach((snap, snapIndex) => {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }

	  Object.assign(swiper, {
	    slides,
	    snapGrid,
	    slidesGrid,
	    slidesSizesGrid
	  });

	  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
	    const addToSnapGrid = -swiper.snapGrid[0];
	    const addToSlidesGrid = -swiper.slidesGrid[0];
	    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
	    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
	  }

	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }

	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }

	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }

	  if (params.watchSlidesProgress) {
	    swiper.updateSlidesOffset();
	  }

	  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
	    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
	    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

	    if (slidesLength <= params.maxBackfaceHiddenSlides) {
	      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
	    } else if (hasClassBackfaceClassAdded) {
	      swiper.$el.removeClass(backFaceHiddenClass);
	    }
	  }
	}

	function updateAutoHeight(speed) {
	  const swiper = this;
	  const activeSlides = [];
	  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	  let newHeight = 0;
	  let i;

	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }

	  const getSlideByIndex = index => {
	    if (isVirtual) {
	      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
	    }

	    return swiper.slides.eq(index)[0];
	  }; // Find slides currently in view


	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      (swiper.visibleSlides || $$2([])).each(slide => {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        const index = swiper.activeIndex + i;
	        if (index > swiper.slides.length && !isVirtual) break;
	        activeSlides.push(getSlideByIndex(index));
	      }
	    }
	  } else {
	    activeSlides.push(getSlideByIndex(swiper.activeIndex));
	  } // Find new height from highest slide in view


	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      const height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  } // Update Height


	  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
	}

	function updateSlidesOffset() {
	  const swiper = this;
	  const slides = swiper.slides;

	  for (let i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

	function updateSlidesProgress(translate) {
	  if (translate === void 0) {
	    translate = this && this.translate || 0;
	  }

	  const swiper = this;
	  const params = swiper.params;
	  const {
	    slides,
	    rtlTranslate: rtl,
	    snapGrid
	  } = swiper;
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  let offsetCenter = -translate;
	  if (rtl) offsetCenter = translate; // Visible Slides

	  slides.removeClass(params.slideVisibleClass);
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];

	  for (let i = 0; i < slides.length; i += 1) {
	    const slide = slides[i];
	    let slideOffset = slide.swiperSlideOffset;

	    if (params.cssMode && params.centeredSlides) {
	      slideOffset -= slides[0].swiperSlideOffset;
	    }

	    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	    const slideBefore = -(offsetCenter - slideOffset);
	    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

	    if (isVisible) {
	      swiper.visibleSlides.push(slide);
	      swiper.visibleSlidesIndexes.push(i);
	      slides.eq(i).addClass(params.slideVisibleClass);
	    }

	    slide.progress = rtl ? -slideProgress : slideProgress;
	    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
	  }

	  swiper.visibleSlides = $$2(swiper.visibleSlides);
	}

	function updateProgress(translate) {
	  const swiper = this;

	  if (typeof translate === 'undefined') {
	    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }

	  const params = swiper.params;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  let {
	    progress,
	    isBeginning,
	    isEnd
	  } = swiper;
	  const wasBeginning = isBeginning;
	  const wasEnd = isEnd;

	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }

	  Object.assign(swiper, {
	    progress,
	    isBeginning,
	    isEnd
	  });
	  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }

	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }

	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }

	  swiper.emit('progress', progress);
	}

	function updateSlidesClasses() {
	  const swiper = this;
	  const {
	    slides,
	    params,
	    $wrapperEl,
	    activeIndex,
	    realIndex
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;
	  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
	  let activeSlide;

	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  } // Active classes


	  activeSlide.addClass(params.slideActiveClass);

	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
	    }
	  } // Next Slide


	  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  } // Prev Slide


	  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }

	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
	    }

	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
	    }
	  }

	  swiper.emitSlidesClasses();
	}

	function updateActiveIndex(newActiveIndex) {
	  const swiper = this;
	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  const {
	    slidesGrid,
	    snapGrid,
	    params,
	    activeIndex: previousIndex,
	    realIndex: previousRealIndex,
	    snapIndex: previousSnapIndex
	  } = swiper;
	  let activeIndex = newActiveIndex;
	  let snapIndex;

	  if (typeof activeIndex === 'undefined') {
	    for (let i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    } // Normalize slideIndex


	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	    }
	  }

	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }

	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }

	    return;
	  } // Get real index


	  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	  Object.assign(swiper, {
	    snapIndex,
	    realIndex,
	    previousIndex,
	    activeIndex
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');

	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }

	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    swiper.emit('slideChange');
	  }
	}

	function updateClickedSlide(e) {
	  const swiper = this;
	  const params = swiper.params;
	  const slide = $$2(e).closest(`.${params.slideClass}`)[0];
	  let slideFound = false;
	  let slideIndex;

	  if (slide) {
	    for (let i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) {
	        slideFound = true;
	        slideIndex = i;
	        break;
	      }
	    }
	  }

	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;

	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($$2(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = slideIndex;
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }

	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

	var update = {
	  updateSize,
	  updateSlides,
	  updateAutoHeight,
	  updateSlidesOffset,
	  updateSlidesProgress,
	  updateProgress,
	  updateSlidesClasses,
	  updateActiveIndex,
	  updateClickedSlide
	};

	function getSwiperTranslate(axis) {
	  if (axis === void 0) {
	    axis = this.isHorizontal() ? 'x' : 'y';
	  }

	  const swiper = this;
	  const {
	    params,
	    rtlTranslate: rtl,
	    translate,
	    $wrapperEl
	  } = swiper;

	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }

	  if (params.cssMode) {
	    return translate;
	  }

	  let currentTranslate = getTranslate($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}

	function setTranslate(translate, byController) {
	  const swiper = this;
	  const {
	    rtlTranslate: rtl,
	    params,
	    $wrapperEl,
	    wrapperEl,
	    progress
	  } = swiper;
	  let x = 0;
	  let y = 0;
	  const z = 0;

	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }

	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }

	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
	  }

	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }

	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, byController);
	}

	function minTranslate() {
	  return -this.snapGrid[0];
	}

	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}

	function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
	  if (translate === void 0) {
	    translate = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (translateBounds === void 0) {
	    translateBounds = true;
	  }

	  const swiper = this;
	  const {
	    params,
	    wrapperEl
	  } = swiper;

	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }

	  const minTranslate = swiper.minTranslate();
	  const maxTranslate = swiper.maxTranslate();
	  let newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

	  swiper.updateProgress(newTranslate);

	  if (params.cssMode) {
	    const isH = swiper.isHorizontal();

	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      if (!swiper.support.smoothScroll) {
	        animateCSSModeScroll({
	          swiper,
	          targetPosition: -newTranslate,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }

	      wrapperEl.scrollTo({
	        [isH ? 'left' : 'top']: -newTranslate,
	        behavior: 'smooth'
	      });
	    }

	    return true;
	  }

	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);

	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);

	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }

	    if (!swiper.animating) {
	      swiper.animating = true;

	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;

	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }

	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }

	  return true;
	}

	var translate = {
	  getTranslate: getSwiperTranslate,
	  setTranslate,
	  minTranslate,
	  maxTranslate,
	  translateTo
	};

	function setTransition(duration, byController) {
	  const swiper = this;

	  if (!swiper.params.cssMode) {
	    swiper.$wrapperEl.transition(duration);
	  }

	  swiper.emit('setTransition', duration, byController);
	}

	function transitionEmit(_ref) {
	  let {
	    swiper,
	    runCallbacks,
	    direction,
	    step
	  } = _ref;
	  const {
	    activeIndex,
	    previousIndex
	  } = swiper;
	  let dir = direction;

	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }

	  swiper.emit(`transition${step}`);

	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit(`slideResetTransition${step}`);
	      return;
	    }

	    swiper.emit(`slideChangeTransition${step}`);

	    if (dir === 'next') {
	      swiper.emit(`slideNextTransition${step}`);
	    } else {
	      swiper.emit(`slidePrevTransition${step}`);
	    }
	  }
	}

	function transitionStart(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  const swiper = this;
	  const {
	    params
	  } = swiper;
	  if (params.cssMode) return;

	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }

	  transitionEmit({
	    swiper,
	    runCallbacks,
	    direction,
	    step: 'Start'
	  });
	}

	function transitionEnd$1(runCallbacks, direction) {
	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  const swiper = this;
	  const {
	    params
	  } = swiper;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  transitionEmit({
	    swiper,
	    runCallbacks,
	    direction,
	    step: 'End'
	  });
	}

	var transition$1 = {
	  setTransition,
	  transitionStart,
	  transitionEnd: transitionEnd$1
	};

	function slideTo(index, speed, runCallbacks, internal, initial) {
	  if (index === void 0) {
	    index = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (typeof index !== 'number' && typeof index !== 'string') {
	    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
	  }

	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    const indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */

	    const isValidNumber = isFinite(indexAsNumber);

	    if (!isValidNumber) {
	      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.


	    index = indexAsNumber;
	  }

	  const swiper = this;
	  let slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  const {
	    params,
	    snapGrid,
	    slidesGrid,
	    previousIndex,
	    activeIndex,
	    rtlTranslate: rtl,
	    wrapperEl,
	    enabled
	  } = swiper;

	  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
	    return false;
	  }

	  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

	  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  }

	  const translate = -snapGrid[snapIndex]; // Update progress

	  swiper.updateProgress(translate); // Normalize slideIndex

	  if (params.normalizeSlideIndex) {
	    for (let i = 0; i < slidesGrid.length; i += 1) {
	      const normalizedTranslate = -Math.floor(translate * 100);
	      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
	      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
	          slideIndex = i;
	        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
	          slideIndex = i + 1;
	        }
	      } else if (normalizedTranslate >= normalizedGrid) {
	        slideIndex = i;
	      }
	    }
	  } // Directions locks


	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }

	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) return false;
	    }
	  }

	  let direction;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex); // Update Height

	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }

	    swiper.updateSlidesClasses();

	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }

	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }

	    return false;
	  }

	  if (params.cssMode) {
	    const isH = swiper.isHorizontal();
	    const t = rtl ? translate : -translate;

	    if (speed === 0) {
	      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

	      if (isVirtual) {
	        swiper.wrapperEl.style.scrollSnapType = 'none';
	        swiper._immediateVirtual = true;
	      }

	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

	      if (isVirtual) {
	        requestAnimationFrame(() => {
	          swiper.wrapperEl.style.scrollSnapType = '';
	          swiper._swiperImmediateVirtual = false;
	        });
	      }
	    } else {
	      if (!swiper.support.smoothScroll) {
	        animateCSSModeScroll({
	          swiper,
	          targetPosition: t,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }

	      wrapperEl.scrollTo({
	        [isH ? 'left' : 'top']: t,
	        behavior: 'smooth'
	      });
	    }

	    return true;
	  }

	  swiper.setTransition(speed);
	  swiper.setTranslate(translate);
	  swiper.updateActiveIndex(slideIndex);
	  swiper.updateSlidesClasses();
	  swiper.emit('beforeTransitionStart', speed, internal);
	  swiper.transitionStart(runCallbacks, direction);

	  if (speed === 0) {
	    swiper.transitionEnd(runCallbacks, direction);
	  } else if (!swiper.animating) {
	    swiper.animating = true;

	    if (!swiper.onSlideToWrapperTransitionEnd) {
	      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	        if (!swiper || swiper.destroyed) return;
	        if (e.target !== this) return;
	        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	        swiper.onSlideToWrapperTransitionEnd = null;
	        delete swiper.onSlideToWrapperTransitionEnd;
	        swiper.transitionEnd(runCallbacks, direction);
	      };
	    }

	    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	  }

	  return true;
	}

	function slideToLoop(index, speed, runCallbacks, internal) {
	  if (index === void 0) {
	    index = 0;
	  }

	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    const indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */

	    const isValidNumber = isFinite(indexAsNumber);

	    if (!isValidNumber) {
	      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.


	    index = indexAsNumber;
	  }

	  const swiper = this;
	  let newIndex = index;

	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }

	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideNext(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  const swiper = this;
	  const {
	    animating,
	    enabled,
	    params
	  } = swiper;
	  if (!enabled) return swiper;
	  let perGroup = params.slidesPerGroup;

	  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
	  }

	  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }

	  if (params.rewind && swiper.isEnd) {
	    return swiper.slideTo(0, speed, runCallbacks, internal);
	  }

	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slidePrev(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  const swiper = this;
	  const {
	    params,
	    animating,
	    snapGrid,
	    slidesGrid,
	    rtlTranslate,
	    enabled
	  } = swiper;
	  if (!enabled) return swiper;

	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }

	  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }

	  const normalizedTranslate = normalize(translate);
	  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
	  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    let prevSnapIndex;
	    snapGrid.forEach((snap, snapIndex) => {
	      if (normalizedTranslate >= snap) {
	        // prevSnap = snap;
	        prevSnapIndex = snapIndex;
	      }
	    });

	    if (typeof prevSnapIndex !== 'undefined') {
	      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
	    }
	  }

	  let prevIndex = 0;

	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

	    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
	      prevIndex = Math.max(prevIndex, 0);
	    }
	  }

	  if (params.rewind && swiper.isBeginning) {
	    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
	  }

	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideReset(speed, runCallbacks, internal) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  const swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed, runCallbacks, internal, threshold) {
	  if (speed === void 0) {
	    speed = this.params.speed;
	  }

	  if (runCallbacks === void 0) {
	    runCallbacks = true;
	  }

	  if (threshold === void 0) {
	    threshold = 0.5;
	  }

	  const swiper = this;
	  let index = swiper.activeIndex;
	  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    const currentSnap = swiper.snapGrid[snapIndex];
	    const nextSnap = swiper.snapGrid[snapIndex + 1];

	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    const prevSnap = swiper.snapGrid[snapIndex - 1];
	    const currentSnap = swiper.snapGrid[snapIndex];

	    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }

	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

	function slideToClickedSlide() {
	  const swiper = this;
	  const {
	    params,
	    $wrapperEl
	  } = swiper;
	  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  let slideToIndex = swiper.clickedIndex;
	  let realIndex;

	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt($$2(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
	        nextTick(() => {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
	      nextTick(() => {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

	var slide = {
	  slideTo,
	  slideToLoop,
	  slideNext,
	  slidePrev,
	  slideReset,
	  slideToClosest,
	  slideToClickedSlide
	};

	function loopCreate() {
	  const swiper = this;
	  const document = getDocument();
	  const {
	    params,
	    $wrapperEl
	  } = swiper; // Remove duplicated slides

	  const $selector = $wrapperEl.children().length > 0 ? $$2($wrapperEl.children()[0].parentNode) : $wrapperEl;
	  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
	  let slides = $selector.children(`.${params.slideClass}`);

	  if (params.loopFillGroupWithBlank) {
	    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (let i = 0; i < blankSlidesNum; i += 1) {
	        const blankNode = $$2(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
	        $selector.append(blankNode);
	      }

	      slides = $selector.children(`.${params.slideClass}`);
	    }
	  }

	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;

	  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
	    swiper.loopedSlides = slides.length;
	  }

	  const prependSlides = [];
	  const appendSlides = [];
	  slides.each((el, index) => {
	    $$2(el).attr('data-swiper-slide-index', index);
	  });

	  for (let i = 0; i < swiper.loopedSlides; i += 1) {
	    const index = i - Math.floor(i / slides.length) * slides.length;
	    appendSlides.push(slides.eq(index)[0]);
	    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
	  }

	  for (let i = 0; i < appendSlides.length; i += 1) {
	    $selector.append($$2(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }

	  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
	    $selector.prepend($$2(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

	function loopFix() {
	  const swiper = this;
	  swiper.emit('beforeLoopFix');
	  const {
	    activeIndex,
	    slides,
	    loopedSlides,
	    allowSlidePrev,
	    allowSlideNext,
	    snapGrid,
	    rtlTranslate: rtl
	  } = swiper;
	  let newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  const snapTranslate = -snapGrid[activeIndex];
	  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

	  if (activeIndex < loopedSlides) {
	    newIndex = slides.length - loopedSlides * 3 + activeIndex;
	    newIndex += loopedSlides;
	    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if (activeIndex >= slides.length - loopedSlides) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }

	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  swiper.emit('loopFix');
	}

	function loopDestroy() {
	  const swiper = this;
	  const {
	    $wrapperEl,
	    params,
	    slides
	  } = swiper;
	  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

	var loop = {
	  loopCreate,
	  loopFix,
	  loopDestroy
	};

	function setGrabCursor(moving) {
	  const swiper = this;
	  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

	function unsetGrabCursor() {
	  const swiper = this;

	  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }

	  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
	}

	var grabCursor = {
	  setGrabCursor,
	  unsetGrabCursor
	};

	function closestElement(selector, base) {
	  if (base === void 0) {
	    base = this;
	  }

	  function __closestFrom(el) {
	    if (!el || el === getDocument() || el === getWindow()) return null;
	    if (el.assignedSlot) el = el.assignedSlot;
	    const found = el.closest(selector);

	    if (!found && !el.getRootNode) {
	      return null;
	    }

	    return found || __closestFrom(el.getRootNode().host);
	  }

	  return __closestFrom(base);
	}

	function onTouchStart(event) {
	  const swiper = this;
	  const document = getDocument();
	  const window = getWindow();
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    enabled
	  } = swiper;
	  if (!enabled) return;

	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }

	  if (!swiper.animating && params.cssMode && params.loop) {
	    swiper.loopFix();
	  }

	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  let $targetEl = $$2(e.target);

	  if (params.touchEventsTarget === 'wrapper') {
	    if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }

	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

	  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

	  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
	    $targetEl = $$2(event.path[0]);
	  }

	  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
	  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

	  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
	    swiper.allowClick = true;
	    return;
	  }

	  if (params.swipeHandler) {
	    if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }

	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  const startX = touches.currentX;
	  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

	  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
	    if (edgeSwipeDetection === 'prevent') {
	      event.preventDefault();
	    } else {
	      return;
	    }
	  }

	  Object.assign(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;

	  if (e.type !== 'touchstart') {
	    let preventDefault = true;

	    if ($targetEl.is(data.focusableElements)) {
	      preventDefault = false;

	      if ($targetEl[0].nodeName === 'SELECT') {
	        data.isTouched = false;
	      }
	    }

	    if (document.activeElement && $$2(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
	      document.activeElement.blur();
	    }

	    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

	    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
	      e.preventDefault();
	    }
	  }

	  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
	    swiper.freeMode.onTouchStart();
	  }

	  swiper.emit('touchStart', e);
	}

	function onTouchMove(event) {
	  const document = getDocument();
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    rtlTranslate: rtl,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;

	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }

	    return;
	  }

	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }

	  if (!swiper.allowTouchMove) {
	    if (!$$2(e.target).is(data.focusableElements)) {
	      swiper.allowClick = false;
	    }

	    if (data.isTouched) {
	      Object.assign(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = now();
	    }

	    return;
	  }

	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }

	  if (data.isTouchEvent && document.activeElement) {
	    if (e.target === document.activeElement && $$2(e.target).is(data.focusableElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }

	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }

	  if (e.targetTouches && e.targetTouches.length > 1) return;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  const diffX = touches.currentX - touches.startX;
	  const diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

	  if (typeof data.isScrolling === 'undefined') {
	    let touchAngle;

	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }

	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }

	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }

	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }

	  if (!data.startMoving) {
	    return;
	  }

	  swiper.allowClick = false;

	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }

	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }

	  if (!data.isMoved) {
	    if (params.loop && !params.cssMode) {
	      swiper.loopFix();
	    }

	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);

	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }

	    data.allowMomentumBounce = false; // Grab Cursor

	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }

	    swiper.emit('sliderFirstMove', e);
	  }

	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  let diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	  let disableParentSwiper = true;
	  let resistanceRatio = params.resistanceRatio;

	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }

	  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
	  }

	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  } // Directions locks


	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }

	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }

	  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
	    data.currentTranslate = data.startTranslate;
	  } // Threshold


	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }

	  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

	  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }

	  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
	    swiper.freeMode.onTouchMove();
	  } // Update progress


	  swiper.updateProgress(data.currentTranslate); // Update translate

	  swiper.setTranslate(data.currentTranslate);
	}

	function onTouchEnd(event) {
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    rtlTranslate: rtl,
	    slidesGrid,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;

	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }

	  data.allowTouchCallbacks = false;

	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }

	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  } // Return Grab Cursor


	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  } // Time diff


	  const touchEndTime = now();
	  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

	  if (swiper.allowClick) {
	    const pathTree = e.path || e.composedPath && e.composedPath();
	    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
	    swiper.emit('tap click', e);

	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }

	  data.lastClickTime = now();
	  nextTick(() => {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });

	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }

	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  let currentPos;

	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }

	  if (params.cssMode) {
	    return;
	  }

	  if (swiper.params.freeMode && params.freeMode.enabled) {
	    swiper.freeMode.onTouchEnd({
	      currentPos
	    });
	    return;
	  } // Find current slide


	  let stopIndex = 0;
	  let groupSize = swiper.slidesSizesGrid[0];

	  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

	    if (typeof slidesGrid[i + increment] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + increment] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }

	  let rewindFirstIndex = null;
	  let rewindLastIndex = null;

	  if (params.rewind) {
	    if (swiper.isBeginning) {
	      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    } else if (swiper.isEnd) {
	      rewindFirstIndex = 0;
	    }
	  } // Find current slide size


	  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }

	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
	    }

	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) {
	        swiper.slideTo(stopIndex + increment);
	      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
	        swiper.slideTo(rewindLastIndex);
	      } else {
	        swiper.slideTo(stopIndex);
	      }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }

	    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
	      }

	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

	function onResize() {
	  const swiper = this;
	  const {
	    params,
	    el
	  } = swiper;
	  if (el && el.offsetWidth === 0) return; // Breakpoints

	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  } // Save locks


	  const {
	    allowSlideNext,
	    allowSlidePrev,
	    snapGrid
	  } = swiper; // Disable locks on resize

	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();

	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }

	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    swiper.autoplay.run();
	  } // Return locks after resize


	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;

	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

	function onClick(e) {
	  const swiper = this;
	  if (!swiper.enabled) return;

	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();

	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

	function onScroll() {
	  const swiper = this;
	  const {
	    wrapperEl,
	    rtlTranslate,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  swiper.previousTranslate = swiper.translate;

	  if (swiper.isHorizontal()) {
	    swiper.translate = -wrapperEl.scrollLeft;
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  } // eslint-disable-next-line


	  if (swiper.translate === 0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }

	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }

	  swiper.emit('setTranslate', swiper.translate, false);
	}

	let dummyEventAttached = false;

	function dummyEventListener() {}

	const events = (swiper, method) => {
	  const document = getDocument();
	  const {
	    params,
	    touchEvents,
	    el,
	    wrapperEl,
	    device,
	    support
	  } = swiper;
	  const capture = !!params.nested;
	  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
	  const swiperMethod = method; // Touch Events

	  if (!support.touch) {
	    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
	    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
	    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
	    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
	      passive: false,
	      capture
	    } : capture);
	    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

	    if (touchEvents.cancel) {
	      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	    }
	  } // Prevent Links Clicks


	  if (params.preventClicks || params.preventClicksPropagation) {
	    el[domMethod]('click', swiper.onClick, true);
	  }

	  if (params.cssMode) {
	    wrapperEl[domMethod]('scroll', swiper.onScroll);
	  } // Resize handler


	  if (params.updateOnWindowResize) {
	    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
	  } else {
	    swiper[swiperMethod]('observerUpdate', onResize, true);
	  }
	};

	function attachEvents() {
	  const swiper = this;
	  const document = getDocument();
	  const {
	    params,
	    support
	  } = swiper;
	  swiper.onTouchStart = onTouchStart.bind(swiper);
	  swiper.onTouchMove = onTouchMove.bind(swiper);
	  swiper.onTouchEnd = onTouchEnd.bind(swiper);

	  if (params.cssMode) {
	    swiper.onScroll = onScroll.bind(swiper);
	  }

	  swiper.onClick = onClick.bind(swiper);

	  if (support.touch && !dummyEventAttached) {
	    document.addEventListener('touchstart', dummyEventListener);
	    dummyEventAttached = true;
	  }

	  events(swiper, 'on');
	}

	function detachEvents() {
	  const swiper = this;
	  events(swiper, 'off');
	}

	var events$1 = {
	  attachEvents,
	  detachEvents
	};

	const isGridEnabled = (swiper, params) => {
	  return swiper.grid && params.grid && params.grid.rows > 1;
	};

	function setBreakpoint() {
	  const swiper = this;
	  const {
	    activeIndex,
	    initialized,
	    loopedSlides = 0,
	    params,
	    $el
	  } = swiper;
	  const breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

	  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
	  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
	  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
	  const wasMultiRow = isGridEnabled(swiper, params);
	  const isMultiRow = isGridEnabled(swiper, breakpointParams);
	  const wasEnabled = params.enabled;

	  if (wasMultiRow && !isMultiRow) {
	    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
	    swiper.emitContainerClasses();
	  } else if (!wasMultiRow && isMultiRow) {
	    $el.addClass(`${params.containerModifierClass}grid`);

	    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
	      $el.addClass(`${params.containerModifierClass}grid-column`);
	    }

	    swiper.emitContainerClasses();
	  } // Toggle navigation, pagination, scrollbar


	  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
	    const wasModuleEnabled = params[prop] && params[prop].enabled;
	    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

	    if (wasModuleEnabled && !isModuleEnabled) {
	      swiper[prop].disable();
	    }

	    if (!wasModuleEnabled && isModuleEnabled) {
	      swiper[prop].enable();
	    }
	  });
	  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

	  if (directionChanged && initialized) {
	    swiper.changeDirection();
	  }

	  extend$1(swiper.params, breakpointParams);
	  const isEnabled = swiper.params.enabled;
	  Object.assign(swiper, {
	    allowTouchMove: swiper.params.allowTouchMove,
	    allowSlideNext: swiper.params.allowSlideNext,
	    allowSlidePrev: swiper.params.allowSlidePrev
	  });

	  if (wasEnabled && !isEnabled) {
	    swiper.disable();
	  } else if (!wasEnabled && isEnabled) {
	    swiper.enable();
	  }

	  swiper.currentBreakpoint = breakpoint;
	  swiper.emit('_beforeBreakpoint', breakpointParams);

	  if (needsReLoop && initialized) {
	    swiper.loopDestroy();
	    swiper.loopCreate();
	    swiper.updateSlides();
	    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
	  }

	  swiper.emit('breakpoint', breakpointParams);
	}

	function getBreakpoint(breakpoints, base, containerEl) {
	  if (base === void 0) {
	    base = 'window';
	  }

	  if (!breakpoints || base === 'container' && !containerEl) return undefined;
	  let breakpoint = false;
	  const window = getWindow();
	  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
	  const points = Object.keys(breakpoints).map(point => {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      const minRatio = parseFloat(point.substr(1));
	      const value = currentHeight * minRatio;
	      return {
	        value,
	        point
	      };
	    }

	    return {
	      value: point,
	      point
	    };
	  });
	  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

	  for (let i = 0; i < points.length; i += 1) {
	    const {
	      point,
	      value
	    } = points[i];

	    if (base === 'window') {
	      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
	        breakpoint = point;
	      }
	    } else if (value <= containerEl.clientWidth) {
	      breakpoint = point;
	    }
	  }

	  return breakpoint || 'max';
	}

	var breakpoints = {
	  setBreakpoint,
	  getBreakpoint
	};

	function prepareClasses(entries, prefix) {
	  const resultClasses = [];
	  entries.forEach(item => {
	    if (typeof item === 'object') {
	      Object.keys(item).forEach(classNames => {
	        if (item[classNames]) {
	          resultClasses.push(prefix + classNames);
	        }
	      });
	    } else if (typeof item === 'string') {
	      resultClasses.push(prefix + item);
	    }
	  });
	  return resultClasses;
	}

	function addClasses() {
	  const swiper = this;
	  const {
	    classNames,
	    params,
	    rtl,
	    $el,
	    device,
	    support
	  } = swiper; // prettier-ignore

	  const suffixes = prepareClasses(['initialized', params.direction, {
	    'pointer-events': !support.touch
	  }, {
	    'free-mode': swiper.params.freeMode && params.freeMode.enabled
	  }, {
	    'autoheight': params.autoHeight
	  }, {
	    'rtl': rtl
	  }, {
	    'grid': params.grid && params.grid.rows > 1
	  }, {
	    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
	  }, {
	    'android': device.android
	  }, {
	    'ios': device.ios
	  }, {
	    'css-mode': params.cssMode
	  }, {
	    'centered': params.cssMode && params.centeredSlides
	  }, {
	    'watch-progress': params.watchSlidesProgress
	  }], params.containerModifierClass);
	  classNames.push(...suffixes);
	  $el.addClass([...classNames].join(' '));
	  swiper.emitContainerClasses();
	}

	function removeClasses() {
	  const swiper = this;
	  const {
	    $el,
	    classNames
	  } = swiper;
	  $el.removeClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

	var classes = {
	  addClasses,
	  removeClasses
	};

	function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
	  const window = getWindow();
	  let image;

	  function onReady() {
	    if (callback) callback();
	  }

	  const isPicture = $$2(imageEl).parent('picture')[0];

	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	    if (src) {
	      image = new window.Image();
	      image.onload = onReady;
	      image.onerror = onReady;

	      if (sizes) {
	        image.sizes = sizes;
	      }

	      if (srcset) {
	        image.srcset = srcset;
	      }

	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

	function preloadImages() {
	  const swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');

	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
	    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) swiper.update();
	      swiper.emit('imagesReady');
	    }
	  }

	  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    const imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
	  }
	}

	var images = {
	  loadImage,
	  preloadImages
	};

	function checkOverflow() {
	  const swiper = this;
	  const {
	    isLocked: wasLocked,
	    params
	  } = swiper;
	  const {
	    slidesOffsetBefore
	  } = params;

	  if (slidesOffsetBefore) {
	    const lastSlideIndex = swiper.slides.length - 1;
	    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
	    swiper.isLocked = swiper.size > lastSlideRightEdge;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }

	  if (params.allowSlideNext === true) {
	    swiper.allowSlideNext = !swiper.isLocked;
	  }

	  if (params.allowSlidePrev === true) {
	    swiper.allowSlidePrev = !swiper.isLocked;
	  }

	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	  }

	  if (wasLocked !== swiper.isLocked) {
	    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
	  }
	}

	var checkOverflow$1 = {
	  checkOverflow
	};

	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'wrapper',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  resizeObserver: true,
	  nested: false,
	  createElements: false,
	  enabled: true,
	  focusableElements: 'input, select, option, textarea, button, video, label',
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	  // Breakpoints
	  breakpoints: undefined,
	  breakpointsBase: 'window',
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  slidesPerGroupAuto: false,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: true,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopedSlidesLimit: true,
	  loopFillGroupWithBlank: false,
	  loopPreventsSlide: true,
	  // rewind
	  rewind: false,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  maxBackfaceHiddenSlides: 10,
	  // NS
	  containerModifierClass: 'swiper-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};

	function moduleExtendParams(params, allModulesParams) {
	  return function extendParams(obj) {
	    if (obj === void 0) {
	      obj = {};
	    }

	    const moduleParamName = Object.keys(obj)[0];
	    const moduleParams = obj[moduleParamName];

	    if (typeof moduleParams !== 'object' || moduleParams === null) {
	      extend$1(allModulesParams, obj);
	      return;
	    }

	    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
	      params[moduleParamName] = {
	        auto: true
	      };
	    }

	    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
	      extend$1(allModulesParams, obj);
	      return;
	    }

	    if (params[moduleParamName] === true) {
	      params[moduleParamName] = {
	        enabled: true
	      };
	    }

	    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
	      params[moduleParamName].enabled = true;
	    }

	    if (!params[moduleParamName]) params[moduleParamName] = {
	      enabled: false
	    };
	    extend$1(allModulesParams, obj);
	  };
	}

	/* eslint no-param-reassign: "off" */
	const prototypes = {
	  eventsEmitter,
	  update,
	  translate,
	  transition: transition$1,
	  slide,
	  loop,
	  grabCursor,
	  events: events$1,
	  breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes,
	  images
	};
	const extendedDefaults = {};

	class Swiper {
	  constructor() {
	    let el;
	    let params;

	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
	      params = args[0];
	    } else {
	      [el, params] = args;
	    }

	    if (!params) params = {};
	    params = extend$1({}, params);
	    if (el && !params.el) params.el = el;

	    if (params.el && $$2(params.el).length > 1) {
	      const swipers = [];
	      $$2(params.el).each(containerEl => {
	        const newParams = extend$1({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      });
	      return swipers;
	    } // Swiper Instance


	    const swiper = this;
	    swiper.__swiper__ = true;
	    swiper.support = getSupport();
	    swiper.device = getDevice({
	      userAgent: params.userAgent
	    });
	    swiper.browser = getBrowser();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];
	    swiper.modules = [...swiper.__modules__];

	    if (params.modules && Array.isArray(params.modules)) {
	      swiper.modules.push(...params.modules);
	    }

	    const allModulesParams = {};
	    swiper.modules.forEach(mod => {
	      mod({
	        swiper,
	        extendParams: moduleExtendParams(params, allModulesParams),
	        on: swiper.on.bind(swiper),
	        once: swiper.once.bind(swiper),
	        off: swiper.off.bind(swiper),
	        emit: swiper.emit.bind(swiper)
	      });
	    }); // Extend defaults with modules params

	    const swiperParams = extend$1({}, defaults, allModulesParams); // Extend defaults with passed params

	    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = extend$1({}, swiper.params);
	    swiper.passedParams = extend$1({}, params); // add event listeners

	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(eventName => {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }

	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    } // Save Dom lib


	    swiper.$ = $$2; // Extend Swiper

	    Object.assign(swiper, {
	      enabled: swiper.params.enabled,
	      el,
	      // Classes
	      classNames: [],
	      // Slides
	      slides: $$2(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],

	      // isDirection
	      isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },

	      isVertical() {
	        return swiper.params.direction === 'vertical';
	      },

	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEvents: function touchEvents() {
	        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	          cancel: touch[3]
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2]
	        };
	        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }(),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        focusableElements: swiper.params.focusableElements,
	        // Last click time
	        lastClickTime: now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    });
	    swiper.emit('_swiper'); // Init

	    if (swiper.params.init) {
	      swiper.init();
	    } // Return app instance


	    return swiper;
	  }

	  enable() {
	    const swiper = this;
	    if (swiper.enabled) return;
	    swiper.enabled = true;

	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }

	    swiper.emit('enable');
	  }

	  disable() {
	    const swiper = this;
	    if (!swiper.enabled) return;
	    swiper.enabled = false;

	    if (swiper.params.grabCursor) {
	      swiper.unsetGrabCursor();
	    }

	    swiper.emit('disable');
	  }

	  setProgress(progress, speed) {
	    const swiper = this;
	    progress = Math.min(Math.max(progress, 0), 1);
	    const min = swiper.minTranslate();
	    const max = swiper.maxTranslate();
	    const current = (max - min) * progress + min;
	    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }

	  emitContainerClasses() {
	    const swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    const cls = swiper.el.className.split(' ').filter(className => {
	      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	    });
	    swiper.emit('_containerClasses', cls.join(' '));
	  }

	  getSlideClasses(slideEl) {
	    const swiper = this;
	    if (swiper.destroyed) return '';
	    return slideEl.className.split(' ').filter(className => {
	      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	    }).join(' ');
	  }

	  emitSlidesClasses() {
	    const swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    const updates = [];
	    swiper.slides.each(slideEl => {
	      const classNames = swiper.getSlideClasses(slideEl);
	      updates.push({
	        slideEl,
	        classNames
	      });
	      swiper.emit('_slideClass', slideEl, classNames);
	    });
	    swiper.emit('_slideClasses', updates);
	  }

	  slidesPerViewDynamic(view, exact) {
	    if (view === void 0) {
	      view = 'current';
	    }

	    if (exact === void 0) {
	      exact = false;
	    }

	    const swiper = this;
	    const {
	      params,
	      slides,
	      slidesGrid,
	      slidesSizesGrid,
	      size: swiperSize,
	      activeIndex
	    } = swiper;
	    let spv = 1;

	    if (params.centeredSlides) {
	      let slideSize = slides[activeIndex].swiperSlideSize;
	      let breakLoop;

	      for (let i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }

	      for (let i = activeIndex - 1; i >= 0; i -= 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	    } else {
	      // eslint-disable-next-line
	      if (view === 'current') {
	        for (let i = activeIndex + 1; i < slides.length; i += 1) {
	          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

	          if (slideInView) {
	            spv += 1;
	          }
	        }
	      } else {
	        // previous
	        for (let i = activeIndex - 1; i >= 0; i -= 1) {
	          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

	          if (slideInView) {
	            spv += 1;
	          }
	        }
	      }
	    }

	    return spv;
	  }

	  update() {
	    const swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    const {
	      snapGrid,
	      params
	    } = swiper; // Breakpoints

	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }

	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();

	    function setTranslate() {
	      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }

	    let translated;

	    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
	      setTranslate();

	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }

	      if (!translated) {
	        setTranslate();
	      }
	    }

	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }

	    swiper.emit('update');
	  }

	  changeDirection(newDirection, needUpdate) {
	    if (needUpdate === void 0) {
	      needUpdate = true;
	    }

	    const swiper = this;
	    const currentDirection = swiper.params.direction;

	    if (!newDirection) {
	      // eslint-disable-next-line
	      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	    }

	    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	      return swiper;
	    }

	    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
	    swiper.emitContainerClasses();
	    swiper.params.direction = newDirection;
	    swiper.slides.each(slideEl => {
	      if (newDirection === 'vertical') {
	        slideEl.style.width = '';
	      } else {
	        slideEl.style.height = '';
	      }
	    });
	    swiper.emit('changeDirection');
	    if (needUpdate) swiper.update();
	    return swiper;
	  }

	  changeLanguageDirection(direction) {
	    const swiper = this;
	    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
	    swiper.rtl = direction === 'rtl';
	    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

	    if (swiper.rtl) {
	      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
	      swiper.el.dir = 'rtl';
	    } else {
	      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
	      swiper.el.dir = 'ltr';
	    }

	    swiper.update();
	  }

	  mount(el) {
	    const swiper = this;
	    if (swiper.mounted) return true; // Find el

	    const $el = $$2(el || swiper.params.el);
	    el = $el[0];

	    if (!el) {
	      return false;
	    }

	    el.swiper = swiper;

	    const getWrapperSelector = () => {
	      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
	    };

	    const getWrapper = () => {
	      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	        const res = $$2(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

	        res.children = options => $el.children(options);

	        return res;
	      }

	      if (!$el.children) {
	        return $$2($el).children(getWrapperSelector());
	      }

	      return $el.children(getWrapperSelector());
	    }; // Find Wrapper


	    let $wrapperEl = getWrapper();

	    if ($wrapperEl.length === 0 && swiper.params.createElements) {
	      const document = getDocument();
	      const wrapper = document.createElement('div');
	      $wrapperEl = $$2(wrapper);
	      wrapper.className = swiper.params.wrapperClass;
	      $el.append(wrapper);
	      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
	        $wrapperEl.append(slideEl);
	      });
	    }

	    Object.assign(swiper, {
	      $el,
	      el,
	      $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	      mounted: true,
	      // RTL
	      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
	    });
	    return true;
	  }

	  init(el) {
	    const swiper = this;
	    if (swiper.initialized) return swiper;
	    const mounted = swiper.mount(el);
	    if (mounted === false) return swiper;
	    swiper.emit('beforeInit'); // Set breakpoint

	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    } // Add Classes


	    swiper.addClasses(); // Create loop

	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    } // Update size


	    swiper.updateSize(); // Update slides

	    swiper.updateSlides();

	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    } // Set Grab Cursor


	    if (swiper.params.grabCursor && swiper.enabled) {
	      swiper.setGrabCursor();
	    }

	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    } // Slide To Initial Slide


	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
	    } // Attach events


	    swiper.attachEvents(); // Init Flag

	    swiper.initialized = true; // Emit

	    swiper.emit('init');
	    swiper.emit('afterInit');
	    return swiper;
	  }

	  destroy(deleteInstance, cleanStyles) {
	    if (deleteInstance === void 0) {
	      deleteInstance = true;
	    }

	    if (cleanStyles === void 0) {
	      cleanStyles = true;
	    }

	    const swiper = this;
	    const {
	      params,
	      $el,
	      $wrapperEl,
	      slides
	    } = swiper;

	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }

	    swiper.emit('beforeDestroy'); // Init Flag

	    swiper.initialized = false; // Detach events

	    swiper.detachEvents(); // Destroy loop

	    if (params.loop) {
	      swiper.loopDestroy();
	    } // Cleanup styles


	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');

	      if (slides && slides.length) {
	        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
	      }
	    }

	    swiper.emit('destroy'); // Detach emitter events

	    Object.keys(swiper.eventsListeners).forEach(eventName => {
	      swiper.off(eventName);
	    });

	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      deleteProps(swiper);
	    }

	    swiper.destroyed = true;
	    return null;
	  }

	  static extendDefaults(newDefaults) {
	    extend$1(extendedDefaults, newDefaults);
	  }

	  static get extendedDefaults() {
	    return extendedDefaults;
	  }

	  static get defaults() {
	    return defaults;
	  }

	  static installModule(mod) {
	    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
	    const modules = Swiper.prototype.__modules__;

	    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
	      modules.push(mod);
	    }
	  }

	  static use(module) {
	    if (Array.isArray(module)) {
	      module.forEach(m => Swiper.installModule(m));
	      return Swiper;
	    }

	    Swiper.installModule(module);
	    return Swiper;
	  }

	}

	Object.keys(prototypes).forEach(prototypeGroup => {
	  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([Resize, Observer]);

	function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
	  const document = getDocument();

	  if (swiper.params.createElements) {
	    Object.keys(checkProps).forEach(key => {
	      if (!params[key] && params.auto === true) {
	        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

	        if (!element) {
	          element = document.createElement('div');
	          element.className = checkProps[key];
	          swiper.$el.append(element);
	        }

	        params[key] = element;
	        originalParams[key] = element;
	      }
	    });
	  }

	  return params;
	}

	function Navigation(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on,
	    emit
	  } = _ref;
	  extendParams({
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock',
	      navigationDisabledClass: 'swiper-navigation-disabled'
	    }
	  });
	  swiper.navigation = {
	    nextEl: null,
	    $nextEl: null,
	    prevEl: null,
	    $prevEl: null
	  };

	  function getEl(el) {
	    let $el;

	    if (el) {
	      $el = $$2(el);

	      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
	        $el = swiper.$el.find(el);
	      }
	    }

	    return $el;
	  }

	  function toggleEl($el, disabled) {
	    const params = swiper.params.navigation;

	    if ($el && $el.length > 0) {
	      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
	      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

	      if (swiper.params.watchOverflow && swiper.enabled) {
	        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    }
	  }

	  function update() {
	    // Update Navigation Buttons
	    if (swiper.params.loop) return;
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
	    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
	  }

	  function onPrevClick(e) {
	    e.preventDefault();
	    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
	    swiper.slidePrev();
	    emit('navigationPrev');
	  }

	  function onNextClick(e) {
	    e.preventDefault();
	    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
	    swiper.slideNext();
	    emit('navigationNext');
	  }

	  function init() {
	    const params = swiper.params.navigation;
	    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
	      nextEl: 'swiper-button-next',
	      prevEl: 'swiper-button-prev'
	    });
	    if (!(params.nextEl || params.prevEl)) return;
	    const $nextEl = getEl(params.nextEl);
	    const $prevEl = getEl(params.prevEl);

	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', onNextClick);
	    }

	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', onPrevClick);
	    }

	    Object.assign(swiper.navigation, {
	      $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl,
	      prevEl: $prevEl && $prevEl[0]
	    });

	    if (!swiper.enabled) {
	      if ($nextEl) $nextEl.addClass(params.lockClass);
	      if ($prevEl) $prevEl.addClass(params.lockClass);
	    }
	  }

	  function destroy() {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;

	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click', onNextClick);
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }

	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click', onPrevClick);
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  }

	  on('init', () => {
	    if (swiper.params.navigation.enabled === false) {
	      // eslint-disable-next-line
	      disable();
	    } else {
	      init();
	      update();
	    }
	  });
	  on('toEdge fromEdge lock unlock', () => {
	    update();
	  });
	  on('destroy', () => {
	    destroy();
	  });
	  on('enable disable', () => {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;

	    if ($nextEl) {
	      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	    }

	    if ($prevEl) {
	      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	    }
	  });
	  on('click', (_s, e) => {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    const targetEl = e.target;

	    if (swiper.params.navigation.hideOnClick && !$$2(targetEl).is($prevEl) && !$$2(targetEl).is($nextEl)) {
	      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
	      let isHidden;

	      if ($nextEl) {
	        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	      } else if ($prevEl) {
	        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	      }

	      if (isHidden === true) {
	        emit('navigationShow');
	      } else {
	        emit('navigationHide');
	      }

	      if ($nextEl) {
	        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	      }

	      if ($prevEl) {
	        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	      }
	    }
	  });

	  const enable = () => {
	    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
	    init();
	    update();
	  };

	  const disable = () => {
	    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
	    destroy();
	  };

	  Object.assign(swiper.navigation, {
	    enable,
	    disable,
	    update,
	    init,
	    destroy
	  });
	}

	function classesToSelector(classes) {
	  if (classes === void 0) {
	    classes = '';
	  }

	  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
	}

	function Pagination(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on,
	    emit
	  } = _ref;
	  const pfx = 'swiper-pagination';
	  extendParams({
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: number => number,
	      formatFractionTotal: number => number,
	      bulletClass: `${pfx}-bullet`,
	      bulletActiveClass: `${pfx}-bullet-active`,
	      modifierClass: `${pfx}-`,
	      currentClass: `${pfx}-current`,
	      totalClass: `${pfx}-total`,
	      hiddenClass: `${pfx}-hidden`,
	      progressbarFillClass: `${pfx}-progressbar-fill`,
	      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
	      clickableClass: `${pfx}-clickable`,
	      lockClass: `${pfx}-lock`,
	      horizontalClass: `${pfx}-horizontal`,
	      verticalClass: `${pfx}-vertical`,
	      paginationDisabledClass: `${pfx}-disabled`
	    }
	  });
	  swiper.pagination = {
	    el: null,
	    $el: null,
	    bullets: []
	  };
	  let bulletSize;
	  let dynamicBulletIndex = 0;

	  function isPaginationDisabled() {
	    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
	  }

	  function setSideBullets($bulletEl, position) {
	    const {
	      bulletActiveClass
	    } = swiper.params.pagination;
	    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
	  }

	  function update() {
	    // Render || Update Pagination bullets/items
	    const rtl = swiper.rtl;
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    const $el = swiper.pagination.$el; // Current/Total

	    let current;
	    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

	      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
	        current -= slidesLength - swiper.loopedSlides * 2;
	      }

	      if (current > total - 1) current -= total;
	      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    } // Types


	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      const bullets = swiper.pagination.bullets;
	      let firstIndex;
	      let lastIndex;
	      let midIndex;

	      if (params.dynamicBullets) {
	        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

	          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (dynamicBulletIndex < 0) {
	            dynamicBulletIndex = 0;
	          }
	        }

	        firstIndex = Math.max(current - dynamicBulletIndex, 0);
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }

	      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

	      if ($el.length > 1) {
	        bullets.each(bullet => {
	          const $bullet = $$2(bullet);
	          const bulletIndex = $bullet.index();

	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }

	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(`${params.bulletActiveClass}-main`);
	            }

	            if (bulletIndex === firstIndex) {
	              setSideBullets($bullet, 'prev');
	            }

	            if (bulletIndex === lastIndex) {
	              setSideBullets($bullet, 'next');
	            }
	          }
	        });
	      } else {
	        const $bullet = bullets.eq(current);
	        const bulletIndex = $bullet.index();
	        $bullet.addClass(params.bulletActiveClass);

	        if (params.dynamicBullets) {
	          const $firstDisplayedBullet = bullets.eq(firstIndex);
	          const $lastDisplayedBullet = bullets.eq(lastIndex);

	          for (let i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
	          }

	          if (swiper.params.loop) {
	            if (bulletIndex >= bullets.length) {
	              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
	                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
	              }

	              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
	            } else {
	              setSideBullets($firstDisplayedBullet, 'prev');
	              setSideBullets($lastDisplayedBullet, 'next');
	            }
	          } else {
	            setSideBullets($firstDisplayedBullet, 'prev');
	            setSideBullets($lastDisplayedBullet, 'next');
	          }
	        }
	      }

	      if (params.dynamicBullets) {
	        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
	        const offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
	      }
	    }

	    if (params.type === 'fraction') {
	      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
	      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
	    }

	    if (params.type === 'progressbar') {
	      let progressbarDirection;

	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }

	      const scale = (current + 1) / total;
	      let scaleX = 1;
	      let scaleY = 1;

	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }

	      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
	    }

	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      emit('paginationRender', $el[0]);
	    } else {
	      emit('paginationUpdate', $el[0]);
	    }

	    if (swiper.params.watchOverflow && swiper.enabled) {
	      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  }

	  function render() {
	    // Render Container
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    const $el = swiper.pagination.$el;
	    let paginationHTML = '';

	    if (params.type === 'bullets') {
	      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

	      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
	        numberOfBullets = slidesLength;
	      }

	      for (let i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
	        }
	      }

	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
	    }

	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
	      }

	      $el.html(paginationHTML);
	    }

	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
	      }

	      $el.html(paginationHTML);
	    }

	    if (params.type !== 'custom') {
	      emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  }

	  function init() {
	    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
	      el: 'swiper-pagination'
	    });
	    const params = swiper.params.pagination;
	    if (!params.el) return;
	    let $el = $$2(params.el);
	    if ($el.length === 0) return;

	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
	      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

	      if ($el.length > 1) {
	        $el = $el.filter(el => {
	          if ($$2(el).parents('.swiper')[0] !== swiper.el) return false;
	          return true;
	        });
	      }
	    }

	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }

	    $el.addClass(params.modifierClass + params.type);
	    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
	      dynamicBulletIndex = 0;

	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }

	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }

	    if (params.clickable) {
	      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
	        e.preventDefault();
	        let index = $$2(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) index += swiper.loopedSlides;
	        swiper.slideTo(index);
	      });
	    }

	    Object.assign(swiper.pagination, {
	      $el,
	      el: $el[0]
	    });

	    if (!swiper.enabled) {
	      $el.addClass(params.lockClass);
	    }
	  }

	  function destroy() {
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const $el = swiper.pagination.$el;
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

	    if (params.clickable) {
	      $el.off('click', classesToSelector(params.bulletClass));
	    }
	  }

	  on('init', () => {
	    if (swiper.params.pagination.enabled === false) {
	      // eslint-disable-next-line
	      disable();
	    } else {
	      init();
	      render();
	      update();
	    }
	  });
	  on('activeIndexChange', () => {
	    if (swiper.params.loop) {
	      update();
	    } else if (typeof swiper.snapIndex === 'undefined') {
	      update();
	    }
	  });
	  on('snapIndexChange', () => {
	    if (!swiper.params.loop) {
	      update();
	    }
	  });
	  on('slidesLengthChange', () => {
	    if (swiper.params.loop) {
	      render();
	      update();
	    }
	  });
	  on('snapGridLengthChange', () => {
	    if (!swiper.params.loop) {
	      render();
	      update();
	    }
	  });
	  on('destroy', () => {
	    destroy();
	  });
	  on('enable disable', () => {
	    const {
	      $el
	    } = swiper.pagination;

	    if ($el) {
	      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
	    }
	  });
	  on('lock unlock', () => {
	    update();
	  });
	  on('click', (_s, e) => {
	    const targetEl = e.target;
	    const {
	      $el
	    } = swiper.pagination;

	    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$$2(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
	      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
	      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

	      if (isHidden === true) {
	        emit('paginationShow');
	      } else {
	        emit('paginationHide');
	      }

	      $el.toggleClass(swiper.params.pagination.hiddenClass);
	    }
	  });

	  const enable = () => {
	    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

	    if (swiper.pagination.$el) {
	      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
	    }

	    init();
	    render();
	    update();
	  };

	  const disable = () => {
	    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

	    if (swiper.pagination.$el) {
	      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
	    }

	    destroy();
	  };

	  Object.assign(swiper.pagination, {
	    enable,
	    disable,
	    render,
	    update,
	    init,
	    destroy
	  });
	}

	/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
	function Controller(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on
	  } = _ref;
	  extendParams({
	    controller: {
	      control: undefined,
	      inverse: false,
	      by: 'slide' // or 'container'

	    }
	  });
	  swiper.controller = {
	    control: undefined
	  };

	  function LinearSpline(x, y) {
	    const binarySearch = function search() {
	      let maxIndex;
	      let minIndex;
	      let guess;
	      return (array, val) => {
	        minIndex = -1;
	        maxIndex = array.length;

	        while (maxIndex - minIndex > 1) {
	          guess = maxIndex + minIndex >> 1;

	          if (array[guess] <= val) {
	            minIndex = guess;
	          } else {
	            maxIndex = guess;
	          }
	        }

	        return maxIndex;
	      };
	    }();

	    this.x = x;
	    this.y = y;
	    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
	    // (x1,y1) is the known point before given value,
	    // (x3,y3) is the known point after given value.

	    let i1;
	    let i3;

	    this.interpolate = function interpolate(x2) {
	      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

	      i3 = binarySearch(this.x, x2);
	      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
	      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

	      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
	    };

	    return this;
	  } // xxx: for now i will just save one spline function to to


	  function getInterpolateFunction(c) {
	    if (!swiper.controller.spline) {
	      swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
	    }
	  }

	  function setTranslate(_t, byController) {
	    const controlled = swiper.controller.control;
	    let multiplier;
	    let controlledTranslate;
	    const Swiper = swiper.constructor;

	    function setControlledTranslate(c) {
	      // this will create an Interpolate function based on the snapGrids
	      // x is the Grid of the scrolled scroller and y will be the controlled scroller
	      // it makes sense to create this only once and recall it for the interpolation
	      // the function does a lot of value caching for performance
	      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

	      if (swiper.params.controller.by === 'slide') {
	        getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	        // but it did not work out

	        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
	      }

	      if (!controlledTranslate || swiper.params.controller.by === 'container') {
	        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
	        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
	      }

	      if (swiper.params.controller.inverse) {
	        controlledTranslate = c.maxTranslate() - controlledTranslate;
	      }

	      c.updateProgress(controlledTranslate);
	      c.setTranslate(controlledTranslate, swiper);
	      c.updateActiveIndex();
	      c.updateSlidesClasses();
	    }

	    if (Array.isArray(controlled)) {
	      for (let i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTranslate(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTranslate(controlled);
	    }
	  }

	  function setTransition(duration, byController) {
	    const Swiper = swiper.constructor;
	    const controlled = swiper.controller.control;
	    let i;

	    function setControlledTransition(c) {
	      c.setTransition(duration, swiper);

	      if (duration !== 0) {
	        c.transitionStart();

	        if (c.params.autoHeight) {
	          nextTick(() => {
	            c.updateAutoHeight();
	          });
	        }

	        c.$wrapperEl.transitionEnd(() => {
	          if (!controlled) return;

	          if (c.params.loop && swiper.params.controller.by === 'slide') {
	            c.loopFix();
	          }

	          c.transitionEnd();
	        });
	      }
	    }

	    if (Array.isArray(controlled)) {
	      for (i = 0; i < controlled.length; i += 1) {
	        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	          setControlledTransition(controlled[i]);
	        }
	      }
	    } else if (controlled instanceof Swiper && byController !== controlled) {
	      setControlledTransition(controlled);
	    }
	  }

	  function removeSpline() {
	    if (!swiper.controller.control) return;

	    if (swiper.controller.spline) {
	      swiper.controller.spline = undefined;
	      delete swiper.controller.spline;
	    }
	  }

	  on('beforeInit', () => {
	    swiper.controller.control = swiper.params.controller.control;
	  });
	  on('update', () => {
	    removeSpline();
	  });
	  on('resize', () => {
	    removeSpline();
	  });
	  on('observerUpdate', () => {
	    removeSpline();
	  });
	  on('setTranslate', (_s, translate, byController) => {
	    if (!swiper.controller.control) return;
	    swiper.controller.setTranslate(translate, byController);
	  });
	  on('setTransition', (_s, duration, byController) => {
	    if (!swiper.controller.control) return;
	    swiper.controller.setTransition(duration, byController);
	  });
	  Object.assign(swiper.controller, {
	    setTranslate,
	    setTransition
	  });
	}

	/* eslint no-underscore-dangle: "off" */
	function Autoplay(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on,
	    emit
	  } = _ref;
	  let timeout;
	  swiper.autoplay = {
	    running: false,
	    paused: false
	  };
	  extendParams({
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	      pauseOnMouseEnter: false
	    }
	  });

	  function run() {
	    if (!swiper.size) {
	      swiper.autoplay.running = false;
	      swiper.autoplay.paused = false;
	      return;
	    }

	    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    let delay = swiper.params.autoplay.delay;

	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }

	    clearTimeout(timeout);
	    timeout = nextTick(() => {
	      let autoplayResult;

	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          emit('autoplay');
	        } else {
	          stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        emit('autoplay');
	      } else if (!swiper.isEnd) {
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
	        emit('autoplay');
	      } else {
	        stop();
	      }

	      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
	        run();
	      }
	    }, delay);
	  }

	  function start() {
	    if (typeof timeout !== 'undefined') return false;
	    if (swiper.autoplay.running) return false;
	    swiper.autoplay.running = true;
	    emit('autoplayStart');
	    run();
	    return true;
	  }

	  function stop() {
	    if (!swiper.autoplay.running) return false;
	    if (typeof timeout === 'undefined') return false;

	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = undefined;
	    }

	    swiper.autoplay.running = false;
	    emit('autoplayStop');
	    return true;
	  }

	  function pause(speed) {
	    if (!swiper.autoplay.running) return;
	    if (swiper.autoplay.paused) return;
	    if (timeout) clearTimeout(timeout);
	    swiper.autoplay.paused = true;

	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      run();
	    } else {
	      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
	      });
	    }
	  }

	  function onVisibilityChange() {
	    const document = getDocument();

	    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
	      pause();
	    }

	    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
	      run();
	      swiper.autoplay.paused = false;
	    }
	  }

	  function onTransitionEnd(e) {
	    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
	    if (e.target !== swiper.$wrapperEl[0]) return;
	    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
	    });
	    swiper.autoplay.paused = false;

	    if (!swiper.autoplay.running) {
	      stop();
	    } else {
	      run();
	    }
	  }

	  function onMouseEnter() {
	    if (swiper.params.autoplay.disableOnInteraction) {
	      stop();
	    } else {
	      emit('autoplayPause');
	      pause();
	    }

	    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
	    });
	  }

	  function onMouseLeave() {
	    if (swiper.params.autoplay.disableOnInteraction) {
	      return;
	    }

	    swiper.autoplay.paused = false;
	    emit('autoplayResume');
	    run();
	  }

	  function attachMouseEvents() {
	    if (swiper.params.autoplay.pauseOnMouseEnter) {
	      swiper.$el.on('mouseenter', onMouseEnter);
	      swiper.$el.on('mouseleave', onMouseLeave);
	    }
	  }

	  function detachMouseEvents() {
	    swiper.$el.off('mouseenter', onMouseEnter);
	    swiper.$el.off('mouseleave', onMouseLeave);
	  }

	  on('init', () => {
	    if (swiper.params.autoplay.enabled) {
	      start();
	      const document = getDocument();
	      document.addEventListener('visibilitychange', onVisibilityChange);
	      attachMouseEvents();
	    }
	  });
	  on('beforeTransitionStart', (_s, speed, internal) => {
	    if (swiper.autoplay.running) {
	      if (internal || !swiper.params.autoplay.disableOnInteraction) {
	        swiper.autoplay.pause(speed);
	      } else {
	        stop();
	      }
	    }
	  });
	  on('sliderFirstMove', () => {
	    if (swiper.autoplay.running) {
	      if (swiper.params.autoplay.disableOnInteraction) {
	        stop();
	      } else {
	        pause();
	      }
	    }
	  });
	  on('touchEnd', () => {
	    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
	      run();
	    }
	  });
	  on('destroy', () => {
	    detachMouseEvents();

	    if (swiper.autoplay.running) {
	      stop();
	    }

	    const document = getDocument();
	    document.removeEventListener('visibilitychange', onVisibilityChange);
	  });
	  Object.assign(swiper.autoplay, {
	    pause,
	    run,
	    start,
	    stop
	  });
	}

	function Thumb(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on
	  } = _ref;
	  extendParams({
	    thumbs: {
	      swiper: null,
	      multipleActiveThumbs: true,
	      autoScrollOffset: 0,
	      slideThumbActiveClass: 'swiper-slide-thumb-active',
	      thumbsContainerClass: 'swiper-thumbs'
	    }
	  });
	  let initialized = false;
	  let swiperCreated = false;
	  swiper.thumbs = {
	    swiper: null
	  };

	  function onThumbClick() {
	    const thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
	    const clickedIndex = thumbsSwiper.clickedIndex;
	    const clickedSlide = thumbsSwiper.clickedSlide;
	    if (clickedSlide && $$2(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
	    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
	    let slideToIndex;

	    if (thumbsSwiper.params.loop) {
	      slideToIndex = parseInt($$2(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    } else {
	      slideToIndex = clickedIndex;
	    }

	    if (swiper.params.loop) {
	      let currentIndex = swiper.activeIndex;

	      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
	        swiper.loopFix(); // eslint-disable-next-line

	        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	        currentIndex = swiper.activeIndex;
	      }

	      const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
	      const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
	      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
	    }

	    swiper.slideTo(slideToIndex);
	  }

	  function init() {
	    const {
	      thumbs: thumbsParams
	    } = swiper.params;
	    if (initialized) return false;
	    initialized = true;
	    const SwiperClass = swiper.constructor;

	    if (thumbsParams.swiper instanceof SwiperClass) {
	      swiper.thumbs.swiper = thumbsParams.swiper;
	      Object.assign(swiper.thumbs.swiper.originalParams, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	      Object.assign(swiper.thumbs.swiper.params, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	    } else if (isObject$1(thumbsParams.swiper)) {
	      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
	      Object.assign(thumbsSwiperParams, {
	        watchSlidesProgress: true,
	        slideToClickedSlide: false
	      });
	      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
	      swiperCreated = true;
	    }

	    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
	    swiper.thumbs.swiper.on('tap', onThumbClick);
	    return true;
	  }

	  function update(initial) {
	    const thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
	    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs

	    let thumbsToActivate = 1;
	    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

	    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
	      thumbsToActivate = swiper.params.slidesPerView;
	    }

	    if (!swiper.params.thumbs.multipleActiveThumbs) {
	      thumbsToActivate = 1;
	    }

	    thumbsToActivate = Math.floor(thumbsToActivate);
	    thumbsSwiper.slides.removeClass(thumbActiveClass);

	    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
	      for (let i = 0; i < thumbsToActivate; i += 1) {
	        thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
	      }
	    } else {
	      for (let i = 0; i < thumbsToActivate; i += 1) {
	        thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
	      }
	    }

	    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
	    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;

	    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
	      let currentThumbsIndex = thumbsSwiper.activeIndex;
	      let newThumbsIndex;
	      let direction;

	      if (thumbsSwiper.params.loop) {
	        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
	          thumbsSwiper.loopFix(); // eslint-disable-next-line

	          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
	          currentThumbsIndex = thumbsSwiper.activeIndex;
	        } // Find actual thumbs index to slide to


	        const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
	        const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();

	        if (typeof prevThumbsIndex === 'undefined') {
	          newThumbsIndex = nextThumbsIndex;
	        } else if (typeof nextThumbsIndex === 'undefined') {
	          newThumbsIndex = prevThumbsIndex;
	        } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
	          newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
	        } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
	          newThumbsIndex = nextThumbsIndex;
	        } else {
	          newThumbsIndex = prevThumbsIndex;
	        }

	        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
	      } else {
	        newThumbsIndex = swiper.realIndex;
	        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
	      }

	      if (useOffset) {
	        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
	      }

	      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
	        if (thumbsSwiper.params.centeredSlides) {
	          if (newThumbsIndex > currentThumbsIndex) {
	            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
	          } else {
	            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
	          }
	        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;

	        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
	      }
	    }
	  }

	  on('beforeInit', () => {
	    const {
	      thumbs
	    } = swiper.params;
	    if (!thumbs || !thumbs.swiper) return;
	    init();
	    update(true);
	  });
	  on('slideChange update resize observerUpdate', () => {
	    update();
	  });
	  on('setTransition', (_s, duration) => {
	    const thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
	    thumbsSwiper.setTransition(duration);
	  });
	  on('beforeDestroy', () => {
	    const thumbsSwiper = swiper.thumbs.swiper;
	    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

	    if (swiperCreated) {
	      thumbsSwiper.destroy();
	    }
	  });
	  Object.assign(swiper.thumbs, {
	    init,
	    update
	  });
	}

	function effectInit(params) {
	  const {
	    effect,
	    swiper,
	    on,
	    setTranslate,
	    setTransition,
	    overwriteParams,
	    perspective,
	    recreateShadows,
	    getEffectParams
	  } = params;
	  on('beforeInit', () => {
	    if (swiper.params.effect !== effect) return;
	    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);

	    if (perspective && perspective()) {
	      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
	    }

	    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
	    Object.assign(swiper.params, overwriteParamsResult);
	    Object.assign(swiper.originalParams, overwriteParamsResult);
	  });
	  on('setTranslate', () => {
	    if (swiper.params.effect !== effect) return;
	    setTranslate();
	  });
	  on('setTransition', (_s, duration) => {
	    if (swiper.params.effect !== effect) return;
	    setTransition(duration);
	  });
	  on('transitionEnd', () => {
	    if (swiper.params.effect !== effect) return;

	    if (recreateShadows) {
	      if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows

	      swiper.slides.each(slideEl => {
	        const $slideEl = swiper.$(slideEl);
	        $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
	      }); // create new one

	      recreateShadows();
	    }
	  });
	  let requireUpdateOnVirtual;
	  on('virtualUpdate', () => {
	    if (swiper.params.effect !== effect) return;

	    if (!swiper.slides.length) {
	      requireUpdateOnVirtual = true;
	    }

	    requestAnimationFrame(() => {
	      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
	        setTranslate();
	        requireUpdateOnVirtual = false;
	      }
	    });
	  });
	}

	function effectTarget(effectParams, $slideEl) {
	  if (effectParams.transformEl) {
	    return $slideEl.find(effectParams.transformEl).css({
	      'backface-visibility': 'hidden',
	      '-webkit-backface-visibility': 'hidden'
	    });
	  }

	  return $slideEl;
	}

	function effectVirtualTransitionEnd(_ref) {
	  let {
	    swiper,
	    duration,
	    transformEl,
	    allSlides
	  } = _ref;
	  const {
	    slides,
	    activeIndex,
	    $wrapperEl
	  } = swiper;

	  if (swiper.params.virtualTranslate && duration !== 0) {
	    let eventTriggered = false;
	    let $transitionEndTarget;

	    if (allSlides) {
	      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
	    } else {
	      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
	    }

	    $transitionEndTarget.transitionEnd(() => {
	      if (eventTriggered) return;
	      if (!swiper || swiper.destroyed) return;
	      eventTriggered = true;
	      swiper.animating = false;
	      const triggerEvents = ['webkitTransitionEnd', 'transitionend'];

	      for (let i = 0; i < triggerEvents.length; i += 1) {
	        $wrapperEl.trigger(triggerEvents[i]);
	      }
	    });
	  }
	}

	function createShadow(params, $slideEl, side) {
	  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
	  const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
	  let $shadowEl = $shadowContainer.children(`.${shadowClass}`);

	  if (!$shadowEl.length) {
	    $shadowEl = $$2(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
	    $shadowContainer.append($shadowEl);
	  }

	  return $shadowEl;
	}

	function EffectCreative(_ref) {
	  let {
	    swiper,
	    extendParams,
	    on
	  } = _ref;
	  extendParams({
	    creativeEffect: {
	      transformEl: null,
	      limitProgress: 1,
	      shadowPerProgress: false,
	      progressMultiplier: 1,
	      perspective: true,
	      prev: {
	        translate: [0, 0, 0],
	        rotate: [0, 0, 0],
	        opacity: 1,
	        scale: 1
	      },
	      next: {
	        translate: [0, 0, 0],
	        rotate: [0, 0, 0],
	        opacity: 1,
	        scale: 1
	      }
	    }
	  });

	  const getTranslateValue = value => {
	    if (typeof value === 'string') return value;
	    return `${value}px`;
	  };

	  const setTranslate = () => {
	    const {
	      slides,
	      $wrapperEl,
	      slidesSizesGrid
	    } = swiper;
	    const params = swiper.params.creativeEffect;
	    const {
	      progressMultiplier: multiplier
	    } = params;
	    const isCenteredSlides = swiper.params.centeredSlides;

	    if (isCenteredSlides) {
	      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
	      $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
	    }

	    for (let i = 0; i < slides.length; i += 1) {
	      const $slideEl = slides.eq(i);
	      const slideProgress = $slideEl[0].progress;
	      const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
	      let originalProgress = progress;

	      if (!isCenteredSlides) {
	        originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
	      }

	      const offset = $slideEl[0].swiperSlideOffset;
	      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
	      const r = [0, 0, 0];
	      let custom = false;

	      if (!swiper.isHorizontal()) {
	        t[1] = t[0];
	        t[0] = 0;
	      }

	      let data = {
	        translate: [0, 0, 0],
	        rotate: [0, 0, 0],
	        scale: 1,
	        opacity: 1
	      };

	      if (progress < 0) {
	        data = params.next;
	        custom = true;
	      } else if (progress > 0) {
	        data = params.prev;
	        custom = true;
	      } // set translate


	      t.forEach((value, index) => {
	        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
	      }); // set rotates

	      r.forEach((value, index) => {
	        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
	      });
	      $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
	      const translateString = t.join(', ');
	      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
	      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
	      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
	      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

	      if (custom && data.shadow || !custom) {
	        let $shadowEl = $slideEl.children('.swiper-slide-shadow');

	        if ($shadowEl.length === 0 && data.shadow) {
	          $shadowEl = createShadow(params, $slideEl);
	        }

	        if ($shadowEl.length) {
	          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
	          $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
	        }
	      }

	      const $targetEl = effectTarget(params, $slideEl);
	      $targetEl.transform(transform).css({
	        opacity: opacityString
	      });

	      if (data.origin) {
	        $targetEl.css('transform-origin', data.origin);
	      }
	    }
	  };

	  const setTransition = duration => {
	    const {
	      transformEl
	    } = swiper.params.creativeEffect;
	    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
	    $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
	    effectVirtualTransitionEnd({
	      swiper,
	      duration,
	      transformEl,
	      allSlides: true
	    });
	  };

	  effectInit({
	    effect: 'creative',
	    swiper,
	    on,
	    setTranslate,
	    setTransition,
	    perspective: () => swiper.params.creativeEffect.perspective,
	    overwriteParams: () => ({
	      watchSlidesProgress: true,
	      virtualTranslate: !swiper.params.cssMode
	    })
	  });
	}

	var swiper_main_banner, quanhe_big_title;

	function autoSlideNextOnThumbSlide(initSwiper, element, thumb) {
	  let activeIndex = initSwiper.activeIndex + 1;
	  let activeSlide = document.querySelector(`${element} ${thumb} .swiper-slide:nth-child(${activeIndex})`);
	  let nextSlide = document.querySelector(`${element} ${thumb} .swiper-slide:nth-child(${activeIndex + 1})`);
	  let prevSlide = document.querySelector(`${element} ${thumb} .swiper-slide:nth-child(${activeIndex - 1})`);

	  if (nextSlide && !nextSlide.classList.contains("swiper-slide-visible")) {
	    initSwiper.thumbs.swiper.slideNext();
	  } else if (prevSlide && !prevSlide.classList.contains("swiper-slide-visible")) {
	    initSwiper.thumbs.swiper.slidePrev();
	  }
	}

	function swiperInit() {
	  var swiperParameter = {
	    speed: 500,
	    observer: true,
	    observeParents: true,
	    breakpoints: {
	      1280: {
	        spaceBetween: 32,
	        slidesPerView: 3
	      },
	      1024: {
	        spaceBetween: 24,
	        slidesPerView: 3
	      },
	      576: {
	        spaceBetween: 16,
	        slidesPerView: 2
	      },
	      320: {
	        spaceBetween: 16,
	        slidesPerView: 1.2
	      }
	    }
	  };
	  var swiperParameter_xl_4 = {
	    speed: 500,
	    observer: true,
	    observeParents: true,
	    breakpoints: {
	      1280: {
	        spaceBetween: 32,
	        slidesPerView: 4
	      },
	      1024: {
	        spaceBetween: 24,
	        slidesPerView: 3
	      },
	      576: {
	        spaceBetween: 16,
	        slidesPerView: 2
	      },
	      320: {
	        spaceBetween: 16,
	        slidesPerView: 1.3
	      }
	    }
	  };
	  swiper_main_banner = new Swiper("#main-banner .swiper", {
	    modules: [Pagination, EffectCreative, Navigation],
	    spaceBetween: 0,
	    effect: "creative",
	    creativeEffect: {
	      prev: {
	        shadow: true,
	        translate: ["-20%", 0, -1]
	      },
	      next: {
	        translate: ["100%", 0, 0]
	      }
	    },
	    speed: 500,
	    observer: true,
	    observeParents: true,
	    pagination: {
	      el: "#main-banner .swiper-pagination",
	      clickable: true,
	      renderBullet: function (index, className) {
	        index++;
	        const number = index < 10 ? "0" + index : index;
	        return '<span class="bullet-custom ' + className + '">' + number + "</span>";
	      }
	    },
	    navigation: {
	      prevEl: "#main-banner .swiper-button-prev",
	      nextEl: "#main-banner .swiper-button-next"
	    }
	  });
	  $(".home-3-slide").each(function (e) {
	    $(this).addClass(`home-3-slide-id-${e}`);
	    var home_3 = new Swiper(`.home-3-slide-id-${e} .swiper`, {
	      modules: [Navigation],
	      speed: 500,
	      observer: true,
	      observeParents: true,
	      // allowTouchMove: false,
	      slidesPerView: 1,
	      spaceBetween: 12,
	      navigation: {
	        prevEl: `.home-3-slide-id-${e} .swiper-button-prev`,
	        nextEl: `.home-3-slide-id-${e} .swiper-button-next`
	      }
	    });
	  });
	  var home_4 = new Swiper(`.home-4-slide .swiper`, {
	    modules: [Navigation],
	    ...swiperParameter,
	    navigation: {
	      prevEl: `.home-4-slide .swiper-button-prev`,
	      nextEl: `.home-4-slide .swiper-button-next`
	    }
	  }); // **** Introduce **** //

	  var introduce_3_thumb = new Swiper(".introduce-3 .thumb .swiper", {
	    speed: 800,
	    observer: true,
	    observeParents: true,
	    // allowTouchMove: false,
	    spaceBetween: 0,
	    breakpoints: {
	      1280: {
	        spaceBetween: 0,
	        slidesPerView: "auto"
	      },
	      1024: {
	        spaceBetween: 0,
	        slidesPerView: 5
	      },
	      768: {
	        spaceBetween: 0,
	        slidesPerView: 5
	      },
	      576: {
	        spaceBetween: 0,
	        slidesPerView: 4
	      },
	      320: {
	        spaceBetween: 0,
	        slidesPerView: 3
	      }
	    }
	  });
	  var introduce_3_main = new Swiper(".introduce-3 .main .swiper", {
	    modules: [Thumb, Navigation, Controller],
	    speed: 800,
	    slidesPerView: 1,
	    observer: true,
	    observeParents: true,
	    spaceBetween: 0,
	    thumbs: {
	      swiper: introduce_3_thumb
	    },
	    navigation: {
	      prevEl: ".introduce-3 .swiper-button-prev",
	      nextEl: ".introduce-3 .swiper-button-next"
	    },
	    autoHeight: true,
	    on: {
	      slideChange: function () {
	        //
	        autoSlideNextOnThumbSlide(this, ".introduce-3", ".thumb");
	      }
	    }
	  });
	  var introduce_3_image = new Swiper(".introduce-3-image .swiper", {
	    modules: [EffectCreative],
	    effect: "creative",
	    creativeEffect: {
	      prev: {
	        shadow: true,
	        translate: ["-120%", 0, -500]
	      },
	      next: {
	        shadow: true,
	        translate: ["120%", 0, -500]
	      }
	    },
	    slidesPerView: 1,
	    observer: true,
	    observeParents: true,
	    spaceBetween: 0
	  });
	  introduce_3_main.controller.control = introduce_3_image;
	  $(".avatar-slide").each(function (e) {
	    $(this).addClass(`avatar-slide-id-${e}`);
	    var home_3 = new Swiper(`.avatar-slide-id-${e} .swiper`, {
	      modules: [Navigation],
	      ...swiperParameter_xl_4,
	      navigation: {
	        prevEl: `.avatar-slide-id-${e} .swiper-button-prev`,
	        nextEl: `.avatar-slide-id-${e} .swiper-button-next`
	      }
	    });
	  }); // **** Services **** //

	  var services_detail = new Swiper(".services-detail .swiper", {
	    modules: [Navigation],
	    spaceBetween: 0,
	    // effect: "creative",
	    // creativeEffect: {
	    // 	prev: {
	    // 		shadow: true,
	    // 		translate: ["-20%", 0, -1],
	    // 	},
	    // 	next: {
	    // 		translate: ["100%", 0, 0],
	    // 	},
	    // },
	    speed: 500,
	    observer: true,
	    observeParents: true,
	    navigation: {
	      prevEl: ".services-detail .swiper-button-prev",
	      nextEl: ".services-detail .swiper-button-next"
	    }
	  }); // **** Project **** //

	  var project_detail_1_thumb = new Swiper(".project-detail-1 .thumb .swiper", {
	    speed: 800,
	    observer: true,
	    observeParents: true,
	    // allowTouchMove: false,
	    spaceBetween: 0,
	    breakpoints: {
	      1280: {
	        spaceBetween: 32,
	        slidesPerView: 3
	      },
	      1024: {
	        spaceBetween: 24,
	        slidesPerView: 3
	      },
	      576: {
	        spaceBetween: 16,
	        slidesPerView: 3
	      },
	      320: {
	        spaceBetween: 16,
	        slidesPerView: 2.3
	      }
	    }
	  });
	  var project_detail_1_main = new Swiper(".project-detail-1 .main .swiper", {
	    modules: [Thumb, Navigation, Controller],
	    speed: 800,
	    slidesPerView: 1,
	    observer: true,
	    observeParents: true,
	    spaceBetween: 12,
	    thumbs: {
	      swiper: project_detail_1_thumb
	    },
	    navigation: {
	      prevEl: ".project-detail-1 .swiper-button-prev",
	      nextEl: ".project-detail-1 .swiper-button-next"
	    },
	    autoHeight: true,
	    on: {
	      slideChange: function () {
	        //
	        autoSlideNextOnThumbSlide(this, ".project-detail-1", ".thumb");
	      }
	    }
	  });
	  var project_detail_3 = new Swiper(".project-detail-3 .swiper", {
	    modules: [Navigation, Autoplay],
	    spaceBetween: 0,
	    slidesPerView: 1,
	    speed: 500,
	    loop: true,
	    // loopedSlides: 3,
	    autoplay: {
	      delay: 4500,
	      disableOnInteraction: true
	    },
	    observer: true,
	    observeParents: true,
	    navigation: {
	      prevEl: ".project-detail-3 .swiper-button-prev",
	      nextEl: ".project-detail-3 .swiper-button-next"
	    }
	  }); // **** Quan hệ cổ đông **** //

	  quanhe_big_title = new Swiper(".big-title-slide .swiper", {
	    modules: [Navigation, Autoplay],
	    spaceBetween: 24,
	    slidesPerView: 1,
	    speed: 500,
	    loop: true,
	    observer: true,
	    observeParents: true,
	    navigation: {
	      prevEl: ".big-title-slide .swiper-button-prev",
	      nextEl: ".big-title-slide .swiper-button-next"
	    }
	  }); // **** Other **** //

	  var news_other = new Swiper(".news-other .swiper", {
	    modules: [Pagination, EffectCreative, Navigation],
	    ...swiperParameter,
	    pagination: {
	      el: ".news-other .swiper-pagination",
	      clickable: true
	    },
	    navigation: {
	      prevEl: ".news-other .swiper-button-prev",
	      nextEl: ".news-other .swiper-button-next"
	    }
	  });
	}

	var __assign = undefined && undefined.__assign || function () {
	  return (__assign = Object.assign || function (t) {
	    for (var i, n = 1, s = arguments.length; n < s; n++) for (var a in i = arguments[n]) Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);

	    return t;
	  }).apply(this, arguments);
	},
	    CountUp = function () {
	  function t(t, i, n) {
	    var s = this;
	    this.endVal = i, this.options = n, this.version = "2.4.2", this.defaults = {
	      startVal: 0,
	      decimalPlaces: 0,
	      duration: 2,
	      useEasing: !0,
	      useGrouping: !0,
	      useIndianSeparators: !1,
	      smartEasingThreshold: 999,
	      smartEasingAmount: 333,
	      separator: ",",
	      decimal: ".",
	      prefix: "",
	      suffix: "",
	      enableScrollSpy: !1,
	      scrollSpyDelay: 200,
	      scrollSpyOnce: !1
	    }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function (t) {
	      s.startTime || (s.startTime = t);
	      var i = t - s.startTime;
	      s.remaining = s.duration - i, s.useEasing ? s.countDown ? s.frameVal = s.startVal - s.easingFn(i, 0, s.startVal - s.endVal, s.duration) : s.frameVal = s.easingFn(i, s.startVal, s.endVal - s.startVal, s.duration) : s.frameVal = s.startVal + (s.endVal - s.startVal) * (i / s.duration);
	      var n = s.countDown ? s.frameVal < s.endVal : s.frameVal > s.endVal;
	      s.frameVal = n ? s.endVal : s.frameVal, s.frameVal = Number(s.frameVal.toFixed(s.options.decimalPlaces)), s.printValue(s.frameVal), i < s.duration ? s.rAF = requestAnimationFrame(s.count) : null !== s.finalEndVal ? s.update(s.finalEndVal) : s.callback && s.callback();
	    }, this.formatNumber = function (t) {
	      var i,
	          n,
	          a,
	          e,
	          r = t < 0 ? "-" : "";
	      i = Math.abs(t).toFixed(s.options.decimalPlaces);
	      var o = (i += "").split(".");

	      if (n = o[0], a = o.length > 1 ? s.options.decimal + o[1] : "", s.options.useGrouping) {
	        e = "";

	        for (var l = 3, h = 0, u = 0, p = n.length; u < p; ++u) s.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = s.options.separator + e), h++, e = n[p - u - 1] + e;

	        n = e;
	      }

	      return s.options.numerals && s.options.numerals.length && (n = n.replace(/[0-9]/g, function (t) {
	        return s.options.numerals[+t];
	      }), a = a.replace(/[0-9]/g, function (t) {
	        return s.options.numerals[+t];
	      })), r + s.options.prefix + n + a + s.options.suffix;
	    }, this.easeOutExpo = function (t, i, n, s) {
	      return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
	    }, this.options = __assign(__assign({}, this.defaults), n), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof t ? document.getElementById(t) : t, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, t) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function () {
	      return s.handleScroll(s);
	    }), window.onscroll = function () {
	      window.onScrollFns.forEach(function (t) {
	        return t();
	      });
	    }, this.handleScroll(this)));
	  }

	  return t.prototype.handleScroll = function (t) {
	    if (t && window && !t.once) {
	      var i = window.innerHeight + window.scrollY,
	          n = t.el.getBoundingClientRect(),
	          s = n.top + window.pageYOffset,
	          a = n.top + n.height + window.pageYOffset;
	      a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function () {
	        return t.start();
	      }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
	    }
	  }, t.prototype.determineDirectionAndSmartEasing = function () {
	    var t = this.finalEndVal ? this.finalEndVal : this.endVal;
	    this.countDown = this.startVal > t;
	    var i = t - this.startVal;

	    if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
	      this.finalEndVal = t;
	      var n = this.countDown ? 1 : -1;
	      this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
	    } else this.endVal = t, this.finalEndVal = null;

	    null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
	  }, t.prototype.start = function (t) {
	    this.error || (this.callback = t, this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
	  }, t.prototype.pauseResume = function () {
	    this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
	  }, t.prototype.reset = function () {
	    cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
	  }, t.prototype.update = function (t) {
	    cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
	  }, t.prototype.printValue = function (t) {
	    var i = this.formattingFn(t);
	    this.el && ("INPUT" === this.el.tagName ? this.el.value = i : "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = i : this.el.innerHTML = i);
	  }, t.prototype.ensureNumber = function (t) {
	    return "number" == typeof t && !isNaN(t);
	  }, t.prototype.validateValue = function (t) {
	    var i = Number(t);
	    return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
	  }, t.prototype.resetDuration = function () {
	    this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
	  }, t;
	}();

	/*! lozad.js - v1.16.0 - 2020-09-06
	* https://github.com/ApoorvSaxena/lozad.js
	* Copyright (c) 2020 Apoorv Saxena; Licensed MIT */

	/**
	 * Detect IE browser
	 * @const {boolean}
	 * @private
	 */
	const isIE = typeof document !== 'undefined' && document.documentMode;
	const defaultConfig = {
	  rootMargin: '0px',
	  threshold: 0,

	  load(element) {
	    if (element.nodeName.toLowerCase() === 'picture') {
	      let img = element.querySelector('img');
	      let append = false;

	      if (img === null) {
	        img = document.createElement('img');
	        append = true;
	      }

	      if (isIE && element.getAttribute('data-iesrc')) {
	        img.src = element.getAttribute('data-iesrc');
	      }

	      if (element.getAttribute('data-alt')) {
	        img.alt = element.getAttribute('data-alt');
	      }

	      if (append) {
	        element.append(img);
	      }
	    }

	    if (element.nodeName.toLowerCase() === 'video' && !element.getAttribute('data-src')) {
	      if (element.children) {
	        const childs = element.children;
	        let childSrc;

	        for (let i = 0; i <= childs.length - 1; i++) {
	          childSrc = childs[i].getAttribute('data-src');

	          if (childSrc) {
	            childs[i].src = childSrc;
	          }
	        }

	        element.load();
	      }
	    }

	    if (element.getAttribute('data-poster')) {
	      element.poster = element.getAttribute('data-poster');
	    }

	    if (element.getAttribute('data-src')) {
	      element.src = element.getAttribute('data-src');
	    }

	    if (element.getAttribute('data-srcset')) {
	      element.setAttribute('srcset', element.getAttribute('data-srcset'));
	    }

	    let backgroundImageDelimiter = ',';

	    if (element.getAttribute('data-background-delimiter')) {
	      backgroundImageDelimiter = element.getAttribute('data-background-delimiter');
	    }

	    if (element.getAttribute('data-background-image')) {
	      element.style.backgroundImage = `url('${element.getAttribute('data-background-image').split(backgroundImageDelimiter).join('\'),url(\'')}')`;
	    } else if (element.getAttribute('data-background-image-set')) {
	      const imageSetLinks = element.getAttribute('data-background-image-set').split(backgroundImageDelimiter);
	      let firstUrlLink = imageSetLinks[0].substr(0, imageSetLinks[0].indexOf(' ')) || imageSetLinks[0]; // Substring before ... 1x

	      firstUrlLink = firstUrlLink.indexOf('url(') === -1 ? `url(${firstUrlLink})` : firstUrlLink;

	      if (imageSetLinks.length === 1) {
	        element.style.backgroundImage = firstUrlLink;
	      } else {
	        element.setAttribute('style', (element.getAttribute('style') || '') + `background-image: ${firstUrlLink}; background-image: -webkit-image-set(${imageSetLinks}); background-image: image-set(${imageSetLinks})`);
	      }
	    }

	    if (element.getAttribute('data-toggle-class')) {
	      element.classList.toggle(element.getAttribute('data-toggle-class'));
	    }
	  },

	  loaded() {}

	};

	function markAsLoaded(element) {
	  element.setAttribute('data-loaded', true);
	}

	function preLoad(element) {
	  if (element.getAttribute('data-placeholder-background')) {
	    element.style.background = element.getAttribute('data-placeholder-background');
	  }
	}

	const isLoaded = element => element.getAttribute('data-loaded') === 'true';

	const onIntersection = (load, loaded) => (entries, observer) => {
	  entries.forEach(entry => {
	    if (entry.intersectionRatio > 0 || entry.isIntersecting) {
	      observer.unobserve(entry.target);

	      if (!isLoaded(entry.target)) {
	        load(entry.target);
	        markAsLoaded(entry.target);
	        loaded(entry.target);
	      }
	    }
	  });
	};

	const getElements = (selector, root = document) => {
	  if (selector instanceof Element) {
	    return [selector];
	  }

	  if (selector instanceof NodeList) {
	    return selector;
	  }

	  return root.querySelectorAll(selector);
	};

	function lozad(selector = '.lozad', options = {}) {
	  const {
	    root,
	    rootMargin,
	    threshold,
	    load,
	    loaded
	  } = Object.assign({}, defaultConfig, options);
	  let observer;

	  if (typeof window !== 'undefined' && window.IntersectionObserver) {
	    observer = new IntersectionObserver(onIntersection(load, loaded), {
	      root,
	      rootMargin,
	      threshold
	    });
	  }

	  const elements = getElements(selector, root);

	  for (let i = 0; i < elements.length; i++) {
	    preLoad(elements[i]);
	  }

	  return {
	    observe() {
	      const elements = getElements(selector, root);

	      for (let i = 0; i < elements.length; i++) {
	        if (isLoaded(elements[i])) {
	          continue;
	        }

	        if (observer) {
	          observer.observe(elements[i]);
	          continue;
	        }

	        load(elements[i]);
	        markAsLoaded(elements[i]);
	        loaded(elements[i]);
	      }
	    },

	    triggerLoad(element) {
	      if (isLoaded(element)) {
	        return;
	      }

	      load(element);
	      markAsLoaded(element);
	      loaded(element);
	    },

	    observer
	  };
	}

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var aos = createCommonjsModule(function (module, exports) {
	!function (e, t) {
	   module.exports = t() ;
	}(commonjsGlobal, function () {
	  return function (e) {
	    function t(o) {
	      if (n[o]) return n[o].exports;
	      var i = n[o] = {
	        exports: {},
	        id: o,
	        loaded: !1
	      };
	      return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
	    }

	    var n = {};
	    return t.m = e, t.c = n, t.p = "dist/", t(0);
	  }([function (e, t, n) {

	    function o(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }

	    var i = Object.assign || function (e) {
	      for (var t = 1; t < arguments.length; t++) {
	        var n = arguments[t];

	        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
	      }

	      return e;
	    },
	        r = n(1),
	        a = (o(r), n(6)),
	        u = o(a),
	        c = n(7),
	        s = o(c),
	        f = n(8),
	        d = o(f),
	        l = n(9),
	        p = o(l),
	        m = n(10),
	        b = o(m),
	        v = n(11),
	        y = o(v),
	        g = n(14),
	        h = o(g),
	        w = [],
	        k = !1,
	        x = {
	      offset: 120,
	      delay: 0,
	      easing: "ease",
	      duration: 400,
	      disable: !1,
	      once: !1,
	      startEvent: "DOMContentLoaded",
	      throttleDelay: 99,
	      debounceDelay: 50,
	      disableMutationObserver: !1
	    },
	        j = function () {
	      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
	      if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
	    },
	        O = function () {
	      w = (0, h.default)(), j();
	    },
	        M = function () {
	      w.forEach(function (e, t) {
	        e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
	      });
	    },
	        S = function (e) {
	      return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
	    },
	        _ = function (e) {
	      x = i(x, e), w = (0, h.default)();
	      var t = document.all && !window.atob;
	      return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function () {
	        j(!0);
	      }) : document.addEventListener(x.startEvent, function () {
	        j(!0);
	      }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () {
	        (0, b.default)(w, x.once);
	      }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
	    };

	    e.exports = {
	      init: _,
	      refresh: j,
	      refreshHard: O
	    };
	  }, function (e, t) {},,,,, function (e, t) {
	    (function (t) {

	      function n(e, t, n) {
	        function o(t) {
	          var n = b,
	              o = v;
	          return b = v = void 0, k = t, g = e.apply(o, n);
	        }

	        function r(e) {
	          return k = e, h = setTimeout(f, t), M ? o(e) : g;
	        }

	        function a(e) {
	          var n = e - w,
	              o = e - k,
	              i = t - n;
	          return S ? j(i, y - o) : i;
	        }

	        function c(e) {
	          var n = e - w,
	              o = e - k;
	          return void 0 === w || n >= t || n < 0 || S && o >= y;
	        }

	        function f() {
	          var e = O();
	          return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
	        }

	        function d(e) {
	          return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
	        }

	        function l() {
	          void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
	        }

	        function p() {
	          return void 0 === h ? g : d(O());
	        }

	        function m() {
	          var e = O(),
	              n = c(e);

	          if (b = arguments, v = this, w = e, n) {
	            if (void 0 === h) return r(w);
	            if (S) return h = setTimeout(f, t), o(w);
	          }

	          return void 0 === h && (h = setTimeout(f, t)), g;
	        }

	        var b,
	            v,
	            y,
	            g,
	            h,
	            w,
	            k = 0,
	            M = !1,
	            S = !1,
	            _ = !0;

	        if ("function" != typeof e) throw new TypeError(s);
	        return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
	      }

	      function o(e, t, o) {
	        var r = !0,
	            a = !0;
	        if ("function" != typeof e) throw new TypeError(s);
	        return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
	          leading: r,
	          maxWait: t,
	          trailing: a
	        });
	      }

	      function i(e) {
	        var t = "undefined" == typeof e ? "undefined" : c(e);
	        return !!e && ("object" == t || "function" == t);
	      }

	      function r(e) {
	        return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
	      }

	      function a(e) {
	        return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
	      }

	      function u(e) {
	        if ("number" == typeof e) return e;
	        if (a(e)) return f;

	        if (i(e)) {
	          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
	          e = i(t) ? t + "" : t;
	        }

	        if ("string" != typeof e) return 0 === e ? e : +e;
	        e = e.replace(l, "");
	        var n = m.test(e);
	        return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
	      }

	      var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
	        return typeof e;
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	      },
	          s = "Expected a function",
	          f = NaN,
	          d = "[object Symbol]",
	          l = /^\s+|\s+$/g,
	          p = /^[-+]0x[0-9a-f]+$/i,
	          m = /^0b[01]+$/i,
	          b = /^0o[0-7]+$/i,
	          v = parseInt,
	          y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t,
	          g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self,
	          h = y || g || Function("return this")(),
	          w = Object.prototype,
	          k = w.toString,
	          x = Math.max,
	          j = Math.min,
	          O = function () {
	        return h.Date.now();
	      };

	      e.exports = o;
	    }).call(t, function () {
	      return this;
	    }());
	  }, function (e, t) {
	    (function (t) {

	      function n(e, t, n) {
	        function i(t) {
	          var n = b,
	              o = v;
	          return b = v = void 0, O = t, g = e.apply(o, n);
	        }

	        function r(e) {
	          return O = e, h = setTimeout(f, t), M ? i(e) : g;
	        }

	        function u(e) {
	          var n = e - w,
	              o = e - O,
	              i = t - n;
	          return S ? x(i, y - o) : i;
	        }

	        function s(e) {
	          var n = e - w,
	              o = e - O;
	          return void 0 === w || n >= t || n < 0 || S && o >= y;
	        }

	        function f() {
	          var e = j();
	          return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
	        }

	        function d(e) {
	          return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
	        }

	        function l() {
	          void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
	        }

	        function p() {
	          return void 0 === h ? g : d(j());
	        }

	        function m() {
	          var e = j(),
	              n = s(e);

	          if (b = arguments, v = this, w = e, n) {
	            if (void 0 === h) return r(w);
	            if (S) return h = setTimeout(f, t), i(w);
	          }

	          return void 0 === h && (h = setTimeout(f, t)), g;
	        }

	        var b,
	            v,
	            y,
	            g,
	            h,
	            w,
	            O = 0,
	            M = !1,
	            S = !1,
	            _ = !0;

	        if ("function" != typeof e) throw new TypeError(c);
	        return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
	      }

	      function o(e) {
	        var t = "undefined" == typeof e ? "undefined" : u(e);
	        return !!e && ("object" == t || "function" == t);
	      }

	      function i(e) {
	        return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
	      }

	      function r(e) {
	        return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
	      }

	      function a(e) {
	        if ("number" == typeof e) return e;
	        if (r(e)) return s;

	        if (o(e)) {
	          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
	          e = o(t) ? t + "" : t;
	        }

	        if ("string" != typeof e) return 0 === e ? e : +e;
	        e = e.replace(d, "");
	        var n = p.test(e);
	        return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
	      }

	      var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
	        return typeof e;
	      } : function (e) {
	        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	      },
	          c = "Expected a function",
	          s = NaN,
	          f = "[object Symbol]",
	          d = /^\s+|\s+$/g,
	          l = /^[-+]0x[0-9a-f]+$/i,
	          p = /^0b[01]+$/i,
	          m = /^0o[0-7]+$/i,
	          b = parseInt,
	          v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t,
	          y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self,
	          g = v || y || Function("return this")(),
	          h = Object.prototype,
	          w = h.toString,
	          k = Math.max,
	          x = Math.min,
	          j = function () {
	        return g.Date.now();
	      };

	      e.exports = n;
	    }).call(t, function () {
	      return this;
	    }());
	  }, function (e, t) {

	    function n(e) {
	      var t = void 0,
	          o = void 0,
	          i = void 0;

	      for (t = 0; t < e.length; t += 1) {
	        if (o = e[t], o.dataset && o.dataset.aos) return !0;
	        if (i = o.children && n(o.children)) return !0;
	      }

	      return !1;
	    }

	    function o() {
	      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	    }

	    function i() {
	      return !!o();
	    }

	    function r(e, t) {
	      var n = window.document,
	          i = o(),
	          r = new i(a);
	      u = t, r.observe(n.documentElement, {
	        childList: !0,
	        subtree: !0,
	        removedNodes: !0
	      });
	    }

	    function a(e) {
	      e && e.forEach(function (e) {
	        var t = Array.prototype.slice.call(e.addedNodes),
	            o = Array.prototype.slice.call(e.removedNodes),
	            i = t.concat(o);
	        if (n(i)) return u();
	      });
	    }

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var u = function () {};

	    t.default = {
	      isSupported: i,
	      ready: r
	    };
	  }, function (e, t) {

	    function n(e, t) {
	      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
	    }

	    function o() {
	      return navigator.userAgent || navigator.vendor || window.opera || "";
	    }

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var i = function () {
	      function e(e, t) {
	        for (var n = 0; n < t.length; n++) {
	          var o = t[n];
	          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
	        }
	      }

	      return function (t, n, o) {
	        return n && e(t.prototype, n), o && e(t, o), t;
	      };
	    }(),
	        r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
	        c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        s = function () {
	      function e() {
	        n(this, e);
	      }

	      return i(e, [{
	        key: "phone",
	        value: function () {
	          var e = o();
	          return !(!r.test(e) && !a.test(e.substr(0, 4)));
	        }
	      }, {
	        key: "mobile",
	        value: function () {
	          var e = o();
	          return !(!u.test(e) && !c.test(e.substr(0, 4)));
	        }
	      }, {
	        key: "tablet",
	        value: function () {
	          return this.mobile() && !this.phone();
	        }
	      }]), e;
	    }();

	    t.default = new s();
	  }, function (e, t) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var n = function (e, t, n) {
	      var o = e.node.getAttribute("data-aos-once");
	      t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
	    },
	        o = function (e, t) {
	      var o = window.pageYOffset,
	          i = window.innerHeight;
	      e.forEach(function (e, r) {
	        n(e, i + o, t);
	      });
	    };

	    t.default = o;
	  }, function (e, t, n) {

	    function o(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var i = n(12),
	        r = o(i),
	        a = function (e, t) {
	      return e.forEach(function (e, n) {
	        e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
	      }), e;
	    };

	    t.default = a;
	  }, function (e, t, n) {

	    function o(e) {
	      return e && e.__esModule ? e : {
	        default: e
	      };
	    }

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var i = n(13),
	        r = o(i),
	        a = function (e, t) {
	      var n = 0,
	          o = 0,
	          i = window.innerHeight,
	          a = {
	        offset: e.getAttribute("data-aos-offset"),
	        anchor: e.getAttribute("data-aos-anchor"),
	        anchorPlacement: e.getAttribute("data-aos-anchor-placement")
	      };

	      switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) {
	        case "top-bottom":
	          break;

	        case "center-bottom":
	          n += e.offsetHeight / 2;
	          break;

	        case "bottom-bottom":
	          n += e.offsetHeight;
	          break;

	        case "top-center":
	          n += i / 2;
	          break;

	        case "bottom-center":
	          n += i / 2 + e.offsetHeight;
	          break;

	        case "center-center":
	          n += i / 2 + e.offsetHeight / 2;
	          break;

	        case "top-top":
	          n += i;
	          break;

	        case "bottom-top":
	          n += e.offsetHeight + i;
	          break;

	        case "center-top":
	          n += e.offsetHeight / 2 + i;
	      }

	      return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
	    };

	    t.default = a;
	  }, function (e, t) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var n = function (e) {
	      for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;

	      return {
	        top: n,
	        left: t
	      };
	    };

	    t.default = n;
	  }, function (e, t) {

	    Object.defineProperty(t, "__esModule", {
	      value: !0
	    });

	    var n = function (e) {
	      return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) {
	        return {
	          node: e
	        };
	      });
	    };

	    t.default = n;
	  }]);
	});
	});

	var Aos = unwrapExports(aos);
	var aos_1 = aos.AOS;

	$.fn.hasAttr = function (name) {
	  return this.attr(name) !== undefined;
	}; // ******* Global Variable s*******
	// *** Window


	var ww = $(window).width();
	var body = $("body"); // *** Header *** //

	var header = $("header");
	var height_header = header.outerHeight();
	var menu_nav = header.find("nav");
	var burger = header.find("#burger");
	var overlay = $("#overlay"); // *** Nav Mobile *** //

	var nav_mobile = $(".nav-mobile");
	var roundedDiv = $(".rounded-div");
	var close_NB = nav_mobile.find(".close-nav-mobile"); // *** Banner *** //

	var pagesBanner = $("#page-banner");
	var mainBanner = $("#main-banner"); // *** Footer *** //

	$(".search-overlay").removeClass("active");
	var footer = $("footer"); // *** Component *** //

	const headerFunction = {
	  onScroll: () => {
	    var lastScroll = 0;
	    $(window).on("scroll", function () {
	      var currentScroll = $(this).scrollTop();

	      if (currentScroll >= height_header) {
	        header.addClass("header-active");

	        if (currentScroll > lastScroll) {
	          header.addClass("header-scroll");
	        } else {
	          header.removeClass("header-scroll");
	        }

	        lastScroll = currentScroll;
	      } else {
	        header.removeClass("header-active");
	      }
	    });
	  },
	  removeActiveCpn: () => {
	    roundedDiv.removeClass("active");
	    burger.removeClass("active");
	    nav_mobile.removeClass("active");
	    overlay.removeClass("active");
	    body.removeClass("ovh");
	    header.removeClass("navMobileOpen");
	  },
	  navMobileSlide: () => {
	    burger.on("click", function () {
	      burger.toggleClass("active");
	      nav_mobile.toggleClass("active");
	      overlay.toggleClass("active");
	      body.toggleClass("ovh");
	      header.toggleClass("navMobileOpen");
	      roundedDiv.toggleClass("active");
	    });
	    overlay.on("click", function () {
	      headerFunction.removeActiveCpn();
	    });
	    close_NB.on("click", function () {
	      headerFunction.removeActiveCpn();
	    });
	  },
	  searchActive: () => {
	    //
	    $(".search-icon").on("click", function () {
	      $(".search-icon").addClass("active");
	      header.find(".search-overlay").addClass("active");
	      setTimeout(() => {
	        header.find(".search-overlay input").trigger("focus");
	      }, 500);
	    });
	    var input = $(".search-overlay .searchbox input");
	    input.on("focus", function () {
	      header.find(".search-overlay").addClass("active");
	    });
	    input.on("focusout", function () {
	      header.find(".search-overlay").removeClass("active");
	    });
	    $(document).on("click", function (event) {
	      var $trigger = $("header");
	      var $trigger_2 = $(".search-overlay");

	      if ($trigger !== event.target && !$trigger.has(event.target).length && $trigger_2 !== event.target && !$trigger_2.has(event.target).length) {
	        header.find(".search-overlay").removeClass("active");
	        $(".search-icon").removeClass("active");
	      }
	    }); // Press ESC to close Search

	    setTimeout(() => {
	      $(window).on("keyup", function (event) {
	        var e = event.keyCode;

	        if (e == 27) {
	          header.find(".search-overlay").removeClass("active");
	          $(".search-icon").removeClass("active");
	        }
	      });
	    }, 500);
	  },
	  escBtn: () => {
	    $(window).on("keyup", function (event) {
	      var e = event.keyCode;

	      if (e == 27) {
	        roundedDiv.removeClass("active");
	        nav_mobile.removeClass("active");
	        header.removeClass("blur-content");
	        burger.removeClass("active");
	        overlay.removeClass("active");
	        body.removeClass("ovh");
	        header.removeClass("navMobileOpen");
	      }
	    });
	  },
	  toggleChildMenu: () => {
	    $(document).on("click", ".nav-mobile nav li.menu-item-has-children >.title", function (e) {
	      if (e.target.nodeName != "A") {
	        $(this).closest("li").siblings().find("> ul").slideUp();
	        $(this).closest("li").find("> ul").slideToggle();
	        $(this).closest("li").siblings().removeClass("toggle-dropdown");
	        $(this).closest("li").toggleClass("toggle-dropdown");
	      }
	    });
	  },
	  init: () => {
	    headerFunction.onScroll();
	    headerFunction.navMobileSlide();
	    headerFunction.searchActive();
	    headerFunction.toggleChildMenu();
	    headerFunction.escBtn();
	  }
	};

	function counterUpNumber(separator = ".") {
	  const options = {
	    separator: separator,
	    enableScrollSpy: true
	  };
	  var counters = document.querySelectorAll(".counter");
	  counters.forEach(counter => {
	    var countUp = new CountUp(counter, counter.textContent, options);
	    countUp.start();
	  });
	}

	function fancyboxCustom() {
	  var closeCircle = `<button data-fancybox-close class='f-button is-close-btn' title='{{CLOSE}}'><i class="fa-regular fa-xmark"></i></button>`;
	  var closeNormal = `<button data-fancybox-close class='f-button is-close-btn' title='{{CLOSE}}'><i class="fa-regular fa-xmark"></i></button>`;
	  xt.bind("[data-fancybox]", {
	    on: {
	      done: fancybox => {}
	    }
	  });
	  $("[data-fancybox]").each(function () {
	    var customFancybox = "data-popup";
	    var name = $(this).attr(customFancybox);
	    var hasCloseNormal = $(this).attr("data-close-normal");

	    if (name != customFancybox) {
	      $(this).attr(name, "");
	      xt.bind(`[${name}]`, {
	        dragToClose: false,
	        mainClass: hasCloseNormal == "" ? `${name} has-custom-close-normal-button` : `${name} has-custom-close-button`,
	        tpl: {
	          closeButton: hasCloseNormal == "" ? closeNormal : closeCircle
	        },
	        on: {
	          done: function () {
	            console.log("open");
	          },
	          closing: function () {
	            console.log("close");
	          }
	        }
	      });
	    }
	  });
	}

	function useVariables() {
	  return {
	    swiper_main_banner,
	    quanhe_big_title,
	    lozadInit
	  }; // externalJS.useVariables().quanhe_big_title;
	}

	function onLoadToSection() {
	  var path = window.location.href;
	  let destination = "#" + path.substr(path.indexOf("#") + 1);
	  if (destination.length > 1) if ($(destination)?.offset()?.top) $("html, body").animate({
	    scrollTop: $(destination).offset().top - height_header
	  }, "slow");
	}

	function secondToTimeFormat(seconds) {
	  const minutes = Math.floor(seconds / 60);
	  const remainingSeconds = seconds % 60;
	  const formattedMinutes = String(minutes).padStart(2, "0");
	  const formattedSeconds = String(remainingSeconds).padStart(2, "0");
	  return `${formattedMinutes}:${formattedSeconds}`;
	}

	function swiperVideo(autoPlayNextVideo, playFirstVideo) {
	  /**
	   * @param true for auto play next video
	   */
	  if (mainBanner.length == 1) {
	    let timer; // Clear Timeout Cache

	    function slideNext(time) {
	      window.clearTimeout(timer);
	      timer = setTimeout(() => {
	        swiper_main_banner.slideNext();
	      }, time);
	    }

	    swiper_main_banner.on("slideChangeTransitionStart", function (slide) {
	      $("body").removeClass("videoStartPlaying");
	      var videos = document.querySelectorAll("#main-banner video");
	      videos.forEach(video => {
	        video.pause();
	        video.currentTime = 0;
	        $(video).closest(".swiper-slide").removeClass("playVideo");
	        $(video).closest(".swiper-slide").find(".button-play").removeClass("play");
	      });
	      setTimeout(() => {
	        if ($("#main-banner .swiper-slide-active video").length != 1) {
	          slideNext(5000);
	        } else {
	          slideNext(99999999);
	          if (autoPlayNextVideo) setTimeout(() => {
	            var activeVideo = document.querySelector("#main-banner .swiper .swiper-slide-active video");
	            getVideoData(activeVideo);
	            $("#main-banner .swiper .swiper-slide").removeClass("playVideo");
	            $("#main-banner .swiper .swiper-slide").eq(slide.activeIndex).addClass("playVideo");
	          }, 500);
	        }
	      }, 100); // console.log("🤌 ~ slide:", slide);
	    });

	    async function getVideoData(video) {
	      try {
	        if (video.paused || video.ended) {
	          await video.play();
	          $(video).closest(".swiper-slide").find(".button-play").addClass("play");
	          video.addEventListener("timeupdate", function () {
	            const videoDuration = Math.round(video.duration); // console.log("videoDuration", videoDuration);

	            const videoCurrent = Math.round(video.currentTime); // console.log("videoCurrent", videoCurrent);

	            $(video).closest(".swiper-slide").find(".button-play .currentTime").text(secondToTimeFormat(videoCurrent));
	            $(video).closest(".swiper-slide").find(".button-play .durationTime").text(secondToTimeFormat(videoDuration));
	            $(video).closest(".swiper-slide").find(".button-play .timeline").css({
	              "--data-time": videoCurrent / videoDuration * 100 + "%"
	            });

	            if (videoDuration == videoCurrent) {
	              video.pause();
	              video.currentTime = 0;
	              $(video).closest(".swiper-slide").find(".button-play .timeHandler").slideUp();
	              setTimeout(() => {
	                swiper_main_banner.slideNext();
	              }, 1500);
	            }
	          });
	          $(video).closest(".swiper-slide").find(".button-play .timeHandler").slideDown();
	          $("body").addClass("videoStartPlaying");
	        } else {
	          $("body").removeClass("videoStartPlaying");
	          video.pause(); // $(video).closest(".swiper-slide").removeClass("playVideo");

	          $(video).closest(".swiper-slide").find(".button-play").removeClass("play");
	        }
	      } catch (err) {
	        console.log(err);
	        $(video).closest(".swiper-slide").find(".button-play").removeClass("play");
	        $(video).closest(".swiper-slide").removeClass("playVideo");
	      }
	    }

	    $(".button-play").on("click", function () {
	      var activeVideo = document.querySelector("#main-banner .swiper .swiper-slide-active video");
	      getVideoData(activeVideo); // swiper_main_banner.autoplay.stop();

	      $(this).closest(".swiper").find(".swiper-slide").removeClass("playVideo");
	      $(this).closest(".swiper-slide").addClass("playVideo");
	    }); // On load

	    if (playFirstVideo) if ($("#main-banner .swiper-slide").eq(0).find("video").length == 1) {
	      var activeVideo = document.querySelector("#main-banner .swiper .swiper-slide-active video");
	      fetchVideo(activeVideo.getAttribute("data-src")).then(function (videoResponse) {
	        if (videoResponse && videoResponse.status === 200) {
	          setTimeout(() => {
	            console.log("Video status: ", videoResponse.statusText);
	            getVideoData(activeVideo);
	            $(".swiper").find(".swiper-slide").eq(0).addClass("playVideo");
	          }, 1000);
	        } else {
	          console.log("Failed to fetch video");
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  }
	}

	async function fetchVideo(src) {
	  try {
	    const video = await fetch(src);
	    return video;
	  } catch (error) {
	    console.log(error);
	  }
	}

	const noVideoFound = "No Video Found";

	function youtubeCustom() {
	  var target = $(".has-youtube-video");
	  var autoLoading = target.hasAttr("auto-load"); // console.log("🤌 ~ youtubeCustom ~ autoLoading:", autoLoading);
	  // Load the YouTube script asynchronously

	  var tag = document.createElement("script");
	  tag.src = "https://www.youtube.com/player_api";
	  var firstScriptTag = document.getElementsByTagName("script")[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag); // Wait for the YouTube script to load

	  var youtubeScriptLoaded = new Promise(resolve => {
	    window.onYouTubePlayerAPIReady = function () {
	      resolve();
	    };
	  });
	  target.each(function (index) {
	    var element = $(this);
	    var click = 0;
	    var player;
	    var button = $(this).find(".video-toggle");

	    if (autoLoading) {
	      triggerYoutubeLoad(index, element, target);
	    } else {
	      button.on("click", function () {
	        triggerYoutubeLoad(index, element, target);
	      });
	    }

	    function triggerYoutubeLoad(index, element, target) {
	      click++;

	      if (click == 1) {
	        var youtubeUrl = element.closest(target).attr("data-embed");
	        const youtubeEmbedLink = generateYouTubeEmbed(youtubeUrl);

	        if (youtubeEmbedLink !== "No Video Found") {
	          element.closest(target).append(`<iframe
			  id='VYT-place-${index}'
			  src=${youtubeEmbedLink}
			  frameborder="0"
			  allow="autoplay"
			  allowfullscreen=""
			  style=""
			></iframe>`); // Wait for the YouTube script to load before calling VideoLoad

	          youtubeScriptLoaded.then(() => {
	            VideoLoad(`VYT-place-${index}`, target);
	          });
	        } else if (click == 1 && youtubeEmbedLink === "No Video Found") {
	          element.closest(target).append("Sai đường dẫn video");
	        }
	      }
	    }

	    function VideoLoad(id, target) {
	      function playVideo() {
	        player.playVideo();
	      }

	      function pauseVideo() {
	        player.pauseVideo();
	        element.find("iframe").attr("style", "");
	      }

	      function createPlayer() {
	        player = new YT.Player(id, {
	          events: {
	            onReady: onPlayerReady,
	            onStateChange: onPlayerStateChange
	          }
	        });
	      }

	      createPlayer();

	      function onPlayerReady(event) {
	        target.find(".title").text(event.target.videoTitle);
	        event.target.setOption("playerVars", {
	          modestbranding: 1,
	          rel: 1,
	          showinfo: 0
	        });
	        player.playVideo();
	        element.find("iframe").attr("style", "");
	      } //! Pause video on swiper change
	      // if (project_detail_3 && project_detail_3.enabled && !videoLoaded) {
	      // 	project_detail_3.on("slideChangeTransitionStart", function () {
	      // 		pauseVideo();
	      // 	});
	      // }


	      function onPlayerStateChange() {
	        // console.log(YT.PlayerState);
	        // console.log(event.data);
	        var data = JSON.parse(event.data);

	        if (data.info == YT.PlayerState.PLAYING) {
	          target.addClass("active");
	          button.addClass("active");
	        } else {
	          target.removeClass("active");
	          button.removeClass("active");
	        }
	      }

	      button.on("click", function () {
	        //Paused
	        if (player.playerInfo.playerState == 1) {
	          pauseVideo();
	        } else {
	          playVideo();
	        }
	      });
	    }
	  });
	}

	function generateYouTubeEmbed(url) {
	  // Regular expression for matching YouTube URLs
	  var urlRegex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/; // Try to extract a valid video ID from the URL using the regular expression

	  var match = url.match(urlRegex);

	  if (match && match[2].length == 11) {
	    // If a valid video ID was found, generate and return the complete YouTube embed URL with autoplay and other options
	    var videoId = match[2];
	    var embedUrl = "https://www.youtube.com/embed/" + videoId + "?&enablejsapi=1&controls=0&loop=0&playsinline=1&color=white&rel=0&cc_load_policy=1&modestbranding=1&playlist=" + videoId;
	    return embedUrl;
	  } else {
	    // If no valid video ID was found, return "no video found"
	    return noVideoFound;
	  }
	}

	function toggleFaqsAskModule() {
	  var item = $(".faqs-module .item .top");
	  item.on("click", function () {
	    $(this).parent().toggleClass("active");
	    $(this).siblings().slideToggle();
	  });
	}

	function customScrollBar() {
	  $(".scroll-nav").each(function (e) {
	    if ($(this).find("nav ul").width() > $(this).find("nav").width()) {
	      $(this).addClass(`scroll-nav-id-${e}`);
	      var parent = $(this).closest(".scroll-nav-wrapper");
	      $(`.scroll-nav-id-${e}`).mCustomScrollbar({
	        scrollButtons: {
	          enable: true
	        },
	        theme: "light-thick",
	        scrollbarPosition: "inside",
	        scrollEasing: "linear",
	        scrollInertia: 150,
	        axis: "x",
	        callbacks: {
	          onInit: function () {
	            $(this).find(".mCSB_scrollTools").wrapInner("<div class='wrapper-scroll'></div>");
	          },
	          onOverflowX: function () {
	            parent.addClass("active");
	            $(this).addClass("show-scroll");
	            $(`.scroll-nav-id-${e}`).mCustomScrollbar("scrollTo", 0);
	          },
	          onOverflowXNone: function () {
	            parent.removeClass("active");
	            $(this).removeClass("show-scroll");
	            console.log("mCustomScrollbar turn off");
	          }
	        }
	      });
	      $(this).find("li a").on("click touchstart", function (element) {
	        element.preventDefault();
	        $(this).parent().siblings().removeClass("active");
	        $(this).parent().addClass("active");
	        $(`.scroll-nav-id-${e}`).mCustomScrollbar("scrollTo", $(this));
	      });
	    }
	  });
	}

	const homeTemplate = {
	  toggleServices: () => {
	    $(".home-1 .item a").on("mouseenter", function () {
	      var $this = $(this);
	      if ($this.is(".active")) return null;
	      var imageUrl = $(this).attr("data-image");
	      $this.siblings().removeClass("active");
	      $this.addClass("active");
	      $this.closest(".item").find("img").attr("src", imageUrl);

	      const fetchImage = async () => {
	        $this.closest(".item").find(".loading-wrapper").addClass("active");
	        const res = await fetch(imageUrl);
	        return res;
	      };

	      const imageFetching = fetchImage();
	      imageFetching.then(() => $this.closest(".item").find(".loading-wrapper").removeClass("active"));
	    });
	  },
	  init: () => {
	    homeTemplate.toggleServices();
	  }
	};

	function aosAnimation() {
	  Aos.init({
	    disable: "mobile",
	    duration: 1000,
	    offset: height_header,
	    delay: 150,
	    once: true
	  });
	  Aos.refresh();
	  $(window).scroll(function () {
	    Aos.refreshHard();
	  });
	}

	function activeCommonNav() {
	  if ($("[data-toggle='tabslet']").length) {
	    $("[data-toggle='tabslet'] ul").scrollTo("li.active", 300);
	  }
	}

	function tabsletSetting() {
	  if ($("[data-toggle]").length && $("[data-slide-active]").length) $(".tabslet-tab a").on("click", function () {
	    setTimeout(() => {
	      activeCommonNav();
	    }, 300);
	  });
	}

	const observer = lozad(".lozad", {
	  rootMargin: "10px 0px",
	  // syntax similar to that of CSS Margin
	  threshold: 0.2,
	  // ratio of element convergence
	  enableAutoReload: true,
	  // it will reload the new image when validating attributes changes
	  loaded: function (el) {
	    globalJS.autoFillNoImage(el);
	  }
	});
	function lozadInit() {
	  observer.observe();
	}

	function checkBanner() {
	  var mainBanner = $("#main-banner");
	  var pageBanner = $("#page-banner");
	  console.log(mainBanner.length == 0);

	  if (mainBanner.length || pageBanner.length) ; else {
	    $("header").addClass("no-banner-detect");
	    $("main").addClass("no-banner-detect");
	  }
	}

	function fixedTool() {
	  $(document).on("click", function (e) {
	    if ($(e.target).closest("#fixed-tool").length > 0) {
	      $("#fixed-tool").addClass("active");
	    } else {
	      $("#fixed-tool").removeClass("active");
	    }
	  });
	}

	$(document).ready(function () {
	  aosAnimation(); // ---***--- Global JS ---***---

	  globalJS.init(); // ---***--- Header ---***---

	  headerFunction.init(); // ---***--- Swiper Init ---***---

	  swiperInit();
	  swiperVideo(true, false); // ---***--- Body ---***---

	  tabsletSetting();
	  counterUpNumber(); // Template Page

	  homeTemplate.init(); // ---***--- Fancybox ---***---

	  fancyboxCustom(); // ---***--- Other ---***---

	  youtubeCustom();
	  toggleFaqsAskModule();
	  customScrollBar(); // Lazyload

	  lozadInit();
	  checkBanner();
	  fixedTool();
	});
	$(window).resize(function () {
	  height_header = header.outerHeight();
	  $("html").css({
	    "--header-height": height_header + "px"
	  });
	});
	$(window).trigger("resize"); // ***** Preload ***** //

	document.onreadystatechange = () => {
	  if (document.readyState === "complete") {
	    /**
	     * Turn on when Deploy
	     */
	    pagesBanner.addClass("initial"); //
	    //

	    height_header = header.outerHeight();
	    $("html").css({
	      "--header-height": height_header + "px"
	    }); //
	    //
	    // Load to section

	    if (window.location.href.indexOf("#") != -1) {
	      onLoadToSection();
	    }
	  }
	};

	window.externalJS = {
	  useVariables
	};

	exports.footer = footer;
	exports.header = header;
	exports.lozadInit = lozadInit;
	exports.ww = ww;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
